import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources: {
            translation: {
            },
            sv: {
                translation: {
                },
                metrics: {
                    "tonnes": " ton",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "stycken"
                },
                seo: {
                    startpage: {
                        "titel": "Rototilt Produktguide - Matcha med din grävmaskin",
                        "text": "Välkommen till Rototilts produktguide. Här kan du enkelt hitta och matcha produkter från Rototilt mot din specifika grävmaskinsmodell.",
                        "keywords": "rototilt produktguide, rototilt produktkonfigurator",
                    }
                },
                marketstep: {
                    markets: {
                        "market": "Välj marknad",
                        "change": "ändra",
                        "sv-SE": "Sverige",
                        "da-DK": "Danmark",
                        "en-GB": "Storbritannien",
                        "fi-FI": "Finland",
                        "fr-FR": "Frankrike",
                        "de-DE": "Tyskland",
                        "nb-NO": "Norge",
                        "en-US": "USA",
                        "en-CA": "Kanada (Engelska)",
                        "fr-CA": "Kanada (Franska)",
                        "en": "Global",
                        "pl-PL": "Polen",
                        "nl-NL": "Nederländerna",
                        "es-ES": "Spanien",
                        "en-AU": "Australien",
                        "en-NZ": "Nya Zeeland",
                        "ja-JP": "Japan",
                        "ko-KR": "Sydkorea",
                        "nl-BE": "Belgien (Nederländska)",
                        "fr-BE": "Belgien (Franska)",
                    },
                    markettexts: {
                        "marketheader": "Välkommen till Rototilts produktguide",
                        "marketintro": "Här kan du enkelt matcha produkter från Rototilt mot en specifik grävmaskinsmodell. Genom att ange din maskinmodell eller maskinvikt kan du välja bland rekommenderade produkter och bygga ett eget tiltrotatorsystem. Börja med att välja din marknad.",
                        "chosemarketheader": "Välj din marknad",
                        "choosebetween": "Välj bland",
                        "markets": "Marknader",
                        "marketnotfound": "Om du inte kan hitta din marknad, välj ”Global”.",
                        "searchmarket": "Sök bland våra marknader",
                        "choosemarket": "Välj marknad",
                    },
                },
                machinetonnagestep: {
                    machinetonnagetexts: {
                        "machinetonnageheader": "Maskin och vikt",
                        "machinetonnageintro": "För att få bästa möjliga produktrekommendationer för din maskin, välj grävmaskinsmodell eller ange maskinens vikt.",
                        "findmachine": "Hitta din maskin",
                        "findmachinetext1":"Välj maskinmodell för att få produktrekommendationer för din grävmaskin.",
                        "findmachinetext2":"Välj maskinmodell för att få produktrekommendationer för din grävmaskin. Om du inte kan hitta din modell, växla till maskinvikt.",
                        "searchplaceholder": "Sök märke och modell",
                        "switchtotonnage": "Växla till maskinvikt",
                        "picktonnage": "Ange din maskinvikt",
                        "picktonnagetext1":"Ange vikt för att få produktrekommendationer som passar din grävmaskin.",
                        "picktonnagetext2":"Ange vikt för att få produktrekommendationer som passar din grävmaskin. Du kan även växla till maskinmodell. ",
                        "choosetonnage": "Ange din maskinvikt",
                        "tonnagehelpertext":"Du kan ge en ungefärlig uppskattning.",
                        "switchtomachine":"Växla till maskinmodell",
                        "loadingMessage": "Vi söker efter din maskin...",
                        "noOptionsMessage": "Sök efter din maskin...",
                    },                
                },
                productstep: {
                    producttexts: {
                        "productheading": "Produkter",
                        "productintro": "Vilka produkter är du intresserad av? Välj en produktkategori till att börja med. Du har möjlighet att addera fler produkter och ändra dina val senare.",
                        "chooseproductcategory": "Välj produktkategori",
                    },
                },
                tiltrotator: {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotatorer",
                    "choosetiltrotator": "Välj tiltrotator",
                    "recomended": "Rekommenderas",
                    "breakforcemax": "Brytkraft, max",
                    "bucketwidthmax": "Skopbredd, max",
                },
                machinefixings: {
                    "weight": "Vikt",
                    "recommended": "rekommenderas",
                    "readmore": "Läs mer",
                    "machinefixing": "Maskinfästen",
                    "choosemachinefixing": "Välj maskinfäste",
                    "attachment":"Infästning",
                    "chooseattachment": "Välj infästning",
                    "continuewithout": "Fortsätt utan maskinfäste",
                    "choosedirectmount": "Välj direktinfästning",
                    "choosesfixing": "Välj S-fäste",
                    "chooseqcfixing": "Välj QuickChange™-fäste",
                    "nomachinefixing": "Fortsätt utan att välja maskinfäste",
                    sfixing: {
                    "sfixing": "S-fäste",
                    "weightfrom": "Vikt, från",
                    "maxallowedloadlifthook": "Tillåten maxlast lyftkrok",
                    "infotext": "Ett kraftfullt och robust standardfäste med kompakt design. Gör det möjligt att koppla av tiltrotatorn vid tyngre arbeten, till exempel vid användning av hydraulhammare. Dessa fästen är baserade på den gemensamma S-standarden.",
                    },
                    qcfixing: {
                        "qcfixing": "QuickChange™-fäste",
                        "weightfrom": "Vikt, från",
                        "maxallowedloadlifthook": "Tillåten maxlast lyftkrok",
                        "numberofcouplers":"Antal kopplingar, max",
                        "infotext": "QuickChange™ är Rototilts helautomatiska snabbfästessystem. Det är ett smart tillägg som möjliggör automatiska byten av hydrauliska redskap utan att du behöver lämna grävmaskinens hytt."
                    },
                    directmount: {
                        "directmount": "Direktinfästning",
                        "infotext": "En direktinfästning innebär att tiltrotatorn fästes direkt på grävmaskinen. Det är den lättaste och mest kompakta lösningen som passar för applikationer där tiltrotatorn aldrig behöver kopplas av."
                    },
                    toolattachment: {
                        "choosetoolattachment": "Välj redskapsfäste",
                        "toolattachment": "Redskapsfäste"
                    },
                },
                tools: {
                    "categories": "kategorier",
                    "readmore": "Läs mer",
                    "tools": "Redskap",
                    "choosetools": "Välj redskap",
                    "ourtools": "Våra redskap",
                    "disclamertools": "Redskapen nedan är en generell rekommendation. Rådgör med din återförsäljare för exakt anpassning mot din maskinmodell.",
                    "number of results": "resultat för din grävmaskin",
                    "results": "Resultat",
                    "buckets": "Skopor",
                    "choise": "Variant",
                    "choises": "Varianter",
                    "weight": "Vikt",
                    bucket: {
                        "bucket": "Skopa",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredd",
                        "volume": "Volym",
                    },
                    excavationbucket: {
                        "excavationbucket": "Grävskopa",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredd",
                        "volume": "Volym",
                        "toothtype": "Tandtyp"
                    },
                    trenchingbucket: {
                        "trenchingbucket": "Kabelskopa",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredd",
                        "volume": "Volym",
                    },
                    sortingbucket: {
                        "sortingbucket": "Sorteringsskopa",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredd",
                        "volume": "Volym",
                    },
                    gradingbucket: {
                        "gradingbucket": "Planeringsskopa",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredd",
                        "volume": "Volym",
                    },
                    grapplemodule: {
                        "doyouwantgrapple": "Vill du lägga till en gripmodul?",
                        "continuewithout": "Fortsätt utan gripmodul",
                        "grapplemodule": "Gripmodul",
                        "weight": "Vikt",
                        "liftingcapacitymax": "Lyftkapacitet, max"
                    },
                    railroadgrapple: {
                        "railroadgrapple": "Järnvägsgrip",
                        "weight": "Vikt",
                        "liftingcapacitymax": "Lyftkapacitet, max"
                    },
                    grapple: {
                        "grapple": "Gripar",
                        "grappleforcemax": "Gripkraft, max",
                        "grapplewidthmax": "Gripvidd, max"
                    },
                    grappletypes: {
                        "multigrapple": "multigrip",
                        "stonegrapple":"stengrip",
                        "sortinggrapple": "sorteringsgrip"
                    },
                    compactor: {
                        "compactor": "Markvibrator",
                        "weight": "Vikt",
                        "vibrationforce": "Vibrationskraft",
                    },
                    gradingbeam: {
                        "gradingbeam": "Avjämningsbalk",
                        "weight": "Vikt",
                        "width": "Bredd"
                    },
                    ripper: {
                        "ripper": "Rivtand",
                        "weight": "Vikt",
                        "toothradius": "Tandradie",
                    },
                    asphaltcutter: {
                        "asphaltcutter": "Asfaltsskärare",
                        "weight": "Vikt",
                        "cutdepth": "Skärdjup"
                    },
                    toolmount: {
                        "toolmount": "Redskapsinfästning"
                    }
                },
                optionalstep: {
                    "yourmachine": "din maskinmodell",
                    "yourmachineweight": "din maskinvikt",
                    "optionalstep": "Tillval",
                    "introweight": "Vill du lägga till fler produkter som matchar ",
                    "intromachine": "Vill du lägga till fler produkter som matchar ",
                    "introaftervalue":"Utforska vårt utbud eller gå vidare till nästa steg.",
                },
                yourchoises: {
                    "yourchoises": "Dina val",
                    "yourchoisesintro": "Fyll i dina uppgifter och granska dina val. När du är klar skickas din sammanställning till en representant från Rototilt som kommer att kontakta dig inom kort.",
                    "yourinformation": "Fyll i dina uppgifter",
                   "viewretailers": "Se återförsäljare",
                    "reviewchoises": "Granska dina val",
                    "products": "produkter"

                },
                contactusform: {
                    "firstname": "Förnamn",
                    "firstnamemandatory": "Fyll i ditt förnamn",
                    "firstnameinvalid": "Ange endast bokstäver",
                    "lastname": "Efternamn",
                    "lastnamemandatory": "Fyll i ditt efternamn",
                    "lastnameinvalid": "Ange endast bokstäver",
                    "email": "E-postadress",
                    "emailmandatory": "Fyll i din e-postadress",
                    "emailinvalid": "Ogiltig e-postadress",
                    "phone": "Telefonnummer",
                    "phonemandatory": "Fyll i ditt telefonnummer",
                    "phoneinvalid": "Ogiltigt telefonnummer",
                    "locationinvalid": "Ange endast bokstäver",
                    "city": "Ort",
                    "zip": "Zip",
                    "country:": "Land",
                    "countrymandatory:": "Fyll i ditt land",
                    "message": "Lägg till meddelande (valfritt)",
                    "contactus": "Skicka", 
                    "checkboxintegrity": "Jag godkänner att Rototilt Group AB får behandla mina personuppgifter, enligt sin ",
                    "checkboxintegritylink": "personuppgiftspolicy.",
                    "checkboxnews": "Jag vill ta emot nyheter och erbjudanden från Rototilt.",
                    share: {
                        share: "Dela",
                        close: "Stäng",
                        copylink: "Kopiera länk",
                        info: "Använd den här länken för att dela eller spara din konfiguration",
                        linkcopied: "Länken är kopierad",
                    }
                },
                endpage: {
                    "welldone": "Bra jobbat!",
                    "endpageinfo": "En representant från Rototilt kommer att kontakta dig inom kort. En bekräftelse med en länk till dina val har skickats till din e-post.",
                    "gotoweb": "Klicka här för att komma till vår hemsida"
                },
                disclamer: {
                    "disclamertext": "Vi reserverar oss för eventuella tryckfel eller felskrivningar och eventuella fel som kan inträffa samt förbehåller rätten att ändra specifikationer utan föregående meddelande. Variationer i produktprogram och utrustningsstandarder kan uppstå mellan olika marknader. För mer information om aktuella produktspecifikationer, lokala anpassningar och specialutrustning kontaktar du din närmaste Rototilt-återförsäljare.",
                },
                url: {
                   "productguide": "produktguiden",
                   "machinetonnage": "maskin-vikt",
                   "product": "produkt",
                   "optional": "tillval",
                   "contactus": "kontakta-oss",
                   "thankyou": "tack" 
                },
                wizard: {
                    "marketstep": "Start",
                    "machinetonnagestep": "Maskin och vikt",
                    "productstep": "Produkter",
                    "otheroptionsstep": "Tillval",
                    "contactusstep": "Dina val"
                },
                cart: {
                    yourproducts: "Dina produkter",
                },
                footer: {
                    "previous": "Föregående",
                    "next": "Nästa"
                },
                topbar: {
                    "products": "Produkter"
                },
                popup: {
                    "areyousure": "Om du ändrar kommer dina val att rensas. Är du säker på att du vill fortsätta?",
                    "important": "Viktigt!",
                    "clearchoises": "Rensa mina val",
                    "stay": "Stanna på sidan",
                    "cancel": "Avbryt"
                },
                thankyoumail: {
                    "subject": "Ämne: Tack för att du kontaktat oss",
                    "hello": "Hej",
                    "intro": "Vi har tagit emot dina val i Rototilts produktguide. En representant från Rototilt kommer att kontakta dig inom kort. Tills vidare kan du klicka på länken nedan för att se en sammanställning av dina val.",
                    "summary": "Din sammanställning",
                    "signature": "Med vänliga hälsningar",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Läs mer på www.rototilt.com"
                }
            },
            "da-DK": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " ton",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "stk."
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt-produktguide – match med din gravemaskine",
                        "text": "Velkommen til Rototilts produktguide. Her kan du nemt finde og matche produkter fra Rototilt med din specifikke gravemaskinemodel.",
                        "keywords": "rototilt-produktguide, rototilt-produktkonfigurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Vælg marked",
                        "change": "skift",
                        "sv-SE": "Sverige",
                        "da-DK": "Danmark",
                        "en-GB": "Storbritannien",
                        "fi-FI": "Finland",
                        "fr-FR": "Frankrig",
                        "de-DE": "Tyskland",
                        "nb-NO": "Norge",
                        "fr-CA": "Canada (fransk)",
                        "en": "Global",
                        "pl-PL": "Polen",
                        "nl-NL": "Holland",
                        "es-ES": "Spanien",
                        "en-AU": "Australien",
                        "ja-JP": "Japan",
                        "ko-KR": "Sydkorea",
                        "en-US": "USA",
                        "en-CA": "Canada (engelsk)",   
                        "en-NZ": "New Zealand",	
                    },
                    "markettexts": {
                        "marketheader": "Velkommen til Rototilts produktguide",
                        "marketintro": "Her kan du nemt matche produkter fra Rototilt med en bestemt gravemaskinemodel. Ved at angive din maskinmodel eller maskinvægt kan du vælge mellem anbefalede produkter og bygge dit eget tiltrotatorsystem. Start med at vælge dit marked.",
                        "chosemarketheader": "Vælg dit marked",
                        "choosebetween": "Vælg mellem",
                        "markets": "Markeder",
                        "marketnotfound": "Hvis du ikke kan finde dit marked, skal du vælge \"Global\".",
                        "searchmarket": "Søg i vores markeder",
                        "choosemarket": "Vælg marked"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Maskine og vægt",
                        "machinetonnageintro": "For at få de bedst mulige produktanbefalinger til din maskine skal du vælge gravemaskinemodellen eller angive maskinens vægt.",
                        "findmachine": "Find din maskine",
                        "findmachinetext1":"Vælg maskinmodellen for at få produktanbefalinger til din gravemaskine.",
                        "findmachinetext2":"Vælg maskinmodellen for at få produktanbefalinger til din gravemaskine. Hvis du ikke kan finde din model, skal du skifte til maskinvægt.",
                        "searchplaceholder": "Søg efter mærke og model",
                        "switchtotonnage": "Skift til maskinvægt",
                        "picktonnage": "Angiv din maskinvægt",
                        "picktonnagetext1":"Angiv vægt for at få produktanbefalinger, der passer til din gravemaskine.",
                        "picktonnagetext2":"Angiv vægt for at få produktanbefalinger, der passer til din gravemaskine. Du kan også skifte til maskinmodel. ",
                        "choosetonnage": "Angiv din maskinvægt",
                        "tonnagehelpertext":"Du kan angive et omtrentligt skøn.",
                        "switchtomachine":"Skift til maskinmodel",
                        "loadingMessage": "Vi søger efter din maskine...",
                        "noOptionsMessage": "Søg efter din maskine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produkter",
                        "productintro": "Hvilke produkter er du interesseret i? Vælg en produktkategori, som du vil begynde med. Du har mulighed for at tilføje flere produkter og ændre dine valg senere.",
                        "chooseproductcategory": "Vælg produktkategori"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotatorer",
                    "choosetiltrotator": "Vælg tiltrotator",
                    "recomended": "Anbefales",
                    "breakforcemax": "Brydekraft, maks.",
                    "bucketwidthmax": "Skovlbredde, maks."
                },
                "machinefixings": {
                    "weight": "Vægt",
                    "recommended": "anbefales",
                    "readmore": "Læs mere",
                    "machinefixing": "Hurtigskifte",
                    "choosemachinefixing": "Vælg hurtigskifte",
                    "attachment":"Tilkoblingsramme",
                    "chooseattachment": "Vælg tilkoblingsramme",
                    "continuewithout": "Fortsæt uden hurtigskifte",
                    "choosedirectmount": "Vælg direkte fastgørelse",
                    "choosesfixing": "Vælg S-fæste",
                    "chooseqcfixing": "Vælg QuickChange™-fæste",
                    "nomachinefixing": "Fortsæt uden at vælge hurtigskifte",
                    "sfixing": {
                    "sfixing": "S-fæste",
                    "weightfrom": "Vægt, fra",
                    "maxallowedloadlifthook": "Tilladt maks. last, løftekrog",
                    "infotext": "Et kraftfuldt og robust standardfæste med et kompakt design. Gør det muligt at frakoble tiltrotatoren ved tungere arbejde, f.eks. ved brug af hydraulikhammer. Disse fæster er baseret på den fælles S-standard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™-fæste",
                        "weightfrom": "Vægt, fra",
                        "maxallowedloadlifthook": "Tilladt maks. last, løftekrog",
                        "numberofcouplers":"Antal koblinger, maks.",
                        "infotext": "QuickChange™ er Rototilts automatiske koblingssystem. Det er en smart tilføjelse, der gør det muligt at skifte hydraulisk redskab, uden at du behøver at forlade gravemaskinens førerhus."
                    },
                    "directmount": {
                        "directmount": "Direkte fastgørelse",
                        "infotext": "En direkte fastgørelse betyder, at tiltrotatoren er fastgjort direkte på gravemaskinen. Det er den letteste og mest kompakte løsning, som er velegnet til anvendelser, hvor tiltrotatoren aldrig skal frakobles."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Vælg redskabsfæste",
                        "toolattachment": "Redskabsfæste"
                    }
                },
                "tools": {
                    "readmore": "Læs mere",
                    "tools": "Redskaber",
                    "categories": "kategorier",
                    "choosetools": "Vælg redskab",
                    "ourtools": "Vores redskaber",
                    "disclamertools": "Redskaberne nedenfor er en generel anbefaling. Kontakt din forhandler for at få en præcis tilpasning til din maskinmodel.",
                    "number of results": "resultat(er) for din gravemaskine",
                    "results": "Resultater",
                    "buckets": "Skovle",
                    "choise": "Variant",
                    "choises": "Varianter",
                    "weight": "Vægt",
                    "bucket": {
                        "bucket": "Skovl",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredde",
                        "volume": "Volumen"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Graveskovl",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredde",
                        "volume": "Volumen",
                        "toothtype": "Tandtype"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Lerskovl",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredde",
                        "volume": "Volumen"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Risteskovl",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredde",
                        "volume": "Volumen"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Universalskovl",
                        "articlenumber": "Artikelnummer",
                        "width": "Bredde",
                        "volume": "Volumen"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Vil du tilføje et grabmodul?",
                        "continuewithout": "Fortsæt uden grabmodul",
                        "grapplemodule": "Grabmodul",
                        "weight": "Vægt",
                        "liftingcapacitymax": "Løftekapacitet, maks."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Jernbanegrab",
                        "weight": "Vægt",
                        "liftingcapacitymax": "Løftekapacitet, maks."
                    },
                    "grapple": {
                        "grapple": "Grabber",
                        "grappleforcemax": "Gribekraft, maks.",
                        "grapplewidthmax": "Grabbredde, maks."
                    },
                    "grappletypes": {
                        "multigrapple": "multigrab",
                        "stonegrapple":"stengrab",
                        "sortinggrapple": "sorteringsgrab"
                    },
                    "compactor": {
                        "compactor": "Pladevibrator",
                        "weight": "Vægt",
                        "vibrationforce": "Vibrationskraft"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Afretningsbjælke",
                        "weight": "Vægt",
                        "width": "Bredde"
                    },
                    "ripper": {
                        "ripper": "Grubbetand",
                        "weight": "Vægt",
                        "toothradius": "Tandradius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asfaltskærer",
                        "weight": "Vægt",
                        "cutdepth": "Skæredybde"
                    },
                    "toolmount": {
                        "toolmount": "Redskabstilkobling"
                    }
                },
                "optionalstep": {
                    "yourmachine": "din maskinmodel",
                    "yourmachineweight": "din maskinvægt",
                    "optionalstep": "Ekstraudstyr",
                    "introweight": "Vil du tilføje flere produkter, der matcher ",
                    "intromachine": "Vil du tilføje flere produkter, der matcher ",
                    "introaftervalue":"Gennemse vores udvalg, eller gå videre til næste trin."
                },
                "yourchoises": {
                    "yourchoises": "Dine valg",
                    "yourchoisesintro": "Udfyld dine oplysninger, og gennemgå dine valg. Når du er færdig, vil dit resumé blive sendt til en repræsentant fra Rototilt, som snarest vil kontakte dig.",
                    "yourinformation": "Udfyld dine oplysninger",
                   "viewretailers": "Se forhandlere",
                    "reviewchoises": "Gennemgå dine valg",
                    "products": "produkter"

                },
                "contactusform": {
                    "firstname": "Fornavn",
                    "firstnamemandatory": "Angiv dit fornavn",
                    "firstnameinvalid": "Angiv kun bogstaver",
                    "lastname": "Efternavn",
                    "locationinvalid": "Angiv kun bogstaver",	
                    "lastnamemandatory": "Angiv dit efternavn",
                    "lastnameinvalid": "Angiv kun bogstaver",
                    "email": "E-mailadresse",
                    "emailmandatory": "Angiv din e-mailadresse",
                    "emailinvalid": "Ugyldig e-mailadresse",
                    "phone": "Telefonnummer",
                    "phonemandatory": "Angiv dit telefonnummer",
                    "phoneinvalid": "Ugyldigt telefonnummer",
                    "city": "By",
                    "zip": "Postnummer",
                    "country:": "Land",
                    "countrymandatory:": "Angiv dit land",
                    "message": "Tilføj meddelelse (valgfrit)",
                    "contactus": "Send", 
                    "checkboxintegrity": "Jeg godkender, at Rototilt Group AB kan behandle mine personoplysninger i henhold til sin ",
                    "checkboxintegritylink": "databeskyttelsespolitik.",	
                    "checkboxnews": "Jeg vil gerne modtage nyheder og tilbud fra Rototilt.",
                    "share": {
                        "share": "Del",
                        "close": "Luk",
                        "copylink": "Kopiér link",
                        "info": "Brug dette link til at dele eller gemme din konfiguration"
                    }
                },
                "endpage": {
                    "welldone": "Godt arbejde!",
                    "gotoweb": "Klik her for at gå til vores hjemmeside",	
                    "endpageinfo": "En repræsentant fra Rototilt vil kontakte dig snarest. En bekræftelse med et link til dine valg er blevet sendt til din e-mail."
                },
                "disclamer": {
                    "disclamertext": "Med forbehold for trykfejl eller typografiske fejl og eventuelle fejl, der måtte opstå, og vi forbeholder os ret til uden varsel at ændre specifikationer. Variationer i produktsortiment og udstyrsstandarder kan forekomme mellem forskellige markeder. Kontakt din nærmeste Rototilt-forhandler for at få flere oplysninger om aktuelle produktspecifikationer, lokale tilpasninger og specialudstyr."
                },
                "url": {
                   "productguide": "produktguiden",
                   "machinetonnage": "maskinens vægt",
                   "product": "produkt",
                   "optional": "ekstraudstyr",
                   "contactus": "kontakt-os",
                   "thankyou": "tak" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Maskine og vægt",
                    "productstep": "Produkter",
                    "otheroptionsstep": "Ekstraudstyr",
                    "contactusstep": "Dine valg"
                },
                "cart": {
                    "yourproducts": "Dine produkter"
                },
                "footer": {
                    "previous": "Forrige",
                    "next": "Næste"
                },
                "topbar": {
                    "products": "Produkter"
                },
                "popup": {
                    "areyousure": "Hvis du ændrer noget, vil dine valg blive ryddet. Er du sikker på, at du vil fortsætte?",
                    "important": "Vigtigt!",
                    "clearchoises": "Ryd mine valg",
                    "stay": "Bliv på siden",
                    "cancel": "Annuller"
                },
                "thankyoumail": {
                    "subject": "Emne: Tak, fordi at du har kontaktet os",
                    "hello": "Hej",
                    "intro": "Vi har modtaget dine valg i Rototilts produktguide. En repræsentant fra Rototilt vil snarest kontakte dig. Indtil videre kan du klikke på linket nedenfor for at få vist en oversigt over dine valg.",
                    "summary": "Dit resumé",
                    "signature": "Med venlig hilsen",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Læs mere på www.rototilt.com"
                }
            },
            "de-DE": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " t",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "Mal"
                },
                seo: {
                    startpage: {
                        "titel": "Rototilt Produktleitfaden – Individuelle Abstimmung auf Ihren Bagger",
                        "text": "Willkommen zu Rototilts Produktleitfaden. Hier können Sie ganz einfach die passenden Rototilt-Produkte zu Ihrem speziellen Baggermodell finden.",
                        "keywords": "Rototilt Produktleitfaden, Rototilt Produktkonfigurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Markt wählen",
                        "change": "ändern",
                        "sv-SE": "Schweden",
                        "da-DK": "Dänemark",
                        "en-GB": "Großbritannien",
                        "fi-FI": "Finnland",
                        "fr-FR": "Frankreich",
                        "de-DE": "Deutschland",
                        "nb-NO": "Norwegen",
                        "fr-CA": "Kanada (Französisch)",
                        "en": "Global",
                        "pl-PL": "Polen",
                        "nl-NL": "Niederlande",
                        "es-ES": "Spanien",
                        "en-AU": "Australien",
                        "ja-JP": "Japan",
                        "en-US": "USA",
                        "en-CA": "Kanada (Englisch)",   
                        "en-NZ": "Neuseeland",	
                        "ko-KR": "Südkorea"
                    },
                    "markettexts": {
                        "marketheader": "Willkommen zu Rototilts Produktleitfaden",
                        "marketintro": "Hier können ganz einfach die passenden Rototilt-Produkte zu einem bestimmten Baggermodell finden.Geben Sie das Baggermodell oder dessen Gewichtsklasse an, und schon bekommen Sie Produkte empfohlen, anhand derer Sie Ihr eigenes Schwenkrotatorsystem zusammenstellen können.Wählen Sie zunächst Ihren Markt aus.",
                        "chosemarketheader": "Markt wählen",
                        "choosebetween": "Zur Auswahl stehen",
                        "markets": "Märkte",
                        "marketnotfound": "Sollten Sie Ihren Markt nicht finden können, wählen Sie bitte „Global“.",
                        "searchmarket": "Sehen Sie sich unsere Märkte an",
                        "choosemarket": "Markt wählen"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Bagger und Gewicht",
                        "machinetonnageintro": "Um die optimalen Produktempfehlungen zu Ihrem Bagger zu erhalten, wählen Sie bitte das Baggermodell oder geben Sie dessen Gewicht ein.",
                        "findmachine": "Bagger finden",
                        "findmachinetext1":"Wählen Sie das Baggermodell aus, um Produktempfehlungen dazu zu erhalten.",
                        "findmachinetext2":"Wählen Sie das Baggermodell aus, um Produktempfehlungen dazu zu erhalten.Sollten Sie Ihr Modell nicht finden können, wechseln Sie einfach zum Baggergewicht.",
                        "searchplaceholder": "Nach Marke und Modell suchen",
                        "switchtotonnage": "Zum Baggergewicht wechseln",
                        "picktonnage": "Baggergewicht eingeben",
                        "picktonnagetext1":"Geben Sie das Gewicht Ihres Baggers an, um Produktempfehlungen dazu zu erhalten.",
                        "picktonnagetext2":"Geben Sie das Gewicht Ihres Baggers an, um Produktempfehlungen dazu zu erhalten.Sie können auch zum Baggermodell wechseln. ",
                        "choosetonnage": "Baggergewicht eingeben",
                        "tonnagehelpertext":"Geben Sie das geschätzte Gewicht ein.",
                        "switchtomachine":"Zum Baggermodell wechseln",
                        "loadingMessage": "Wir suchen nach Ihrem Bagger...",
                        "noOptionsMessage": "Die Suche nach Ihrem Bagger läuft..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produkte",
                        "productintro": "Für welche Produkte interessieren Sie sich? Wählen Sie zunächst eine Produktkategorie aus. Sie können später noch weitere Produkte hinzufügen oder Ihre Auswahl ändern.",
                        "chooseproductcategory": "Produktkategorie wählen"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Schwenkrotator",
                    "tiltrotators": "Schwenkrotatoren",
                    "choosetiltrotator": "Schwenkrotator wählen",
                    "recomended": "Empfehlung",
                    "breakforcemax": "Losbrechkraft, max.",
                    "bucketwidthmax": "Löffelbreite, max."
                },
                "machinefixings": {
                    "weight": "Gewicht",
                    "recommended": "Empfehlung",
                    "readmore": "Mehr erfahren",
                    "machinefixing": "Baggerschnellwechsler",
                    "choosemachinefixing": "Baggerschnellwechsler wählen",
                    "attachment":"Aufnahme",
                    "chooseattachment": "Aufnahme wählen",
                    "continuewithout": "Ohne Baggerschnellwechsler fortfahren",
                    "choosedirectmount": "Direktaufnahme wählen",
                    "choosesfixing": "Schnellwechsler S wählen",
                    "chooseqcfixing": "Schnellwechsler QuickChange™ wählen",
                    "nomachinefixing": "Ohne die Wahl eines Baggerschnellwechslers fortfahren",
                    "sfixing": {
                    "sfixing": "Schnellwechsler S",
                    "weightfrom": "Gewicht, ab",
                    "maxallowedloadlifthook": "Zulässige Höchstlast, Lasthaken",
                    "infotext": "Ein leistungsstarker und robuster Standardschnellwechsler mit kompaktem Design. Ermöglicht das Abkoppeln des Schwenkrotators bei schwereren Arbeiten, z. B. um einen Hydraulikhammer einzusetzen.Diese Schnellwechsler basieren auf dem gängigen S-Standard."
                    },
                    "qcfixing": {
                        "qcfixing": "Schnellwechsler QuickChange™",
                        "weightfrom": "Gewicht, ab",
                        "maxallowedloadlifthook": "Zulässige Höchstlast, Lasthaken",
                        "numberofcouplers":"Anzahl Anschlüsse, max.",
                        "infotext": "QuickChange™ ist das vollhydraulische Schnellwechselsystem von Rototilt.Diese durchdachte Option ermöglicht das automatische Wechseln von hydraulischen Anbaugeräten, bei denen der Baggerfahrer nicht einmal die Kabine zu verlassen braucht."
                    },
                    "directmount": {
                        "directmount": "Direktaufnahme",
                        "infotext": "Bei der Direktaufnahme wird der Schwenkrotator direkt am Bagger befestigt. Sie ist die leichteste und kompakteste Lösung für Anwendungen, bei denen der Schwenkrotator nie abgekoppelt werden muss."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Schnellwechsler wählen",
                        "toolattachment": "Schnellwechsler"
                    }
                },
                "tools": {
                    "readmore": "Mehr erfahren",
                    "tools": "Anbaugerät",
                    "choosetools": "Anbaugerät wählen",
                    "ourtools": "Unsere Anbaugeräte",
                    "categories": "Kategorien",
                    "disclamertools": "Die folgenden Anbaugeräte sind allgemeine Empfehlungen. Ihr Händler berät Sie gern bei der genauen Abstimmung auf Ihr individuelles Baggermodell.",
                    "number of results": "Ergebnisse für Ihren Bagger",
                    "results": "Ergebnisse",
                    "buckets": "Löffel",
                    "choise": "Variante",
                    "choises": "Varianten",
                    "weight": "Gewicht",
                    "bucket": {
                        "bucket": "Löffel",
                        "articlenumber": "Artikelnummer",
                        "width": "Breite",
                        "volume": "Volumen"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Baggerlöffel",
                        "articlenumber": "Artikelnummer",
                        "width": "Breite",
                        "volume": "Volumen",
                        "toothtype": "Zahntyp"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Schmaler Löffel",
                        "articlenumber": "Artikelnummer",
                        "width": "Breite",
                        "volume": "Volumen"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sieblöffel",
                        "articlenumber": "Artikelnummer",
                        "width": "Breite",
                        "volume": "Volumen"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Planierlöffel",
                        "articlenumber": "Artikelnummer",
                        "width": "Breite",
                        "volume": "Volumen"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Soll ein Greifmodul hinzugefügt werden?",
                        "continuewithout": "Ohne Greifmodul fortfahren",
                        "grapplemodule": "Greifmodul",
                        "weight": "Gewicht",
                        "liftingcapacitymax": "Hubkapazität, max."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Bahngreifer",
                        "weight": "Gewicht",
                        "liftingcapacitymax": "Hubkapazität, max."
                    },
                    "grapple": {
                        "grapple": "Greifer",
                        "grappleforcemax": "Schließkraft, max.",
                        "grapplewidthmax": "Greifweite, max."
                    },
                    "grappletypes": {
                        "multigrapple": "Multigreifer",
                        "stonegrapple":"Steingreifer",
                        "sortinggrapple": "Sortiergreifer"
                    },
                    "compactor": {
                        "compactor": "Rüttelplatte",
                        "weight": "Gewicht",
                        "vibrationforce": "Rüttelkraft"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Planierbalken",
                        "weight": "Gewicht",
                        "width": "Breite"
                    },
                    "ripper": {
                        "ripper": "Reißzahn",
                        "weight": "Gewicht",
                        "toothradius": "Zahnradius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asphaltschneider",
                        "weight": "Gewicht",
                        "cutdepth": "Schnitttiefe"
                    },
                    "toolmount": {
                        "toolmount": "Anbaugeräterahmen"
                    }
                },
                "optionalstep": {
                    "yourmachine": "Ihr Baggermodell",
                    "yourmachineweight": "Ihr Baggergewicht",
                    "optionalstep": "Optionen",
                    "introweight": "Sollen weitere passende Produkte hinzugefügt werden? ",
                    "intromachine": "Sollen weitere passende Produkte hinzugefügt werden? ",
                    "introaftervalue":"Durchstöbern Sie unser Sortiment oder fahren Sie mit dem nächsten Schritt fort."
                },
                "yourchoises": {
                    "yourchoises": "Ihre gewählte Kombination",
                    "yourchoisesintro": "Geben Sie Ihre Daten ein und prüfen Sie Ihre Auswahl.Anschließend wird Ihre gewählte Kombination an eine Ansprechperson bei Rototilt gesendet, die sich in Kürze mit Ihnen in Verbindung setzt.",
                    "yourinformation": "Geben Sie Ihre Daten ein",
                   "viewretailers": "Siehe Händler",
                    "reviewchoises": "Prüfen Sie Ihre Auswahl",
                    "products": "Produkte"

                },
                "contactusform": {
                    "firstname": "Vorname",
                    "firstnamemandatory": "Geben Sie Ihren Vornamen ein",
                    "firstnameinvalid": "Verwenden Sie ausschließlich Buchstaben",
                    "locationinvalid": "Verwenden Sie ausschließlich Buchstaben",		
                    "lastname": "Nachname",
                    "lastnamemandatory": "Geben Sie Ihren Nachnamen ein",
                    "lastnameinvalid": "Verwenden Sie ausschließlich Buchstaben",
                    "email": "E-Mail-Adresse",
                    "emailmandatory": "Geben Sie Ihre E-Mail-Adresse ein",
                    "emailinvalid": "Ungültige E-Mail-Adresse",
                    "phone": "Telefonnummer",
                    "phonemandatory": "Geben Sie Ihre Telefonnummer ein",
                    "phoneinvalid": "Ungültige Telefonnummer",
                    "city": "Ort",
                    "zip": "PLZ",
                    "country:": "Land",
                    "countrymandatory:": "Geben Sie Ihr Land ein",
                    "message": "Fügen Sie eine Nachricht hinzu (optional)",
                    "contactus": "Senden", 
                    "checkboxintegrity": "Ich stimme zu, dass die Rototilt Group AB meine personenbezogenen Daten gemäß ihrer Datenschutzerklärung verarbeitet ",
                    "checkboxintegritylink": "Datenschutzerklärung.",	
                    "checkboxnews": "Ich möchte gern News und Angebote von Rototilt erhalten.",
                    "share": {
                        "share": "Teilen",
                        "close": "Schließen",
                        "copylink": "Link kopieren",
                        "info": "Verwenden Sie diesen Link, um Ihre Konfiguration weiterzuleiten oder zu speichern"
                    }
                },
                "endpage": {
                    "welldone": "Sehr gut!",
                    "gotoweb": "Durch einen Klick hier gelangen Sie zu unserer Website",	
                    "endpageinfo": "Eine Ansprechperson von Rototilt wird sich in Kürze mit Ihnen in Verbindung setzen. Es wurde eine Bestätigungs-E-Mail mit einem Link zu Ihrer gewünschten Kombination versendet."
                },
                "disclamer": {
                    "disclamertext": "Druckfehler, Schreibfehler und sonstige Irrtümer sowie Änderungen der technischen Spezifikationen ohne vorherige Ankündigung vorbehalten.Je nach Markt können Abweichungen beim Produktprogramm und bei den Ausrüstungsstandards auftreten.Für weitere Informationen zu aktuellen Produktspezifikationen, lokalen Anpassungen und Spezialausrüstung wenden Sie sich gern an den Rototilt-Händler in Ihrer Nähe."
                },
                "url": {
                   "productguide": "Produktleitfaden",
                   "machinetonnage": "Baggergewicht",
                   "product": "Produkt",
                   "optional": "Option",
                   "contactus": "Kontakt",
                   "thankyou": "Vielen Dank!" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Bagger und Gewicht",
                    "productstep": "Produkte",
                    "otheroptionsstep": "Optionen",
                    "contactusstep": "Ihre gewählte Kombination"
                },
                "cart": {
                    "yourproducts": "Ihre Produkte"
                },
                "footer": {
                    "previous": "Zurück",
                    "next": "Vor"
                },
                "topbar": {
                    "products": "Produkte"
                },
                "popup": {
                    "areyousure": "Bei Änderung gehen Ihre zuvor gewählten Optionen verloren.Möchten Sie trotzdem fortfahren?",
                    "important": "WICHTIG!",
                    "cancel": "Abbrechen",
                    "clearchoises": "Meine Auswahl löschen",
                    "stay": "Auf dieser Seite bleiben"
                },
                "thankyoumail": {
                    "subject": "Betreff: Vielen Dank für Ihre Kontaktaufnahme",
                    "hello": "Hallo",
                    "intro": "Ihre Auswahl aus dem Produktleitfaden von Rototilt ist bei uns eingegangen. In Kürze wird sich eine Ansprechperson von Rototilt mit Ihnen in Verbindung setzen. Bis dahin können Sie über den Link unten die von Ihnen ausgewählte Produktkombination abrufen.",
                    "summary": "Ihre Zusammenstellung",
                    "signature": "Mit freundlichen Grüßen",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Mehr unter www.rototilt.com"
                }
            },
            "en": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pcs"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt product guide - Match with your excavator",
                        "text": "Welcome to Rototilt’s product guide. Here you can easily find and match products from Rototilt with your specific excavator model.",
                        "keywords": "rototilt product guide, rototilt product configurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Select market",
                        "change": "change",
                        "sv-SE": "Sweden",
                        "da-DK": "Denmark",
                        "en-GB": "United Kingdom",
                        "fi-FI": "Finland",
                        "fr-FR": "France",
                        "de-DE": "Germany",
                        "nb-NO": "Norway",
                        "fr-CA": "Canada (French)",
                        "en": "Global",
                        "pl-PL": "Poland",
                        "nl-NL": "Netherlands",
                        "es-ES": "Spain",
                        "en-AU": "Australia",
                        "ja-JP": "Japan",
                        "ko-KR": "South Korea",
                        "en-US": "USA",
                        "en-CA": "Canada (English)",   
                        "en-NZ": "New Zealand",
                        "nl-BE": "Belgium (Dutch)",
                        "fr-BE": "Belgium (French)"
                    },
                    "markettexts": {
                        "marketheader": "Welcome to Rototilt’s product guide",
                        "marketintro": "Using our product guide will assist you in matching products from Rototilt with a specific excavator model. By specifying your machine model or machine weight, you can choose between recommended products and build your own tiltrotator system. Start by choosing your market.",
                        "chosemarketheader": "Choose your market",
                        "choosebetween": "Choose from",
                        "markets": "Markets",
                        "marketnotfound": "If you can’t find your market, select “Global”.",
                        "searchmarket": "Search among our markets",
                        "choosemarket": "Select market"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine and weight",
                        "machinetonnageintro": "To get the best possible product recommendations for your machine, select the excavator model or specify the weight of your machine.",
                        "findmachine": "Find your machine",
                        "findmachinetext1":"Select the machine model to get product recommendations for your excavator.",
                        "findmachinetext2":"Select the machine model to get product recommendations for your excavator. If you can’t find your model, switch to machine weight.",
                        "searchplaceholder": "Search make and model",
                        "switchtotonnage": "Switch to machine weight",
                        "picktonnage": "Enter your machine weight",
                        "picktonnagetext1":"Enter the weight to get product recommendations that match your excavator.",
                        "picktonnagetext2":"Enter the weight to get product recommendations that match your excavator. You can also switch to machine model. ",
                        "choosetonnage": "Enter your machine weight",
                        "tonnagehelpertext":"You can give a rough estimate.",
                        "switchtomachine":"Switch to machine model",
                        "loadingMessage": "We are looking for your machine...",
                        "noOptionsMessage": "Search for your machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Products",
                        "productintro": "What products are you interested in? Select a product category to begin with. You have the option of adding more products and changing your selections later.",
                        "chooseproductcategory": "Select product category"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotators",
                    "choosetiltrotator": "Select tiltrotator",
                    "recomended": "Recommended",
                    "breakforcemax": "Breakout force, max",
                    "bucketwidthmax": "Bucket width, max"
                },
                "machinefixings": {
                    "weight": "Weight",
                    "recommended": "recommended",
                    "readmore": "Read more",
                    "machinefixing": "Machine coupler",
                    "choosemachinefixing": "Select machine coupler",
                    "attachment":"Attachment frame",
                    "chooseattachment": "Select attachment frame",
                    "continuewithout": "Continue without machine coupler",
                    "choosedirectmount": "Select direct attachment",
                    "choosesfixing": "Select S-coupler",
                    "chooseqcfixing": "Select QuickChange™ coupler",
                    "nomachinefixing": "Continue without selecting machine coupler",
                    "sfixing": {
                    "sfixing": "S-coupler",
                    "weightfrom": "Weight, from",
                    "maxallowedloadlifthook": "Permitted max. load, lift hook",
                    "infotext": "A powerful and robust standard coupler with a compact design. Makes it possible to disconnect the tiltrotator during heavier jobs, for example when using hydraulic hammers. These couplers are based on the common S-standard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ coupler",
                        "weightfrom": "Weight, from",
                        "maxallowedloadlifthook": "Permitted max. load, lift hook",
                        "numberofcouplers":"Number of couplings, max",
                        "infotext": "QuickChange™ is Rototilt’s fully automatic quick coupler system. It is a smart addition that allows automatic changes of hydraulic work tools without you having to leave the excavator’s cab."
                    },
                    "directmount": {
                        "directmount": "Direct attachment",
                        "infotext": "A direct attachment means that the tiltrotator is attached directly to the excavator. It is the lightest and most compact solution, which is suitable for applications where the tiltrotator never needs to be disconnected."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Select quick coupler",
                        "toolattachment": "Quick coupler"
                    }
                },
                "tools": {
                    "readmore": "Read more",
                    "tools": "Work tools",
                    "categories": "categories",
                    "choosetools": "Select work tool",
                    "ourtools": "Our work tools",
                    "disclamertools": "The work tools below are a general recommendation. Consult with your dealer for precise adaptation to your machine model.",
                    "number of results": "results for your excavator",
                    "results": "Results",
                    "buckets": "Buckets",
                    "choise": "Variant",
                    "choises": "Variants",
                    "weight": "Weight",
                    "bucket": {
                        "bucket": "Bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Excavation bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume",
                        "toothtype": "Tooth type"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Trenching bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sorting bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Universal bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Do you want to add a grapple module?",
                        "continuewithout": "Continue without grapple module",
                        "grapplemodule": "Grapple module",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Railroad grapple",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "grapple": {
                        "grapple": "Grapples",
                        "grappleforcemax": "Grapple force, max",
                        "grapplewidthmax": "Grapple width, max"
                    },
                    "grappletypes": {
                        "multigrapple": "multi-grapple",
                        "stonegrapple":"stone grapple",
                        "sortinggrapple": "sorting grapple"
                    },
                    "compactor": {
                        "compactor": "Compactor",
                        "weight": "Weight",
                        "vibrationforce": "Vibration force"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Grading beam",
                        "weight": "Weight",
                        "width": "Width"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Weight",
                        "toothradius": "Tooth radius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asphalt cutter",
                        "weight": "Weight",
                        "cutdepth": "Cutting depth"
                    },
                    "toolmount": {
                        "toolmount": "Tool attachment frame"
                    }
                },
                "optionalstep": {
                    "yourmachine": "your machine model",
                    "yourmachineweight": "your machine weight",
                    "optionalstep": "Optional",
                    "introweight": "Do you want to add more products that match ",
                    "intromachine": "Do you want to add more products that match ",
                    "introaftervalue":"Explore our range or proceed to the next step."
                },
                "yourchoises": {
                    "yourchoises": "Your selections",
                    "yourchoisesintro": "Fill in your information and review your selections. When you have finished, your summary will be sent to a representative from Rototilt, who will contact you shortly.",
                    "yourinformation": "Fill in your information",
                   "viewretailers": "See dealers",
                    "reviewchoises": "Review your selections",
                    "products": "products"

                },
                "contactusform": {
                    "firstname": "First name",
                    "firstnamemandatory": "Enter your first name",
                    "firstnameinvalid": "Enter letters only",
                    "lastname": "Last name",
                    "locationinvalid": "Enter letters only",		
                    "lastnamemandatory": "Enter your last name",
                    "lastnameinvalid": "Enter letters only",
                    "email": "Email address",
                    "emailmandatory": "Enter your email address",
                    "emailinvalid": "Invalid email address",
                    "phone": "Phone number",
                    "phonemandatory": "Enter your phone number",
                    "phoneinvalid": "Invalid phone number",
                    "city": "City",
                    "zip": "Postcode",
                    "country:": "Country",
                    "countrymandatory:": "Enter your country",
                    "message": "Add message (optional)",
                    "contactus": "Send", 
                    "checkboxintegrity": "I approve Rototilt Group AB processing my personal data according to its ",
                    "checkboxintegritylink": "personal data policy.",	
                    "checkboxnews": "I would like to receive news and offers from Rototilt.",
                    "share": {
                        "share": "Share",
                        "close": "Close",
                        "copylink": "Copy link",
                        "info": "Use this link to share or save your configuration"
                    }
                },
                "endpage": {
                    "welldone": "Good job!",
                    "gotoweb": "Click here to visit our website",	
                    "endpageinfo": "A representative from Rototilt will contact you shortly. A confirmation with a link to your selections has been sent to your email."
                },
                "disclamer": {
                    "disclamertext": "We make reservation for any typographical errors or spelling mistakes and any errors that may occur, and reserve the right to change specifications without prior notification. Variations in product ranges and equipment standards may occur between different markets. For more information about current product specifications, local adaptations and special equipment, please contact your nearest Rototilt dealer."
                },
                "url": {
                   "productguide": "product guide",
                   "machinetonnage": "machine weight",
                   "product": "product",
                   "optional": "optional",
                   "contactus": "contact us",
                   "thankyou": "thank you" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine and weight",
                    "productstep": "Products",
                    "otheroptionsstep": "Optional",
                    "contactusstep": "Your selections"
                },
                "cart": {
                    "yourproducts": "Your products"
                },
                "footer": {
                    "previous": "Previous",
                    "next": "Next"
                },
                "topbar": {
                    "products": "Products"
                },
                "popup": {
                    "areyousure": "If you make changes, your selections will be cleared. Are you sure you want to continue?",
                    "important": "Important!",
                    "cancel": "Cancel",
                    "clearchoises": "Clear my selections",
                    "stay": "Stay on the page"
                },
                "thankyoumail": {
                    "subject": "Subject: Thank you for contacting us",
                    "hello": "Hello",
                    "intro": "We have received your selections in Rototilt’s product guide. A representative from Rototilt will contact you shortly. For the time being, you can click on the link below to see a summary of your selections.",
                    "summary": "Your compilation",
                    "signature": "Kind regards",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Read more at www.rototilt.com"
                }
            },
            "en-GB": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pcs"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt product guide - Match with your excavator",
                        "text": "Welcome to Rototilt’s product guide. Here you can easily find and match products from Rototilt with your specific excavator model.",
                        "keywords": "rototilt product guide, rototilt product configurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Select market",
                        "change": "change",
                        "sv-SE": "Sweden",
                        "da-DK": "Denmark",
                        "en-GB": "United Kingdom",
                        "fi-FI": "Finland",
                        "fr-FR": "France",
                        "de-DE": "Germany",
                        "nb-NO": "Norway",
                        "en-US": "USA",
                        "en-CA": "Canada (English)",   
                        "en-NZ": "New Zealand",	
                        "fr-CA": "Canada (French)",
                        "en": "Global",
                        "pl-PL": "Poland",
                        "nl-NL": "Netherlands",
                        "es-ES": "Spain",
                        "en-AU": "Australia",
                        "ja-JP": "Japan",
                        "ko-KR": "South Korea",
                        "nl-BE": "Belgium (Dutch)",
                        "fr-BE": "Belgium (French)"
                    },
                    "markettexts": {
                        "marketheader": "Welcome to Rototilt’s product guide",
                        "marketintro": "Using our product guide will assist you in matching products from Rototilt with a specific excavator model. By specifying your machine model or machine weight, you can choose between recommended products and build your own tiltrotator system. Start by choosing your market.",
                        "chosemarketheader": "Choose your market",
                        "choosebetween": "Choose from",
                        "markets": "Markets",
                        "marketnotfound": "If you can’t find your market, select “Global”.",
                        "searchmarket": "Search among our markets",
                        "choosemarket": "Select market"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine and weight",
                        "machinetonnageintro": "To get the best possible product recommendations for your machine, select the excavator model or specify the weight of your machine.",
                        "findmachine": "Find your machine",
                        "findmachinetext1":"Select the machine model to get product recommendations for your excavator.",
                        "findmachinetext2":"Select the machine model to get product recommendations for your excavator. If you can’t find your model, switch to machine weight.",
                        "searchplaceholder": "Search make and model",
                        "switchtotonnage": "Switch to machine weight",
                        "picktonnage": "Enter your machine weight",
                        "picktonnagetext1":"Enter the weight to get product recommendations that match your excavator.",
                        "picktonnagetext2":"Enter the weight to get product recommendations that match your excavator. You can also switch to machine model. ",
                        "choosetonnage": "Enter your machine weight",
                        "tonnagehelpertext":"You can give a rough estimate.",
                        "switchtomachine":"Switch to machine model",
                        "loadingMessage": "We are looking for your machine...",
                        "noOptionsMessage": "Search for your machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Products",
                        "productintro": "What products are you interested in? Select a product category to begin with. You have the option of adding more products and changing your selections later.",
                        "chooseproductcategory": "Select product category"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotators",
                    "choosetiltrotator": "Select tiltrotator",
                    "recomended": "Recommended",
                    "breakforcemax": "Breakout force, max",
                    "bucketwidthmax": "Bucket width, max"
                },
                "machinefixings": {
                    "weight": "Weight",
                    "recommended": "recommended",
                    "readmore": "Read more",
                    "machinefixing": "Machine coupler",
                    "choosemachinefixing": "Select machine coupler",
                    "attachment":"Attachment frame",
                    "chooseattachment": "Select attachment frame",
                    "continuewithout": "Continue without machine coupler",
                    "choosedirectmount": "Select direct attachment",
                    "choosesfixing": "Select S-coupler",
                    "chooseqcfixing": "Select QuickChange™ coupler",
                    "nomachinefixing": "Continue without selecting machine coupler",
                    "sfixing": {
                    "sfixing": "S-coupler",
                    "weightfrom": "Weight, from",
                    "maxallowedloadlifthook": "Permitted max. load, lift hook",
                    "infotext": "A powerful and robust standard coupler with a compact design. Makes it possible to disconnect the tiltrotator during heavier jobs, for example when using hydraulic hammers. These couplers are based on the common S-standard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ coupler",
                        "weightfrom": "Weight, from",
                        "maxallowedloadlifthook": "Permitted max. load, lift hook",
                        "numberofcouplers":"Number of couplings, max",
                        "infotext": "QuickChange™ is Rototilt’s fully automatic quick coupler system. It is a smart addition that allows automatic changes of hydraulic work tools without you having to leave the excavator’s cab."
                    },
                    "directmount": {
                        "directmount": "Direct attachment",
                        "infotext": "A direct attachment means that the tiltrotator is attached directly to the excavator. It is the lightest and most compact solution, which is suitable for applications where the tiltrotator never needs to be disconnected."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Select quick coupler",
                        "toolattachment": "Quick coupler"
                    }
                },
                "tools": {
                    "readmore": "Read more",
                    "tools": "Work tools",
                    "categories": "categories",
                    "choosetools": "Select work tool",
                    "ourtools": "Our work tools",
                    "disclamertools": "The work tools below are a general recommendation. Consult with your dealer for precise adaptation to your machine model.",
                    "number of results": "results for your excavator",
                    "results": "Results",
                    "buckets": "Buckets",
                    "choise": "Variant",
                    "choises": "Variants",
                    "weight": "Weight",
                    "bucket": {
                        "bucket": "Bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Excavation bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume",
                        "toothtype": "Tooth type"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Trenching bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sorting bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Universal bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Do you want to add a grapple module?",
                        "continuewithout": "Continue without grapple module",
                        "grapplemodule": "Grapple module",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Railroad grapple",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "grapple": {
                        "grapple": "Grapples",
                        "grappleforcemax": "Grapple force, max",
                        "grapplewidthmax": "Grapple width, max"
                    },
                    "grappletypes": {
                        "multigrapple": "multi-grapple",
                        "stonegrapple":"stone grapple",
                        "sortinggrapple": "sorting grapple"
                    },
                    "compactor": {
                        "compactor": "Compactor",
                        "weight": "Weight",
                        "vibrationforce": "Vibration force"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Grading beam",
                        "weight": "Weight",
                        "width": "Width"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Weight",
                        "toothradius": "Tooth radius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asphalt cutter",
                        "weight": "Weight",
                        "cutdepth": "Cutting depth"
                    },
                    "toolmount": {
                        "toolmount": "Tool attachment frame"
                    }
                },
                "optionalstep": {
                    "yourmachine": "your machine model",
                    "yourmachineweight": "your machine weight",
                    "optionalstep": "Optional",
                    "introweight": "Do you want to add more products that match ",
                    "intromachine": "Do you want to add more products that match ",
                    "introaftervalue":"Explore our range or proceed to the next step."
                },
                "yourchoises": {
                    "yourchoises": "Your selections",
                    "yourchoisesintro": "Fill in your information and review your selections. When you have finished, your summary will be sent to a representative from Rototilt, who will contact you shortly.",
                    "yourinformation": "Fill in your information",
                   "viewretailers": "See dealers",
                    "reviewchoises": "Review your selections",
                    "products": "products"

                },
                "contactusform": {
                    "firstname": "First name",
                    "firstnamemandatory": "Enter your first name",
                    "firstnameinvalid": "Enter letters only",
                    "lastname": "Last name",
                    "lastnamemandatory": "Enter your last name",
                    "locationinvalid": "Enter letters only",		
                    "lastnameinvalid": "Enter letters only",
                    "email": "Email address",
                    "emailmandatory": "Enter your email address",
                    "emailinvalid": "Invalid email address",
                    "phone": "Phone number",
                    "phonemandatory": "Enter your phone number",
                    "phoneinvalid": "Invalid phone number",
                    "city": "City",
                    "zip": "Postcode",
                    "country:": "Country",
                    "countrymandatory:": "Enter your country",
                    "message": "Add message (optional)",
                    "contactus": "Send", 
                    "checkboxintegrity": "I approve Rototilt Group AB processing my personal data according to its ",
                    "checkboxintegritylink": "personal data policy.",	
                    "checkboxnews": "I would like to receive news and offers from Rototilt.",
                    "share": {
                        "share": "Share",
                        "close": "Close",
                        "copylink": "Copy link",
                        "info": "Use this link to share or save your configuration"
                    }
                },
                "endpage": {
                    "welldone": "Good job!",
                    "gotoweb": "Click here to visit our website",	
                    "endpageinfo": "A representative from Rototilt will contact you shortly. A confirmation with a link to your selections has been sent to your email."
                },
                "disclamer": {
                    "disclamertext": "We make reservation for any typographical errors or spelling mistakes and any errors that may occur, and reserve the right to change specifications without prior notification. Variations in product ranges and equipment standards may occur between different markets. For more information about current product specifications, local adaptations and special equipment, please contact your nearest Rototilt dealer."
                },
                "url": {
                   "productguide": "product guide",
                   "machinetonnage": "machine weight",
                   "product": "product",
                   "optional": "optional",
                   "contactus": "contact us",
                   "thankyou": "thank you" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine and weight",
                    "productstep": "Products",
                    "otheroptionsstep": "Optional",
                    "contactusstep": "Your selections"
                },
                "cart": {
                    "yourproducts": "Your products"
                },
                "footer": {
                    "previous": "Previous",
                    "next": "Next"
                },
                "topbar": {
                    "products": "Products"
                },
                "popup": {
                    "areyousure": "If you make changes, your selections will be cleared. Are you sure you want to continue?",
                    "important": "Important!",
                    "clearchoises": "Clear my selections",
                    "cancel": "Cancel",
                    "stay": "Stay on the page"
                    
                },
                "thankyoumail": {
                    "subject": "Subject: Thank you for contacting us",
                    "hello": "Hello",
                    "intro": "We have received your selections in Rototilt’s product guide. A representative from Rototilt will contact you shortly. For the time being, you can click on the link below to see a summary of your selections.",
                    "summary": "Your compilation",
                    "signature": "Kind regards",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Read more at www.rototilt.com"
                }
            },
            "en-US": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pcs"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt product guide - Find your perfect match",
                        "text": "Mix and match products from Rototilt with your specific excavator model. Find your perfect match now with Rototilt´s product guide!",
                        "keywords": "rototilt product guide, rototilt product configurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Select market",
                        "change": "change",
                        "sv-SE": "Sweden",
                        "da-DK": "Denmark",
                        "en-GB": "United Kingdom",
                        "fi-FI": "Finland",
                        "fr-FR": "France",
                        "de-DE": "Germany",
                        "nb-NO": "Norway",
                        "en-US": "USA",
                        "en-CA": "Canada (English)",   
                        "en-NZ": "New Zealand",	
                        "fr-CA": "Canada (French)",
                        "en": "Global",
                        "pl-PL": "Poland",
                        "nl-NL": "Netherlands",
                        "es-ES": "Spain",
                        "en-AU": "Australia",
                        "ja-JP": "Japan",
                        "ko-KR": "South Korea",
                        "nl-BE": "Belgium (Dutch)",
                        "fr-BE": "Belgium (French)"
                    },
                    "markettexts": {
                        "marketheader": "Welcome to Rototilt’s product guide",
                        "marketintro": "Using our product guide will assist you in matching products from Rototilt with a specific excavator model. By specifying your machine model or machine weight, you can choose between recommended products and build your own tiltrotator system. Start by choosing your market.",
                        "chosemarketheader": "Choose your market",
                        "choosebetween": "Choose from",
                        "markets": "Markets",
                        "marketnotfound": "If you can’t find your market, select “Global”.",
                        "searchmarket": "Search among our markets",
                        "choosemarket": "Select market"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine and weight",
                        "machinetonnageintro": "To get the best possible product recommendations for your machine, select the excavator model or specify the weight of your machine.",
                        "findmachine": "Find your machine",
                        "findmachinetext1":"Select the machine model to get product recommendations for your excavator.",
                        "findmachinetext2":"Select the machine model to get product recommendations for your excavator. If you can’t find your model, switch to machine weight.",
                        "searchplaceholder": "Search make and model",
                        "switchtotonnage": "Switch to machine weight",
                        "picktonnage": "Enter your machine weight",
                        "picktonnagetext1":"Enter the weight to get product recommendations that match your excavator.",
                        "picktonnagetext2":"Enter the weight to get product recommendations that match your excavator. You can also switch to machine model. ",
                        "choosetonnage": "Enter your machine weight",
                        "tonnagehelpertext":"You can give a rough estimate.",
                        "switchtomachine":"Switch to machine model",
                        "loadingMessage": "We are looking for your machine...",
                        "noOptionsMessage": "Search for your machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Products",
                        "productintro": "What products are you interested in? Select a product category to begin with. You have the option of adding more products and changing your selections later.",
                        "chooseproductcategory": "Select product category"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotators",
                    "choosetiltrotator": "Select tiltrotator",
                    "recomended": "Recommended",
                    "breakforcemax": "Breakout force, max",
                    "bucketwidthmax": "Bucket width, max"
                },
                "machinefixings": {
                    "weight": "Weight",
                    "recommended": "recommended",
                    "readmore": "Read more",
                    "machinefixing": "Machine coupler",
                    "choosemachinefixing": "Select machine coupler",
                    "attachment":"Attachment frame",
                    "chooseattachment": "Select attachment frame",
                    "continuewithout": "Continue without machine coupler",
                    "choosedirectmount": "Select direct attachment",
                    "choosesfixing": "Select S-coupler",
                    "chooseqcfixing": "Select QuickChange™ coupler",
                    "nomachinefixing": "Continue without selecting machine coupler",
                    "sfixing": {
                    "sfixing": "S-coupler",
                    "weightfrom": "Weight, from",
                    "maxallowedloadlifthook": "Permitted max. load, lift hook",
                    "infotext": "A powerful and robust standard coupler with a compact design. Makes it possible to disconnect the tiltrotator during heavier jobs, for example when using hydraulic hammers. These couplers are based on the common S-standard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ coupler",
                        "weightfrom": "Weight, from",
                        "maxallowedloadlifthook": "Permitted max. load, lift hook",
                        "numberofcouplers":"Number of couplings, max",
                        "infotext": "QuickChange™ is Rototilt’s fully automatic quick coupler system. It is a smart addition that allows automatic changes of hydraulic work tools without you having to leave the excavator’s cab."
                    },
                    "directmount": {
                        "directmount": "Direct attachment",
                        "infotext": "A direct attachment means that the tiltrotator is attached directly to the excavator. It is the lightest and most compact solution, which is suitable for applications where the tiltrotator never needs to be disconnected."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Select quick coupler",
                        "toolattachment": "Quick coupler"
                    }
                },
                "tools": {
                    "readmore": "Read more",
                    "tools": "Work tools",
                    "categories": "categories",
                    "choosetools": "Select work tool",
                    "ourtools": "Our work tools",
                    "disclamertools": "The work tools below are a general recommendation. Consult with your dealer for precise adaptation to your machine model.",
                    "number of results": "results for your excavator",
                    "results": "Results",
                    "buckets": "Buckets",
                    "choise": "Variant",
                    "choises": "Variants",
                    "weight": "Weight",
                    "bucket": {
                        "bucket": "Bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Excavation bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume",
                        "toothtype": "Tooth type"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Trenching bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sorting bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Universal bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Do you want to add a grapple module?",
                        "continuewithout": "Continue without grapple module",
                        "grapplemodule": "Grapple module",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Railroad grapple",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "grapple": {
                        "grapple": "Grapples",
                        "grappleforcemax": "Grapple force, max",
                        "grapplewidthmax": "Grapple width, max"
                    },
                    "grappletypes": {
                        "multigrapple": "multi-grapple",
                        "stonegrapple":"stone grapple",
                        "sortinggrapple": "sorting grapple"
                    },
                    "compactor": {
                        "compactor": "Compactor",
                        "weight": "Weight",
                        "vibrationforce": "Vibration force"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Grading beam",
                        "weight": "Weight",
                        "width": "Width"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Weight",
                        "toothradius": "Tooth radius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asphalt cutter",
                        "weight": "Weight",
                        "cutdepth": "Cutting depth"
                    },
                    "toolmount": {
                        "toolmount": "Tool attachment frame"
                    }
                },
                "optionalstep": {
                    "yourmachine": "your machine model",
                    "yourmachineweight": "your machine weight",
                    "optionalstep": "Optional",
                    "introweight": "Do you want to add more products that match ",
                    "intromachine": "Do you want to add more products that match ",
                    "introaftervalue":"Explore our range or proceed to the next step."
                },
                "yourchoises": {
                    "yourchoises": "Your selections",
                    "yourchoisesintro": "Fill in your information and review your selections. When you have finished, your summary will be sent to a representative from Rototilt, who will contact you shortly.",
                    "yourinformation": "Fill in your information",
                   "viewretailers": "See dealers",
                    "reviewchoises": "Review your selections",
                    "products": "products"

                },
                "contactusform": {
                    "firstname": "First name",
                    "firstnamemandatory": "Enter your first name",
                    "firstnameinvalid": "Enter letters only",
                    "lastname": "Last name",
                    "lastnamemandatory": "Enter your last name",
                    "lastnameinvalid": "Enter letters only",
                    "locationinvalid": "Enter letters only",		
                    "email": "Email address",
                    "emailmandatory": "Enter your email address",
                    "emailinvalid": "Invalid email address",
                    "phone": "Phone number",
                    "phonemandatory": "Enter your phone number",
                    "phoneinvalid": "Invalid phone number",
                    "city": "City",
                    "zip": "Postcode",
                    "country:": "Country",
                    "countrymandatory:": "Enter your country",
                    "message": "Add message (optional)",
                    "contactus": "Send", 
                    "checkboxintegrity": "I approve Rototilt Group AB processing my personal data according to its ",
                    "checkboxintegritylink": "personal data policy.",	
                    "checkboxnews": "I would like to receive news and offers from Rototilt.",
                    "share": {
                        "share": "Share",
                        "close": "Close",
                        "copylink": "Copy link",
                        "info": "Use this link to share or save your configuration"
                    }
                },
                "endpage": {
                    "welldone": "Good job!",
                    "gotoweb": "Click here to visit our website",	
                    "endpageinfo": "A representative from Rototilt will contact you shortly. A confirmation with a link to your selections has been sent to your email."
                },
                "disclamer": {
                    "disclamertext": "We make reservation for any typographical errors or spelling mistakes and any errors that may occur, and reserve the right to change specifications without prior notification. Variations in product ranges and equipment standards may occur between different markets. For more information about current product specifications, local adaptations and special equipment, please contact your nearest Rototilt dealer."
                },
                "url": {
                   "productguide": "product guide",
                   "machinetonnage": "machine weight",
                   "product": "product",
                   "optional": "optional",
                   "contactus": "contact us",
                   "thankyou": "thank you" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine and weight",
                    "productstep": "Products",
                    "otheroptionsstep": "Optional",
                    "contactusstep": "Your selections"
                },
                "cart": {
                    "yourproducts": "Your products"
                },
                "footer": {
                    "previous": "Previous",
                    "next": "Next"
                },
                "topbar": {
                    "products": "Products"
                },
                "popup": {
                    "areyousure": "If you make changes, your selections will be cleared. Are you sure you want to continue?",
                    "important": "Important!",
                    "clearchoises": "Clear my selections",
                    "cancel": "Cancel",
                    "stay": "Stay on the page"
                },
                "thankyoumail": {
                    "subject": "Subject: Thank you for contacting us",
                    "hello": "Hello",
                    "intro": "We have received your selections in Rototilt’s product guide. A representative from Rototilt will contact you shortly. For the time being, you can click on the link below to see a summary of your selections.",
                    "summary": "Your compilation",
                    "signature": "Kind regards",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Read more at www.rototilt.com"
                }
            },
            "en-AU": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pcs"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt product guide - Find your perfect match",
                        "text": "Mix and match products from Rototilt with your specific excavator model. Find your perfect match now with Rototilt´s product guide!",
                        "keywords": "rototilt product guide, rototilt product configurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Select market",
                        "change": "change",
                        "sv-SE": "Sweden",
                        "da-DK": "Denmark",
                        "en-GB": "United Kingdom",
                        "fi-FI": "Finland",
                        "fr-FR": "France",
                        "de-DE": "Germany",
                        "nb-NO": "Norway",
                        "en-US": "USA",
                        "en-CA": "Canada (English)",   
                        "en-NZ": "New Zealand",	
                        "fr-CA": "Canada (French)",
                        "en": "Global",
                        "pl-PL": "Poland",
                        "nl-NL": "Netherlands",
                        "es-ES": "Spain",
                        "en-AU": "Australia",
                        "ja-JP": "Japan",
                        "ko-KR": "South Korea",
                        "nl-BE": "Belgium (Dutch)",
                        "fr-BE": "Belgium (French)"
                    },
                    "markettexts": {
                        "marketheader": "Welcome to Rototilt’s product guide",
                        "marketintro": "Using our product guide will assist you in matching products from Rototilt with a specific excavator model. By specifying your machine model or machine weight, you can choose between recommended products and build your own tiltrotator system. Start by choosing your market.",
                        "chosemarketheader": "Choose your market",
                        "choosebetween": "Choose from",
                        "markets": "Markets",
                        "marketnotfound": "If you can’t find your market, select “Global”.",
                        "searchmarket": "Search among our markets",
                        "choosemarket": "Select market"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine and weight",
                        "machinetonnageintro": "To get the best possible product recommendations for your machine, select the excavator model or specify the weight of your machine.",
                        "findmachine": "Find your machine",
                        "findmachinetext1":"Select the machine model to get product recommendations for your excavator.",
                        "findmachinetext2":"Select the machine model to get product recommendations for your excavator. If you can’t find your model, switch to machine weight.",
                        "searchplaceholder": "Search make and model",
                        "switchtotonnage": "Switch to machine weight",
                        "picktonnage": "Enter your machine weight",
                        "picktonnagetext1":"Enter the weight to get product recommendations that match your excavator.",
                        "picktonnagetext2":"Enter the weight to get product recommendations that match your excavator. You can also switch to machine model. ",
                        "choosetonnage": "Enter your machine weight",
                        "tonnagehelpertext":"You can give a rough estimate.",
                        "switchtomachine":"Switch to machine model",
                        "loadingMessage": "We are looking for your machine...",
                        "noOptionsMessage": "Search for your machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Products",
                        "productintro": "What products are you interested in? Select a product category to begin with. You have the option of adding more products and changing your selections later.",
                        "chooseproductcategory": "Select product category"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotators",
                    "choosetiltrotator": "Select tiltrotator",
                    "recomended": "Recommended",
                    "breakforcemax": "Breakout force, max",
                    "bucketwidthmax": "Bucket width, max"
                },
                "machinefixings": {
                    "weight": "Weight",
                    "recommended": "recommended",
                    "readmore": "Read more",
                    "machinefixing": "Machine coupler",
                    "choosemachinefixing": "Select machine coupler",
                    "attachment":"Attachment frame",
                    "chooseattachment": "Select attachment frame",
                    "continuewithout": "Continue without machine coupler",
                    "choosedirectmount": "Select direct attachment",
                    "choosesfixing": "Select S-coupler",
                    "chooseqcfixing": "Select QuickChange™ coupler",
                    "nomachinefixing": "Continue without selecting machine coupler",
                    "sfixing": {
                    "sfixing": "S-coupler",
                    "weightfrom": "Weight, from",
                    "maxallowedloadlifthook": "Permitted max. load, lift hook",
                    "infotext": "A powerful and robust standard coupler with a compact design. Makes it possible to disconnect the tiltrotator during heavier jobs, for example when using hydraulic hammers. These couplers are based on the common S-standard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ coupler",
                        "weightfrom": "Weight, from",
                        "maxallowedloadlifthook": "Permitted max. load, lift hook",
                        "numberofcouplers":"Number of couplings, max",
                        "infotext": "QuickChange™ is Rototilt’s fully automatic quick coupler system. It is a smart addition that allows automatic changes of hydraulic work tools without you having to leave the excavator’s cab."
                    },
                    "directmount": {
                        "directmount": "Direct attachment",
                        "infotext": "A direct attachment means that the tiltrotator is attached directly to the excavator. It is the lightest and most compact solution, which is suitable for applications where the tiltrotator never needs to be disconnected."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Select quick coupler",
                        "toolattachment": "Quick coupler"
                    }
                },
                "tools": {
                    "readmore": "Read more",
                    "tools": "Work tools",
                    "categories": "categories",
                    "choosetools": "Select work tool",
                    "ourtools": "Our work tools",
                    "disclamertools": "The work tools below are a general recommendation. Consult with your dealer for precise adaptation to your machine model.",
                    "number of results": "results for your excavator",
                    "results": "Results",
                    "buckets": "Buckets",
                    "choise": "Variant",
                    "choises": "Variants",
                    "weight": "Weight",
                    "bucket": {
                        "bucket": "Bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Excavation bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume",
                        "toothtype": "Tooth type"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Trenching bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sorting bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Universal bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Do you want to add a grapple module?",
                        "continuewithout": "Continue without grapple module",
                        "grapplemodule": "Grapple module",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Railroad grapple",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "grapple": {
                        "grapple": "Grapples",
                        "grappleforcemax": "Grapple force, max",
                        "grapplewidthmax": "Grapple width, max"
                    },
                    "grappletypes": {
                        "multigrapple": "multi-grapple",
                        "stonegrapple":"stone grapple",
                        "sortinggrapple": "sorting grapple"
                    },
                    "compactor": {
                        "compactor": "Compactor",
                        "weight": "Weight",
                        "vibrationforce": "Vibration force"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Grading beam",
                        "weight": "Weight",
                        "width": "Width"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Weight",
                        "toothradius": "Tooth radius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asphalt cutter",
                        "weight": "Weight",
                        "cutdepth": "Cutting depth"
                    },
                    "toolmount": {
                        "toolmount": "Tool attachment frame"
                    }
                },
                "optionalstep": {
                    "yourmachine": "your machine model",
                    "yourmachineweight": "your machine weight",
                    "optionalstep": "Optional",
                    "introweight": "Do you want to add more products that match ",
                    "intromachine": "Do you want to add more products that match ",
                    "introaftervalue":"Explore our range or proceed to the next step."
                },
                "yourchoises": {
                    "yourchoises": "Your selections",
                    "yourchoisesintro": "Fill in your information and review your selections. When you have finished, your summary will be sent to a representative from Rototilt, who will contact you shortly.",
                    "yourinformation": "Fill in your information",
                   "viewretailers": "See dealers",
                    "reviewchoises": "Review your selections",
                    "products": "products"

                },
                "contactusform": {
                    "firstname": "First name",
                    "firstnamemandatory": "Enter your first name",
                    "firstnameinvalid": "Enter letters only",
                    "lastname": "Last name",
                    "lastnamemandatory": "Enter your last name",
                    "lastnameinvalid": "Enter letters only",
                    "locationinvalid": "Enter letters only",		
                    "email": "Email address",
                    "emailmandatory": "Enter your email address",
                    "emailinvalid": "Invalid email address",
                    "phone": "Phone number",
                    "phonemandatory": "Enter your phone number",
                    "phoneinvalid": "Invalid phone number",
                    "city": "City",
                    "zip": "Postcode",
                    "country:": "Country",
                    "countrymandatory:": "Enter your country",
                    "message": "Add message (optional)",
                    "contactus": "Send", 
                    "checkboxintegrity": "I approve Rototilt Group AB processing my personal data according to its ",
                    "checkboxintegritylink": "personal data policy.",	
                    "checkboxnews": "I would like to receive news and offers from Rototilt.",
                    "share": {
                        "share": "Share",
                        "close": "Close",
                        "copylink": "Copy link",
                        "info": "Use this link to share or save your configuration"
                    }
                },
                "endpage": {
                    "welldone": "Good job!",
                    "gotoweb": "Click here to visit our website",	
                    "endpageinfo": "A representative from Rototilt will contact you shortly. A confirmation with a link to your selections has been sent to your email."
                },
                "disclamer": {
                    "disclamertext": "We make reservation for any typographical errors or spelling mistakes and any errors that may occur, and reserve the right to change specifications without prior notification. Variations in product ranges and equipment standards may occur between different markets. For more information about current product specifications, local adaptations and special equipment, please contact your nearest Rototilt dealer."
                },
                "url": {
                   "productguide": "product guide",
                   "machinetonnage": "machine weight",
                   "product": "product",
                   "optional": "optional",
                   "contactus": "contact us",
                   "thankyou": "thank you" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine and weight",
                    "productstep": "Products",
                    "otheroptionsstep": "Optional",
                    "contactusstep": "Your selections"
                },
                "cart": {
                    "yourproducts": "Your products"
                },
                "footer": {
                    "previous": "Previous",
                    "next": "Next"
                },
                "topbar": {
                    "products": "Products"
                },
                "popup": {
                    "areyousure": "If you make changes, your selections will be cleared. Are you sure you want to continue?",
                    "important": "Important!",
                    "clearchoises": "Clear my selections",
                    "cancel": "Cancel",
                    "stay": "Stay on the page"
                },
                "thankyoumail": {
                    "subject": "Subject: Thank you for contacting us",
                    "hello": "Hello",
                    "intro": "We have received your selections in Rototilt’s product guide. A representative from Rototilt will contact you shortly. For the time being, you can click on the link below to see a summary of your selections.",
                    "summary": "Your compilation",
                    "signature": "Kind regards",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Read more at www.rototilt.com"
                }
            },
            "en-NZ": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pcs"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt product guide - Find your perfect match",
                        "text": "Mix and match products from Rototilt with your specific excavator model. Find your perfect match now with Rototilt´s product guide!",
                        "keywords": "rototilt product guide, rototilt product configurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Select market",
                        "change": "change",
                        "sv-SE": "Sweden",
                        "da-DK": "Denmark",
                        "en-GB": "United Kingdom",
                        "fi-FI": "Finland",
                        "fr-FR": "France",
                        "de-DE": "Germany",
                        "nb-NO": "Norway",
                        "en-US": "USA",
                        "en-CA": "Canada (English)",   
                        "en-NZ": "New Zealand",	
                        "fr-CA": "Canada (French)",
                        "en": "Global",
                        "pl-PL": "Poland",
                        "nl-NL": "Netherlands",
                        "es-ES": "Spain",
                        "en-AU": "Australia",
                        "ja-JP": "Japan",
                        "ko-KR": "South Korea",
                        "nl-BE": "Belgium (Dutch)",
                        "fr-BE": "Belgium (French)"
                    },
                    "markettexts": {
                        "marketheader": "Welcome to Rototilt’s product guide",
                        "marketintro": "Using our product guide will assist you in matching products from Rototilt with a specific excavator model. By specifying your machine model or machine weight, you can choose between recommended products and build your own tiltrotator system. Start by choosing your market.",
                        "chosemarketheader": "Choose your market",
                        "choosebetween": "Choose from",
                        "markets": "Markets",
                        "marketnotfound": "If you can’t find your market, select “Global”.",
                        "searchmarket": "Search among our markets",
                        "choosemarket": "Select market"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine and weight",
                        "machinetonnageintro": "To get the best possible product recommendations for your machine, select the excavator model or specify the weight of your machine.",
                        "findmachine": "Find your machine",
                        "findmachinetext1":"Select the machine model to get product recommendations for your excavator.",
                        "findmachinetext2":"Select the machine model to get product recommendations for your excavator. If you can’t find your model, switch to machine weight.",
                        "searchplaceholder": "Search make and model",
                        "switchtotonnage": "Switch to machine weight",
                        "picktonnage": "Enter your machine weight",
                        "picktonnagetext1":"Enter the weight to get product recommendations that match your excavator.",
                        "picktonnagetext2":"Enter the weight to get product recommendations that match your excavator. You can also switch to machine model. ",
                        "choosetonnage": "Enter your machine weight",
                        "tonnagehelpertext":"You can give a rough estimate.",
                        "switchtomachine":"Switch to machine model",
                        "loadingMessage": "We are looking for your machine...",
                        "noOptionsMessage": "Search for your machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Products",
                        "productintro": "What products are you interested in? Select a product category to begin with. You have the option of adding more products and changing your selections later.",
                        "chooseproductcategory": "Select product category"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotators",
                    "choosetiltrotator": "Select tiltrotator",
                    "recomended": "Recommended",
                    "breakforcemax": "Breakout force, max",
                    "bucketwidthmax": "Bucket width, max"
                },
                "machinefixings": {
                    "weight": "Weight",
                    "recommended": "recommended",
                    "readmore": "Read more",
                    "machinefixing": "Machine coupler",
                    "choosemachinefixing": "Select machine coupler",
                    "attachment":"Attachment frame",
                    "chooseattachment": "Select attachment frame",
                    "continuewithout": "Continue without machine coupler",
                    "choosedirectmount": "Select direct attachment",
                    "choosesfixing": "Select S-coupler",
                    "chooseqcfixing": "Select QuickChange™ coupler",
                    "nomachinefixing": "Continue without selecting machine coupler",
                    "sfixing": {
                    "sfixing": "S-coupler",
                    "weightfrom": "Weight, from",
                    "maxallowedloadlifthook": "Permitted max. load, lift hook",
                    "infotext": "A powerful and robust standard coupler with a compact design. Makes it possible to disconnect the tiltrotator during heavier jobs, for example when using hydraulic hammers. These couplers are based on the common S-standard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ coupler",
                        "weightfrom": "Weight, from",
                        "maxallowedloadlifthook": "Permitted max. load, lift hook",
                        "numberofcouplers":"Number of couplings, max",
                        "infotext": "QuickChange™ is Rototilt’s fully automatic quick coupler system. It is a smart addition that allows automatic changes of hydraulic work tools without you having to leave the excavator’s cab."
                    },
                    "directmount": {
                        "directmount": "Direct attachment",
                        "infotext": "A direct attachment means that the tiltrotator is attached directly to the excavator. It is the lightest and most compact solution, which is suitable for applications where the tiltrotator never needs to be disconnected."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Select quick coupler",
                        "toolattachment": "Quick coupler"
                    }
                },
                "tools": {
                    "readmore": "Read more",
                    "tools": "Work tools",
                    "categories": "categories",
                    "choosetools": "Select work tool",
                    "ourtools": "Our work tools",
                    "disclamertools": "The work tools below are a general recommendation. Consult with your dealer for precise adaptation to your machine model.",
                    "number of results": "results for your excavator",
                    "results": "Results",
                    "buckets": "Buckets",
                    "choise": "Variant",
                    "choises": "Variants",
                    "weight": "Weight",
                    "bucket": {
                        "bucket": "Bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Excavation bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume",
                        "toothtype": "Tooth type"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Trenching bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sorting bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Universal bucket",
                        "articlenumber": "Article number",
                        "width": "Width",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Do you want to add a grapple module?",
                        "continuewithout": "Continue without grapple module",
                        "grapplemodule": "Grapple module",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Railroad grapple",
                        "weight": "Weight",
                        "liftingcapacitymax": "Lifting capacity, max"
                    },
                    "grapple": {
                        "grapple": "Grapples",
                        "grappleforcemax": "Grapple force, max",
                        "grapplewidthmax": "Grapple width, max"
                    },
                    "grappletypes": {
                        "multigrapple": "multi-grapple",
                        "stonegrapple":"stone grapple",
                        "sortinggrapple": "sorting grapple"
                    },
                    "compactor": {
                        "compactor": "Compactor",
                        "weight": "Weight",
                        "vibrationforce": "Vibration force"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Grading beam",
                        "weight": "Weight",
                        "width": "Width"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Weight",
                        "toothradius": "Tooth radius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asphalt cutter",
                        "weight": "Weight",
                        "cutdepth": "Cutting depth"
                    },
                    "toolmount": {
                        "toolmount": "Tool attachment frame"
                    }
                },
                "optionalstep": {
                    "yourmachine": "your machine model",
                    "yourmachineweight": "your machine weight",
                    "optionalstep": "Optional",
                    "introweight": "Do you want to add more products that match ",
                    "intromachine": "Do you want to add more products that match ",
                    "introaftervalue":"Explore our range or proceed to the next step."
                },
                "yourchoises": {
                    "yourchoises": "Your selections",
                    "yourchoisesintro": "Fill in your information and review your selections. When you have finished, your summary will be sent to a representative from Rototilt, who will contact you shortly.",
                    "yourinformation": "Fill in your information",
                   "viewretailers": "See dealers",
                    "reviewchoises": "Review your selections",
                    "products": "products"

                },
                "contactusform": {
                    "firstname": "First name",
                    "firstnamemandatory": "Enter your first name",
                    "firstnameinvalid": "Enter letters only",
                    "lastname": "Last name",
                    "lastnamemandatory": "Enter your last name",
                    "lastnameinvalid": "Enter letters only",
                    "locationinvalid": "Enter letters only",		
                    "email": "Email address",
                    "emailmandatory": "Enter your email address",
                    "emailinvalid": "Invalid email address",
                    "phone": "Phone number",
                    "phonemandatory": "Enter your phone number",
                    "phoneinvalid": "Invalid phone number",
                    "city": "City",
                    "zip": "Postcode",
                    "country:": "Country",
                    "countrymandatory:": "Enter your country",
                    "message": "Add message (optional)",
                    "contactus": "Send", 
                    "checkboxintegrity": "I approve Rototilt Group AB processing my personal data according to its ",
                    "checkboxintegritylink": "personal data policy.",	
                    "checkboxnews": "I would like to receive news and offers from Rototilt.",
                    "share": {
                        "share": "Share",
                        "close": "Close",
                        "copylink": "Copy link",
                        "info": "Use this link to share or save your configuration"
                    }
                },
                "endpage": {
                    "welldone": "Good job!",
                    "gotoweb": "Click here to visit our website",	
                    "endpageinfo": "A representative from Rototilt will contact you shortly. A confirmation with a link to your selections has been sent to your email."
                },
                "disclamer": {
                    "disclamertext": "We make reservation for any typographical errors or spelling mistakes and any errors that may occur, and reserve the right to change specifications without prior notification. Variations in product ranges and equipment standards may occur between different markets. For more information about current product specifications, local adaptations and special equipment, please contact your nearest Rototilt dealer."
                },
                "url": {
                   "productguide": "product guide",
                   "machinetonnage": "machine weight",
                   "product": "product",
                   "optional": "optional",
                   "contactus": "contact us",
                   "thankyou": "thank you" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine and weight",
                    "productstep": "Products",
                    "otheroptionsstep": "Optional",
                    "contactusstep": "Your selections"
                },
                "cart": {
                    "yourproducts": "Your products"
                },
                "footer": {
                    "previous": "Previous",
                    "next": "Next"
                },
                "topbar": {
                    "products": "Products"
                },
                "popup": {
                    "areyousure": "If you make changes, your selections will be cleared. Are you sure you want to continue?",
                    "important": "Important!",
                    "clearchoises": "Clear my selections",
                    "cancel": "Cancel",
                    "stay": "Stay on the page"
                },
                "thankyoumail": {
                    "subject": "Subject: Thank you for contacting us",
                    "hello": "Hello",
                    "intro": "We have received your selections in Rototilt’s product guide. A representative from Rototilt will contact you shortly. For the time being, you can click on the link below to see a summary of your selections.",
                    "summary": "Your compilation",
                    "signature": "Kind regards",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Read more at www.rototilt.com"
                }
            },
            "es-ES": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " toneladas",
                    "kg": " kg",
                    "inches": "pulgadas",
                    "pounds": "libras",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "uds"
                },
                "seo": {
                    "startpage": {
                        "titel": "Guía de productos de Rototilt - Combine con su excavadora",
                        "text": "Le presentamos la guía de productos de Rototilt. Aquí puede encontrar y combinar fácilmente los productos de Rototilt con su modelo específico de excavadora.",
                        "keywords": "guía de productos Rototilt, configurador de productos Rototilt",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Seleccione un mercado",
                        "change": "cambiar",
                        "sv-SE": "Suecia",
                        "da-DK": "Dinamarca",
                        "en-GB": "Reino Unido",
                        "fi-FI": "Finlandia",
                        "fr-FR": "Francia",
                        "de-DE": "Alemania",
                        "nb-NO": "Noruega",
                        "en-US": "EE. UU.",
                        "en-CA": "Canadá (Inglés)",   
                        "en-NZ": "Nueva Zelanda",	
                        "fr-CA": "Canadá (francés)",
                        "en": "Global",
                        "pl-PL": "Polonia",
                        "nl-NL": "Países Bajos",
                        "es-ES": "España",
                        "en-AU": "Australia",
                        "ja-JP": "Japón",
                        "ko-KR": "Corea del Sur"
                    },
                    "markettexts": {
                        "marketheader": "Le presentamos la guía de productos de Rototilt",
                        "marketintro": "El uso de nuestra guía, os ayudara a combinar los productos de Rototilt con un modelo de excavadora concreto. Especificando el modelo de su maquina o en alternativa su peso, podrá elegir los productos recomendados y configurar su rotor basculante. Primero debe elegir un país:",
                        "chosemarketheader": "Elija un mercado",
                        "choosebetween": "Puede elegir entre",
                        "markets": "Mercados",
                        "marketnotfound": "Si no encuentra un mercado específico, seleccione la opción «Global».",
                        "searchmarket": "Consulte nuestros mercados",
                        "choosemarket": "Seleccione un mercado"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Máquina y peso",
                        "machinetonnageintro": "Para obtener las mejores sugerencias posibles para su máquina, seleccione el modelo de excavadora o el peso de su máquina portadora.",
                        "findmachine": "Encuentre su máquina",
                        "findmachinetext1":"Seleccione el modelo de máquina concreto para obtener recomendaciones de productos para su excavadora.",
                        "findmachinetext2":"Seleccione el modelo de máquina para obtener recomendaciones de productos para su excavadora. Si no encuentra su modelo, busque por el peso de la máquina.",
                        "searchplaceholder": "Buscar marca y modelo",
                        "switchtotonnage": "Buscar por el peso de la máquina",
                        "picktonnage": "Introduzca el peso de su máquina",
                        "picktonnagetext1":"Introduzca el peso para obtener recomendaciones de productos que se ajusten a su excavadora.",
                        "picktonnagetext2":"Introduzca el peso para obtener recomendaciones de productos que se ajusten a su excavadora. También puede buscar por el modelo de máquina. ",
                        "choosetonnage": "Introduzca el peso de su máquina",
                        "tonnagehelpertext":"Puede dar una cifra aproximada.",
                        "switchtomachine":"Buscar por el modelo de la máquina",
                        "loadingMessage": "Estamos buscando su máquina…",
                        "noOptionsMessage": "Buscar su máquina…"
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Productos",
                        "productintro": "¿Qué productos le interesan? Para empezar, seleccione una categoría de productos. Puede añadir más productos y cambiar su selección más adelante.",
                        "chooseproductcategory": "Seleccione la categoría del producto"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Rotor basculante",
                    "tiltrotators": "Rotores basculantes",
                    "choosetiltrotator": "Seleccione un rotor basculante",
                    "recomended": "Recomendado",
                    "breakforcemax": "Fuerza de arranque, máx.",
                    "bucketwidthmax": "Anchura del cucharón, máx."
                },
                "machinefixings": {
                    "weight": "Peso",
                    "recommended": "recomendado",
                    "readmore": "Leer más",
                    "machinefixing": "Acoplador de máquina",
                    "choosemachinefixing": "Seleccione un acoplador de máquina",
                    "attachment":"Bastidor de fijación",
                    "chooseattachment": "Seleccione un bastidor de fijación",
                    "continuewithout": "Continuar sin acoplador de máquina",
                    "choosedirectmount": "Seleccione una fijación directa",
                    "choosesfixing": "Seleccione acoplador S",
                    "chooseqcfixing": "Seleccione un acoplador QuickChange™",
                    "nomachinefixing": "Continuar sin seleccionar un acoplador de máquina",
                    "sfixing": {
                    "sfixing": "Acoplador S",
                    "weightfrom": "Peso, desde",
                    "maxallowedloadlifthook": "Carga máx. permitida, gancho de elevación",
                    "infotext": "Un acoplador estándar potente y robusto con un diseño compacto. Permite desconectar el rotor basculante durante trabajos más pesados, por ejemplo, cuando se utilizan martillos hidráulicos. Estos acopladores se basan en la serie S común."
                    },
                    "qcfixing": {
                        "qcfixing": "Acoplador QuickChange™",
                        "weightfrom": "Peso, desde",
                        "maxallowedloadlifthook": "Carga máx. permitida, gancho de elevación",
                        "numberofcouplers":"Número de acoplamientos, máx.",
                        "infotext": "QuickChange™ es el sistema de acoplador rápido totalmente automático de Rototilt. Es un accesorio inteligente que permite cambios automáticos de herramientas de trabajo hidráulicas sin tener que salir de la cabina de la excavadora."
                    },
                    "directmount": {
                        "directmount": "Fijación directa",
                        "infotext": "La fijación directa hace que el rotor basculante esté conectado directamente a la excavadora. Es la solución más ligera y compacta, adecuada para aplicaciones en las que nunca es necesario desconectar el rotor basculante."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Seleccione un acoplador rápido",
                        "toolattachment": "Acoplador rápido"
                    }
                },
                "tools": {
                    "readmore": "Leer más",
                    "categories": "categorías",
                    "tools": "Herramientas de trabajo",
                    "choosetools": "Seleccione una herramienta de trabajo",
                    "ourtools": "Nuestras herramientas de trabajo",
                    "disclamertools": "Las siguientes herramientas de trabajo son una recomendación general. Contacte con su distribuidor para adaptarla de forma precisa a su modelo de máquina.",
                    "number of results": "resultados para su excavadora",
                    "results": "Resultados",
                    "buckets": "Cucharones",
                    "choise": "Variante",
                    "choises": "Variantes",
                    "weight": "Peso",
                    "bucket": {
                        "bucket": "Cucharón",
                        "articlenumber": "Número de artículo",
                        "width": "Anchura",
                        "volume": "Volumen"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Cucharón de excavación",
                        "articlenumber": "Número de artículo",
                        "width": "Anchura",
                        "volume": "Volumen",
                        "toothtype": "Tipo de diente"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Cuchara para zanjas",
                        "articlenumber": "Número de artículo",
                        "width": "Anchura",
                        "volume": "Volumen"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Cuchara de clasificación",
                        "articlenumber": "Número de artículo",
                        "width": "Anchura",
                        "volume": "Volumen"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Cuchara universal",
                        "articlenumber": "Número de artículo",
                        "width": "Anchura",
                        "volume": "Volumen"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "¿Quiere añadir un módulo de garras?",
                        "continuewithout": "Continuar sin módulo de garras",
                        "grapplemodule": "Módulo de garras",
                        "weight": "Peso",
                        "liftingcapacitymax": "Capacidad de elevación, máx."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Grapa ferroviaria",
                        "weight": "Peso",
                        "liftingcapacitymax": "Capacidad de elevación, máx."
                    },
                    "grapple": {
                        "grapple": "Garras",
                        "grappleforcemax": "Fuerza de agarre, máx.",
                        "grapplewidthmax": "Anchura de la garra, máx."
                    },
                    "grappletypes": {
                        "multigrapple": "garras múltiples",
                        "stonegrapple":"garra de piedra",
                        "sortinggrapple": "garra de clasificación"
                    },
                    "compactor": {
                        "compactor": "Compactador",
                        "weight": "Peso",
                        "vibrationforce": "Fuerza de vibración"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Viga de nivelación",
                        "weight": "Peso",
                        "width": "Anchura"
                    },
                    "ripper": {
                        "ripper": "Diente ripper",
                        "weight": "Peso",
                        "toothradius": "Radio del diente"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Cortadores de asfalto",
                        "weight": "Peso",
                        "cutdepth": "Profundidad de corte"
                    },
                    "toolmount": {
                        "toolmount": "Bastidores de fijación de herramientas"
                    }
                },
                "optionalstep": {
                    "yourmachine": "modelo de su máquina",
                    "yourmachineweight": "peso de su máquina",
                    "optionalstep": "Opcional",
                    "introweight": "¿Quiere añadir más productos que se ajusten a ",
                    "intromachine": "¿Quiere añadir más productos que se ajusten a ",
                    "introaftervalue":"Descubra nuestra gama o continúe con el siguiente paso."
                },
                "yourchoises": {
                    "yourchoises": "Su selección",
                    "yourchoisesintro": "Rellene sus datos y revise su selección. Cuando haya terminado, se enviará su resumen a un representante de Rototilt, que se pondrá en contacto con usted lo antes posible.",
                    "yourinformation": "Rellene sus datos",
                   "viewretailers": "Consulte los distribuidores",
                    "reviewchoises": "Revise su selección",
                    "products": "productos"

                },
                "contactusform": {
                    "firstname": "Nombre",
                    "firstnamemandatory": "Introduzca su nombre",
                    "locationinvalid": "Introduzca únicamente letras",		
                    "firstnameinvalid": "Introduzca únicamente letras",
                    "lastname": "Apellidos",
                    "lastnamemandatory": "Introduzca sus apellidos",
                    "lastnameinvalid": "Introduzca únicamente letras",
                    "email": "Dirección de correo electrónico",
                    "emailmandatory": "Introduzca su dirección de correo electrónico",
                    "emailinvalid": "Dirección de correo electrónico no válida",
                    "phone": "Número de teléfono",
                    "phonemandatory": "Introduzca su número de teléfono",
                    "phoneinvalid": "Número de teléfono no válido",
                    "city": "Ciudad",
                    "zip": "Código postal",
                    "country:": "País",
                    "countrymandatory:": "Introduzca su país",
                    "message": "Añadir un mensaje (opcional)",
                    "contactus": "Enviar", 
                    "checkboxintegrity": "Doy mi consentimiento para que Rototilt Group AB procese mis datos personales de acuerdo con su ",
                    "checkboxintegritylink": "política de datos personales.",	
                    "checkboxnews": "Me gustaría recibir noticias y ofertas de Rototilt.",
                    "share": {
                        "share": "Compartir",
                        "close": "Cerrar",
                        "copylink": "Copiar enlace",
                        "info": "Utilice este vínculo para compartir o guardar la configuración"
                    }
                },
                "endpage": {
                    "welldone": "¡Bravo!",
                    "gotoweb": "Haga clic aquí para visitar nuestro sitio web",	
                    "endpageinfo": "Un representante de Rototilt se pondrá en contacto con usted lo antes posible. Recibirá en su correo electrónico una confirmación con un enlace de su selección."
                },
                "disclamer": {
                    "disclamertext": "Rogamos disculpe cualquier error tipográfico u ortográfico que pudiera haber. Nos reservamos el derecho a modificar las especificaciones sin previo aviso. Pueden producirse variaciones en las gamas de productos y en los estándares de equipamiento entre los distintos mercados. Para obtener más información sobre las especificaciones actuales de los productos, las adaptaciones locales y los equipos especiales, póngase en contacto con su distribuidor de Rototilt más cercano."
                },
                "url": {
                   "productguide": "guía de productos",
                   "machinetonnage": "peso de la máquina",
                   "product": "producto",
                   "optional": "opcional",
                   "contactus": "contacte con nosotros",
                   "thankyou": "gracias" 
                },
                "wizard": {
                    "marketstep": "Comenzar",
                    "machinetonnagestep": "Máquina y peso",
                    "productstep": "Productos",
                    "otheroptionsstep": "Opcional",
                    "contactusstep": "Su selección"
                },
                "cart": {
                    "yourproducts": "Sus productos"
                },
                "footer": {
                    "previous": "Anterior",
                    "next": "Siguiente"
                },
                "topbar": {
                    "products": "Productos"
                },
                "popup": {
                    "areyousure": "Si realiza cambios, se borrará su selección. ¿Seguro que quiere continuar?",
                    "important": "¡Importante!",
                    "cancel": "Cancelar",
                    "clearchoises": "Borrar mi selección",
                    "stay": "Permanecer en la página"
                },
                "thankyoumail": {
                    "subject": "Asunto: Gracias por ponerse en contacto con nosotros",
                    "hello": "Hola:",
                    "intro": "Hemos recibido su selección de la guía de productos de Rototilt. Un representante de Rototilt se pondrá en contacto con usted lo antes posible. De momento, puede hacer clic en el enlace que aparece a continuación para ver un resumen de su selección.",
                    "summary": "Su recopilación",
                    "signature": "Atentamente,",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Más información en www.rototilt.com"
                }
            },
            "fi-FI": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnia",
                    "kg": " kg",
                    "inches": "tuumaa",
                    "pounds": "lbs",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "kpl"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt-tuoteopas - Sovita yhteen kaivukoneesi kanssa",
                        "text": "Tervetuloa Rototiltin tuoteoppaaseen. Täältä löydät helposti oman kaivukonemallisi kanssa yhteensopivat Rototilt-tuotteet.",
                        "keywords": "rototilt-tuoteopas, rototilt-tuotekonfiguraattori",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Valitse markkina",
                        "change": "muuta",
                        "sv-SE": "Ruotsi",
                        "da-DK": "Tanska",
                        "en-GB": "Iso-Britannia",
                        "fi-FI": "Suomi",
                        "fr-FR": "Ranska",
                        "de-DE": "Saksa",
                        "nb-NO": "Norja",
                        "en-US": "Yhdysvallat",
                        "en-CA": "Kanada (englanti)",   
                        "en-NZ": "Uusi-Seelanti",	
                        "fr-CA": "Kanada (ranska)",
                        "en": "Globaali",
                        "pl-PL": "Puola",
                        "nl-NL": "Alankomaat",
                        "es-ES": "Espanja",
                        "en-AU": "Australia",
                        "ja-JP": "Japani",
                        "ko-KR": "Etelä-Korea"
                    },
                    "markettexts": {
                        "marketheader": "Tervetuloa Rototiltin tuoteoppaaseen",
                        "marketintro": "Täältä löydät helposti tietyn kaivinkonemallin kanssa yhteensopivat Rototilt-tuotteet. Antamalla koneesi mallin tai painon voit valita suositelluista tuotteista ja rakentaa oman rototilttijärjestelmän. Aloita valitsemalla markkina-alueesi.",
                        "chosemarketheader": "Valitse markkina-alueesi",
                        "choosebetween": "Valitse näistä",
                        "markets": "Markkinat",
                        "marketnotfound": "Jos et löydä markkina--aluettasi, valitse ”Globaali”.",
                        "searchmarket": "Etsi markkina-alueistamme",
                        "choosemarket": "Valitse markkina"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Kone ja paino",
                        "machinetonnageintro": "Mahdollisimman hyvien tuotesuositusten saamiseksi kaivukonettasi varten valitse sen malli tai ilmoita sen paino.",
                        "findmachine": "Etsi koneesi",
                        "findmachinetext1":"Valitsemalla kaivukoneesi mallin saat tuotesuositukset sitä varten.",
                        "findmachinetext2":"Valitsemalla kaivukoneesi mallin saat tuotesuositukset sitä varten. Jos et löydä oikeaa mallia, valitse koneen paino.",
                        "searchplaceholder": "Etsi merkki ja malli",
                        "switchtotonnage": "Vaihda koneen painoon",
                        "picktonnage": "Anna koneesi paino",
                        "picktonnagetext1":"Antamalla kaivukoneesi painon saat tuotesuositukset sitä varten.",
                        "picktonnagetext2":"Antamalla kaivukoneesi painon saat tuotesuositukset sitä varten. Voit myös vaihtaa konemalliin. ",
                        "choosetonnage": "Anna koneesi paino",
                        "tonnagehelpertext":"Voit arvioida painon likimääräisesti.",
                        "switchtomachine":"Vaihda koneen malliin",
                        "loadingMessage": "Etsimme konettasi...",
                        "noOptionsMessage": "Etsi konettasi..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Tuotteet",
                        "productintro": "Mistä tuotteista olet kiinnostunut? Valitse ensin tuoteluokka. Voit lisätä tuotteita ja muuttaa myöhemmin valintojasi.",
                        "chooseproductcategory": "Valitse tuoteluokka"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Rototiltti",
                    "tiltrotators": "Rototiltit",
                    "choosetiltrotator": "Valitse rototiltti",
                    "recomended": "Suositellaan",
                    "breakforcemax": "Murtovoima, maks.",
                    "bucketwidthmax": "Kauhan leveys, maks."
                },
                "machinefixings": {
                    "weight": "Paino",
                    "recommended": "suositellaan",
                    "readmore": "Lue lisää",
                    "machinefixing": "Pikaliitin",
                    "choosemachinefixing": "Valitse pikaliitin",
                    "attachment":"Kiinnike",
                    "chooseattachment": "Valitse kiinnike",
                    "continuewithout": "Jatka ilman kiinnikettä",
                    "choosedirectmount": "Valitse suorakiinnitys",
                    "choosesfixing": "Valitse S-kiinnike",
                    "chooseqcfixing": "Valitse QuickChange™-kiinnike",
                    "nomachinefixing": "Jatka valitsematta kiinnikettä",
                    "sfixing": {
                    "sfixing": "S-kiinnike",
                    "weightfrom": "Paino alk.",
                    "maxallowedloadlifthook": "Suurin sallittu kuorma, nostokoukku",
                    "infotext": "Luja ja kestävä, rakenteeltaan kompakti vakiokiinnike. Rototiltti voidaan kytkeä pois käytöstä raskaampien töiden ajaksi esimerkiksi käytettäessä hydraulivasaraa. Nämä kiinnikkeet perustuvat yhteiseen S-standardiin."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™-kiinnike",
                        "weightfrom": "Paino alk.",
                        "maxallowedloadlifthook": "Suurin sallittu kuorma, nostokoukku",
                        "numberofcouplers":"Liitinten enimmäismäärä",
                        "infotext": "QuickChange™ on Rototiltin täysautomaattinen pikakiinnitysjärjestelmä. Se on älykäs lisäominaisuus, joka mahdollistaa hydraulisten työlaitteiden automaattisen vaihdon tarvitsematta poistua kaivukoneen ohjaamosta."
                    },
                    "directmount": {
                        "directmount": "Suorakiinnitys",
                        "infotext": "Suorakiinnitys tarkoittaa rototiltin kiinnitystä suoraan kaivukoneeseen. Se on kevyin ja kompaktein ratkaisu sovelluksiin, joissa rototilttiä ei tarvitse missään tilanteessa kytkeä pois päältä."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Valitse työlaitekiinnike",
                        "toolattachment": "Työlaitekiinnike"
                    }
                },
                "tools": {
                    "readmore": "Lue lisää",
                    "tools": "Työlaite",
                    "choosetools": "Valitse työlaite",
                    "ourtools": "Työlaitteemme",
                    "categories": "luokat",
                    "disclamertools": "Seuraavassa luetellut työlaitteet ovat yleinen suositus. Kysy jälleenmyyjältäsi tarkka soveltuvuus konemalliisi.",
                    "number of results": "tulokset kaivukoneellesi",
                    "results": "Tulokset",
                    "buckets": "Kauhat",
                    "choise": "Muunnos",
                    "choises": "Muunnokset",
                    "weight": "Paino",
                    "bucket": {
                        "bucket": "Kauha",
                        "articlenumber": "Tuotenumero",
                        "width": "Leveys",
                        "volume": "Tilavuus"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Kaivuukauha",
                        "articlenumber": "Tuotenumero",
                        "width": "Leveys",
                        "volume": "Tilavuus",
                        "toothtype": "Hammastyyppi"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Kanavakauha",
                        "articlenumber": "Tuotenumero",
                        "width": "Leveys",
                        "volume": "Tilavuus"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Lajittelukauha",
                        "articlenumber": "Tuotenumero",
                        "width": "Leveys",
                        "volume": "Tilavuus"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Luiskakauha",
                        "articlenumber": "Tuotenumero",
                        "width": "Leveys",
                        "volume": "Tilavuus"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Haluatko lisätä pihtimoduulin?",
                        "continuewithout": "Jatka ilman pihtimoduulia",
                        "grapplemodule": "Pihtimoduuli",
                        "weight": "Paino",
                        "liftingcapacitymax": "Nostokapasiteetti maks."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Rautatiekoura",
                        "weight": "Paino",
                        "liftingcapacitymax": "Nostokapasiteetti maks."
                    },
                    "grapple": {
                        "grapple": "Kourat",
                        "grappleforcemax": "Tartuntavoima maks.",
                        "grapplewidthmax": "Tarttumaleveys maks."
                    },
                    "grappletypes": {
                        "multigrapple": "yleiskoura",
                        "stonegrapple":"kivikoura",
                        "sortinggrapple": "lajittelukoura"
                    },
                    "compactor": {
                        "compactor": "Tärylevy",
                        "weight": "Paino",
                        "vibrationforce": "Täryvoima"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Tasauspalkki",
                        "weight": "Paino",
                        "width": "Leveys"
                    },
                    "ripper": {
                        "ripper": "Routapiikki",
                        "weight": "Paino",
                        "toothradius": "Hampaan säde"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asfalttileikkuri",
                        "weight": "Paino",
                        "cutdepth": "Leikkaussyvyys"
                    },
                    "toolmount": {
                        "toolmount": "Työlaitekiinnike"
                    }
                },
                "optionalstep": {
                    "yourmachine": "koneesi malli",
                    "yourmachineweight": "koneesi paino",
                    "optionalstep": "Valinnainen",
                    "introweight": "Haluatko nähdä lisää yhteensopivia tuotteita ",
                    "intromachine": "Haluatko nähdä lisää yhteensopivia tuotteita ",
                    "introaftervalue":"Tutustu valikoimaamme tai jatka seuraavaan vaiheeseen."
                },
                "yourchoises": {
                    "yourchoises": "Valintasi",
                    "yourchoisesintro": "Anna tietosi ja tarkista valintasi. Kun olet valmis, kokoonpanosi lähetetään Rototiltin edustajalle, joka ottaa sinuun pikaisesti yhteyttä.",
                    "yourinformation": "Anna tietosi",
                   "viewretailers": "Katso jälleenmyyjä",
                    "reviewchoises": "Tarkista valintasi",
                    "products": "tuotteet"

                },
                "contactusform": {
                    "firstname": "Etunimi",
                    "firstnamemandatory": "Anna etunimesi",
                    "firstnameinvalid": "Käytä vain etukirjaimia",
                    "locationinvalid": "Käytä vain etukirjaimia",		
                    "lastname": "Sukunimi",
                    "lastnamemandatory": "Anna sukunimesi",
                    "lastnameinvalid": "Käytä vain etukirjaimia",
                    "email": "Sähköpostiosoite",
                    "emailmandatory": "Anna sähköpostiosoitteesi",
                    "emailinvalid": "Sähköpostiosoite ei kelpaa",
                    "phone": "Puhelinnumero",
                    "phonemandatory": "Anna puhelinnumerosi",
                    "phoneinvalid": "Puhelinnumero ei kelpaa",
                    "city": "Paikkakunta",
                    "zip": "Postinumero",
                    "country:": "Maa",
                    "countrymandatory:": "Anna maa",
                    "message": "Lisää viesti (valinnainen)",
                    "contactus": "Lähetä", 
                    "checkboxintegrity": "Annan Rototilt Group AB:lle luvan käsitellä henkilötietojani ",
                    "checkboxintegritylink": "tietosuojakäytäntönsä mukaisesti.",	
                    "checkboxnews": "Haluan, että Rototilt lähettää minulle uutisia ja tarjouksia.",
                    "share": {
                        "share": "Lähetä",
                        "close": "Sulje",
                        "copylink": "Kopioi linkki",
                        "info": "Tämän linkin avulla voit jakaa tai tallentaa kokoonpanosi"
                    }
                },
                "endpage": {
                    "welldone": "Hyvin tehty!",
                    "gotoweb": "Napsauttamalla tätä voit siirtyä verkkosivustollemme",	
                    "endpageinfo": "Rototiltin edustaja ottaa sinuun pikaisesti yhteyttä. Sähköpostiisi on lähetetty vahvistus, jossa on linkki valintoihisi."
                },
                "disclamer": {
                    "disclamertext": "Pidätämme oikeuden paino- tai kirjoitusvirheiden ja mahdollisten tahattomien virheiden varalta sekä pidätämme oikeuden teknisten tietojen muutoksiin ilman ennakkoilmoitusta. Tuotevalikoimat ja laitestandardit voivat vaihdella markkinoiden välillä . Lisätietoja ajantasaisista tuotetiedoista, paikallisista mukautuksista ja erityisvarusteista saat lähimmältä Rototilt-jälleenmyyjältäsi."
                },
                "url": {
                   "productguide": "tuoteopas",
                   "machinetonnage": "koneen paino",
                   "product": "tuote",
                   "optional": "valinnainen",
                   "contactus": "ota yhteyttä",
                   "thankyou": "kiitos" 
                },
                "wizard": {
                    "marketstep": "Alku",
                    "machinetonnagestep": "Kone ja paino",
                    "productstep": "Tuotteet",
                    "otheroptionsstep": "Valinnainen",
                    "contactusstep": "Valintasi"
                },
                "cart": {
                    "yourproducts": "Tuotteesi"
                },
                "footer": {
                    "previous": "Edellinen",
                    "next": "Seuraava"
                },
                "topbar": {
                    "products": "Tuotteet"
                },
                "popup": {
                    "areyousure": "Jos teet muutoksia, valintasi poistuvat. Haluatko varmasti jatkaa?",
                    "important": "Tärkeää!",
                    "cancel": "Keskeytä",
                    "clearchoises": "Poista valintani",
                    "stay": "Pysy sivulla"
                },
                "thankyoumail": {
                    "subject": "Aihe: Kiitos yhteydenotostasi",
                    "hello": "Hei",
                    "intro": "Olemme vastaanottaneet valintasi Rototiltin tuoteoppaasta. Rototiltin edustaja ottaa sinuun pikaisesti yhteyttä. Tässä vaiheessa voit nähdä yhteenvedon valinnoistasi napsauttamalla alla olevaa linkkiä.",
                    "summary": "Kokoonpanosi",
                    "signature": "Ystävällisin terveisin",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Lue lisää osoitteessa www.rototilt.com"
                }
            },
            "fr-FR": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pièces"
                },
                "seo": {
                    "startpage": {
                        "titel": "Guide de produits Rototilt - Trouvez produits correspondant à votre pelle",
                        "text": "Bienvenue dans le guide de produits Rototilt. Ici, vous pouvez facilement trouver les produits Rototilt qui conviennent à votre modèle de pelle.",
                        "keywords": "guide de produits rototilt, configurateur de produits rototilt",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Choisir le marché",
                        "change": "changer",
                        "sv-SE": "Suède",
                        "da-DK": "Danemark",
                        "en-GB": "Royaume-Uni",
                        "fi-FI": "Finlande",
                        "fr-FR": "France",
                        "de-DE": "Allemagne",
                        "nb-NO": "Norvège",
                        "en-US": "États-Unis",
                        "en-CA": "Canada (Anglais)",   
                        "en-NZ": "Nouvelle-Zélande",	
                        "fr-CA": "Canada (Français)",
                        "en": "Global",
                        "pl-PL": "Pologne",
                        "nl-NL": "Pays-Bas",
                        "es-ES": "Espagne",
                        "en-AU": "Australie",
                        "ja-JP": "Japon",
                        "ko-KR": "Corée du Sud"
                    },
                    "markettexts": {
                        "marketheader": "Bienvenue dans le guide de produits Rototilt",
                        "marketintro": "Vous pouvez ici trouver facilement des produits Rototilt qui correspondent à un modèle de pelle spécifique. Indiquez le modèle et le poids de votre machine et vous pourrez choisir parmi les produits recommandés pour construire votre propre système de tiltrotateur. Pour commencer, choisissez votre marché.",
                        "chosemarketheader": "Choisissez votre marché",
                        "choosebetween": "Choisir parmi",
                        "markets": "Marchés",
                        "marketnotfound": "Si vous ne trouvez pas votre marché, sélectionnez « Global ».",
                        "searchmarket": "Rechercher dans nos marchés",
                        "choosemarket": "Choisir le marché"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine et poids",
                        "machinetonnageintro": "Pour obtenir les meilleures recommandations de produits possibles pour votre machine, sélectionnez le modèle de votre pelle ou indiquez-en le poids.",
                        "findmachine": "Trouvez votre machine",
                        "findmachinetext1":"Sélectionnez le modèle de votre pelle pour obtenir des recommandations de produits.",
                        "findmachinetext2":"Sélectionnez le modèle de votre pelle pour obtenir des recommandations de produits. Si vous ne trouvez pas votre modèle, passez au poids de la machine.",
                        "searchplaceholder": "Rechercher marque et modèle",
                        "switchtotonnage": "Passer au poids de la machine",
                        "picktonnage": "Entrez le poids de votre machine",
                        "picktonnagetext1":"Indiquez le poids pour obtenir des recommandations de produits correspondant à votre pelle.",
                        "picktonnagetext2":"Indiquez le poids pour obtenir des recommandations de produits correspondant à votre pelle. Vous pouvez également passer au modèle de machine. ",
                        "choosetonnage": "Entrez le poids de votre machine",
                        "tonnagehelpertext":"Vous pouvez indiquer une estimation approximative.",
                        "switchtomachine":"Passer au modèle de machine",
                        "loadingMessage": "Nous recherchons votre machine...",
                        "noOptionsMessage": "Recherche de votre machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produits",
                        "productintro": "Quels produits vous intéressent ? Pour commencer, sélectionnez une catégorie de produits. Vous pourrez ajouter d’autres produits et modifier vos sélections plus tard.",
                        "chooseproductcategory": "Choisir une catégorie de produits"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotateur",
                    "tiltrotators": "Tiltrotateurs",
                    "choosetiltrotator": "Choisir un tiltrotateur",
                    "recomended": "Recommandé",
                    "breakforcemax": "Force de rupture, max.",
                    "bucketwidthmax": "Largeur du godet, max."
                },
                "machinefixings": {
                    "weight": "Poids",
                    "recommended": "recommandé",
                    "readmore": "En savoir plus",
                    "machinefixing": "Attache rapide machine",
                    "choosemachinefixing": "Choisir une attache rapide machine",
                    "attachment":"Cadre de fixation",
                    "chooseattachment": "Choisir un cadre de fixation",
                    "continuewithout": "Continuer sans attache rapide machine",
                    "choosedirectmount": "Choisir un cadre de fixation direct",
                    "choosesfixing": "Choisir une attache S",
                    "chooseqcfixing": "Choisir une attache QuickChange™",
                    "nomachinefixing": "Continuer sans choisir d’attache rapide machine",
                    "sfixing": {
                    "sfixing": "Attache S",
                    "weightfrom": "Poids, à partir de",
                    "maxallowedloadlifthook": "Charge max. autorisée, crochet de levage",
                    "infotext": "Une attache standard puissante et robuste de conception compacte. Permet de déconnecter le tiltrotateur pour les travaux plus lourds, par exemple lors de l’utilisation d’un marteau hydraulique. Ces attaches sont basées sur la norme S commune."
                    },
                    "qcfixing": {
                        "qcfixing": "Attache QuickChange™",
                        "weightfrom": "Poids, à partir de",
                        "maxallowedloadlifthook": "Charge max. autorisée, crochet de levage",
                        "numberofcouplers":"Nombre de raccords, max.",
                        "infotext": "QuickChange™ est le système de couplage automatique de Rototilt. Cette solution intelligente permet de changer automatiquement l’outil hydraulique sans sortir de la cabine de la pelle."
                    },
                    "directmount": {
                        "directmount": "Cadre de fixation direct",
                        "infotext": "Un cadre de fixation direct signifie que le tiltrotateur est fixé directement sur la pelle. C’est la solution la plus légère et la plus compacte, idéale pour les applications où il n’est jamais nécessaire de déconnecter le tiltrotateur."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Choisir une attache rapide",
                        "toolattachment": "Attache rapide"
                    }
                },
                "tools": {
                    "readmore": "En savoir plus",
                    "categories": "catégories",
                    "tools": "Outils",
                    "choosetools": "Choisir des outils",
                    "ourtools": "Nos outils",
                    "disclamertools": "Les outils ci-dessous sont une recommandation générale. Consultez votre revendeur qui vous conseillera des produits parfaitement adaptés à votre modèle de machine.",
                    "number of results": "résultat pour votre pelle",
                    "results": "Résultat",
                    "buckets": "Godets",
                    "choise": "Variante",
                    "choises": "Variantes",
                    "weight": "Poids",
                    "bucket": {
                        "bucket": "Godet",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Godet de terrassement",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume",
                        "toothtype": "Type de dents"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Godet de tranchée",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Godet de tri",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Godet de finition",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Voulez-vous ajouter un module pince ?",
                        "continuewithout": "Continuer sans module pince",
                        "grapplemodule": "Module pince",
                        "weight": "Poids",
                        "liftingcapacitymax": "Capacité de levage, max."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Module pince pour travaux ferroviaires",
                        "weight": "Poids",
                        "liftingcapacitymax": "Capacité de levage, max."
                    },
                    "grapple": {
                        "grapple": "Pinces/grappins",
                        "grappleforcemax": "Force de préhension, max.",
                        "grapplewidthmax": "Largeur de préhension, max."
                    },
                    "grappletypes": {
                        "multigrapple": "grappin multi-usage",
                        "stonegrapple":"pince d'enrochement",
                        "sortinggrapple": "pince de tri"
                    },
                    "compactor": {
                        "compactor": "Plaque de compactage",
                        "weight": "Poids",
                        "vibrationforce": "Force de vibration"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Lame de nivelage",
                        "weight": "Poids",
                        "width": "Largeur"
                    },
                    "ripper": {
                        "ripper": "Dent de défonçage",
                        "weight": "Poids",
                        "toothradius": "Rayon de dent"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Disque pour enrobés",
                        "weight": "Poids",
                        "cutdepth": "Profondeur de coupe"
                    },
                    "toolmount": {
                        "toolmount": "Cadre de fixation d’outil"
                    }
                },
                "optionalstep": {
                    "yourmachine": "votre modèle de machine",
                    "yourmachineweight": "poids de votre machine",
                    "optionalstep": "Options",
                    "introweight": "Voulez-vous ajouter d’autres produits correspondants ? ",
                    "intromachine": "Voulez-vous ajouter d’autres produits correspondants ? ",
                    "introaftervalue":"Découvrez notre gamme ou passez à l’étape suivante."
                },
                "yourchoises": {
                    "yourchoises": "Vos sélections",
                    "yourchoisesintro": "Renseignez vos coordonnées et vérifiez vos sélections. Votre récapitulatif sera ensuite envoyé à un représentant Rototilt qui vous contactera rapidement.",
                    "yourinformation": "Renseignez vos coordonnées",
                   "viewretailers": "Voir les revendeurs",
                    "reviewchoises": "Vérifiez vos sélections",
                    "products": "produits"

                },
                "contactusform": {
                    "firstname": "Prénom",
                    "locationinvalid": "Saisissez uniquement des lettres",	
                    "firstnamemandatory": "Entrez votre prénom",
                    "firstnameinvalid": "Saisissez uniquement des lettres",
                    "lastname": "Nom",
                    "lastnamemandatory": "Entrez votre nom",
                    "lastnameinvalid": "Saisissez uniquement des lettres",
                    "email": "Adresse e-mail",
                    "emailmandatory": "Entrez votre adresse e-mail",
                    "emailinvalid": "Adresse e-mail non valide",
                    "phone": "Numéro de téléphone",
                    "phonemandatory": "Entrez votre numéro de téléphone",
                    "phoneinvalid": "Numéro de téléphone non valide",
                    "city": "Ville",
                    "zip": "Code postal",
                    "country:": "Pays",
                    "countrymandatory:": "Entrez votre pays",
                    "message": "Ajouter un message (facultatif)",
                    "contactus": "Envoyer", 
                    "checkboxintegrity": "J’accepte que la société Rototilt Group AB traite mes données personnelles en accord avec sa ",
                    "checkboxintegritylink": "politique en matière de gestion des données personnelles.",	
                    "checkboxnews": "Je souhaite recevoir des actualités et offres de Rototilt.",
                    "share": {
                        "share": "Partager",
                        "close": "Fermer",
                        "copylink": "Copier le lien",
                        "info": "Utilisez ce lien pour partager ou sauvegarder votre configuration"
                    }
                },
                "endpage": {
                    "welldone": "Bon travail !",
                    "gotoweb": "Cliquez ici pour accéder à notre site Web",	
                    "endpageinfo": "Un représentant Rototilt vous contactera sous peu. Une confirmation accompagnée d’un lien vers vos sélections a été envoyée à votre adresse e-mail."
                },
                "disclamer": {
                    "disclamertext": "Nous nous réservons le droit de faire des fautes typographiques, erreurs linguistiques ou autres erreurs éventuelles susceptibles d’apparaître ainsi que de modifier les caractéristiques sans avis préalable. Il peut y avoir des variations de la gamme de produits et des normes d’équipement sur les différents marchés. Pour plus d’informations sur les caractéristiques actuelles des produits, les adaptations locales et les équipements spéciaux, contactez votre revendeur Rototilt le plus proche."
                },
                "url": {
                   "productguide": "guide des produits",
                   "machinetonnage": "poids-de-la-machine",
                   "product": "produit",
                   "optional": "options",
                   "contactus": "nous-contacter",
                   "thankyou": "merci" 
                },
                "wizard": {
                    "marketstep": "Démarrer",
                    "machinetonnagestep": "Machine et poids",
                    "productstep": "Produits",
                    "otheroptionsstep": "Options",
                    "contactusstep": "Vos sélections"
                },
                "cart": {
                    "yourproducts": "Vos produits"
                },
                "footer": {
                    "previous": "Précédent",
                    "next": "Suivant"
                },
                "topbar": {
                    "products": "Produits"
                },
                "popup": {
                    "areyousure": "Vos sélections seront effacées si vous modifiez. Voulez-vous vraiment continuer ?",
                    "important": "Important !",
                    "cancel": "Annuler",
                    "clearchoises": "Effacer mes sélections",
                    "stay": "Rester sur la page"
                },
                "thankyoumail": {
                    "subject": "Objet : Merci de nous avoir contactés",
                    "hello": "Bonjour",
                    "intro": "Nous avons reçu vos sélections dans le guide de produits Rototilt. Un représentant Rototilt vous contactera sous peu. En attendant, vous pouvez cliquer sur le lien ci-dessous pour voir un récapitulatif de vos sélections.",
                    "summary": "Votre récapitulatif",
                    "signature": "Cordialement",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Pour en savoir plus, rendez-vous sur www.rototilt.com"
                }
            },
            "fr-CA": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pièces"
                },
                "seo": {
                    "startpage": {
                        "titel": "Guide de produits Rototilt - Trouvez produits correspondant à votre pelle",
                        "text": "Bienvenue dans le guide de produits Rototilt. Ici, vous pouvez facilement trouver les produits Rototilt qui conviennent à votre modèle de pelle.",
                        "keywords": "guide de produits rototilt, configurateur de produits rototilt",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Choisir le marché",
                        "change": "changer",
                        "sv-SE": "Suède",
                        "da-DK": "Danemark",
                        "en-GB": "Royaume-Uni",
                        "fi-FI": "Finlande",
                        "fr-FR": "France",
                        "de-DE": "Allemagne",
                        "nb-NO": "Norvège",
                        "en-US": "États-Unis",
                        "en-CA": "Canada (Anglais)",   
                        "en-NZ": "Nouvelle-Zélande",	
                        "fr-CA": "Canada (Français)",
                        "en": "Global",
                        "pl-PL": "Pologne",
                        "nl-NL": "Pays-Bas",
                        "es-ES": "Espagne",
                        "en-AU": "Australie",
                        "ja-JP": "Japon",
                        "ko-KR": "Corée du Sud"
                    },
                    "markettexts": {
                        "marketheader": "Bienvenue dans le guide de produits Rototilt",
                        "marketintro": "Vous pouvez ici trouver facilement des produits Rototilt qui correspondent à un modèle de pelle spécifique. Indiquez le modèle et le poids de votre machine et vous pourrez choisir parmi les produits recommandés pour construire votre propre système de tiltrotateur. Pour commencer, choisissez votre marché.",
                        "chosemarketheader": "Choisissez votre marché",
                        "choosebetween": "Choisir parmi",
                        "markets": "Marchés",
                        "marketnotfound": "Si vous ne trouvez pas votre marché, sélectionnez « Global ».",
                        "searchmarket": "Rechercher dans nos marchés",
                        "choosemarket": "Choisir le marché"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine et poids",
                        "machinetonnageintro": "Pour obtenir les meilleures recommandations de produits possibles pour votre machine, sélectionnez le modèle de votre pelle ou indiquez-en le poids.",
                        "findmachine": "Trouvez votre machine",
                        "findmachinetext1":"Sélectionnez le modèle de votre pelle pour obtenir des recommandations de produits.",
                        "findmachinetext2":"Sélectionnez le modèle de votre pelle pour obtenir des recommandations de produits. Si vous ne trouvez pas votre modèle, passez au poids de la machine.",
                        "searchplaceholder": "Rechercher marque et modèle",
                        "switchtotonnage": "Passer au poids de la machine",
                        "picktonnage": "Entrez le poids de votre machine",
                        "picktonnagetext1":"Indiquez le poids pour obtenir des recommandations de produits correspondant à votre pelle.",
                        "picktonnagetext2":"Indiquez le poids pour obtenir des recommandations de produits correspondant à votre pelle. Vous pouvez également passer au modèle de machine. ",
                        "choosetonnage": "Entrez le poids de votre machine",
                        "tonnagehelpertext":"Vous pouvez indiquer une estimation approximative.",
                        "switchtomachine":"Passer au modèle de machine",
                        "loadingMessage": "Nous recherchons votre machine...",
                        "noOptionsMessage": "Recherche de votre machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produits",
                        "productintro": "Quels produits vous intéressent ? Pour commencer, sélectionnez une catégorie de produits. Vous pourrez ajouter d’autres produits et modifier vos sélections plus tard.",
                        "chooseproductcategory": "Choisir une catégorie de produits"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotateur",
                    "tiltrotators": "Tiltrotateurs",
                    "choosetiltrotator": "Choisir un tiltrotateur",
                    "recomended": "Recommandé",
                    "breakforcemax": "Force de rupture, max.",
                    "bucketwidthmax": "Largeur du godet, max."
                },
                "machinefixings": {
                    "weight": "Poids",
                    "recommended": "recommandé",
                    "readmore": "En savoir plus",
                    "machinefixing": "Attache rapide machine",
                    "choosemachinefixing": "Choisir une attache rapide machine",
                    "attachment":"Cadre de fixation",
                    "chooseattachment": "Choisir un cadre de fixation",
                    "continuewithout": "Continuer sans attache rapide machine",
                    "choosedirectmount": "Choisir un cadre de fixation direct",
                    "choosesfixing": "Choisir une attache S",
                    "chooseqcfixing": "Choisir une attache QuickChange™",
                    "nomachinefixing": "Continuer sans choisir d’attache rapide machine",
                    "sfixing": {
                    "sfixing": "Attache S",
                    "weightfrom": "Poids, à partir de",
                    "maxallowedloadlifthook": "Charge max. autorisée, crochet de levage",
                    "infotext": "Une attache standard puissante et robuste de conception compacte. Permet de déconnecter le tiltrotateur pour les travaux plus lourds, par exemple lors de l’utilisation d’un marteau hydraulique. Ces attaches sont basées sur la norme S commune."
                    },
                    "qcfixing": {
                        "qcfixing": "Attache QuickChange™",
                        "weightfrom": "Poids, à partir de",
                        "maxallowedloadlifthook": "Charge max. autorisée, crochet de levage",
                        "numberofcouplers":"Nombre de raccords, max.",
                        "infotext": "QuickChange™ est le système de couplage automatique de Rototilt. Cette solution intelligente permet de changer automatiquement l’outil hydraulique sans sortir de la cabine de la pelle."
                    },
                    "directmount": {
                        "directmount": "Cadre de fixation direct",
                        "infotext": "Un cadre de fixation direct signifie que le tiltrotateur est fixé directement sur la pelle. C’est la solution la plus légère et la plus compacte, idéale pour les applications où il n’est jamais nécessaire de déconnecter le tiltrotateur."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Choisir une attache rapide",
                        "toolattachment": "Attache rapide"
                    }
                },
                "tools": {
                    "readmore": "En savoir plus",
                    "tools": "Outils",
                    "categories": "catégories",
                    "choosetools": "Choisir des outils",
                    "ourtools": "Nos outils",
                    "disclamertools": "Les outils ci-dessous sont une recommandation générale. Consultez votre revendeur qui vous conseillera des produits parfaitement adaptés à votre modèle de machine.",
                    "number of results": "résultat pour votre pelle",
                    "results": "Résultat",
                    "buckets": "Godets",
                    "choise": "Variante",
                    "choises": "Variantes",
                    "weight": "Poids",
                    "bucket": {
                        "bucket": "Godet",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Godet de terrassement",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume",
                        "toothtype": "Type de dents"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Godet de tranchée",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Godet de tri",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Godet de finition",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Voulez-vous ajouter un module pince ?",
                        "continuewithout": "Continuer sans module pince",
                        "grapplemodule": "Module pince",
                        "weight": "Poids",
                        "liftingcapacitymax": "Capacité de levage, max."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Module pince pour travaux ferroviaires",
                        "weight": "Poids",
                        "liftingcapacitymax": "Capacité de levage, max."
                    },
                    "grapple": {
                        "grapple": "Pinces/grappins",
                        "grappleforcemax": "Force de préhension, max.",
                        "grapplewidthmax": "Largeur de préhension, max."
                    },
                    "grappletypes": {
                        "multigrapple": "grappin multi-usage",
                        "stonegrapple":"pince d'enrochement",
                        "sortinggrapple": "pince de tri"
                    },
                    "compactor": {
                        "compactor": "Plaque de compactage",
                        "weight": "Poids",
                        "vibrationforce": "Force de vibration"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Lame de nivelage",
                        "weight": "Poids",
                        "width": "Largeur"
                    },
                    "ripper": {
                        "ripper": "Dent de défonçage",
                        "weight": "Poids",
                        "toothradius": "Rayon de dent"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Disque pour enrobés",
                        "weight": "Poids",
                        "cutdepth": "Profondeur de coupe"
                    },
                    "toolmount": {
                        "toolmount": "Cadre de fixation d’outil"
                    }
                },
                "optionalstep": {
                    "yourmachine": "votre modèle de machine",
                    "yourmachineweight": "poids de votre machine",
                    "optionalstep": "Options",
                    "introweight": "Voulez-vous ajouter d’autres produits correspondants ? ",
                    "intromachine": "Voulez-vous ajouter d’autres produits correspondants ? ",
                    "introaftervalue":"Découvrez notre gamme ou passez à l’étape suivante."
                },
                "yourchoises": {
                    "yourchoises": "Vos sélections",
                    "yourchoisesintro": "Renseignez vos coordonnées et vérifiez vos sélections. Votre récapitulatif sera ensuite envoyé à un représentant Rototilt qui vous contactera rapidement.",
                    "yourinformation": "Renseignez vos coordonnées",
                   "viewretailers": "Voir les revendeurs",
                    "reviewchoises": "Vérifiez vos sélections",
                    "products": "produits"

                },
                "contactusform": {
                    "firstname": "Prénom",
                    "locationinvalid": "Saisissez uniquement des lettres",	
                    "firstnamemandatory": "Entrez votre prénom",
                    "firstnameinvalid": "Saisissez uniquement des lettres",
                    "lastname": "Nom",
                    "lastnamemandatory": "Entrez votre nom",
                    "lastnameinvalid": "Saisissez uniquement des lettres",
                    "email": "Adresse e-mail",
                    "emailmandatory": "Entrez votre adresse e-mail",
                    "emailinvalid": "Adresse e-mail non valide",
                    "phone": "Numéro de téléphone",
                    "phonemandatory": "Entrez votre numéro de téléphone",
                    "phoneinvalid": "Numéro de téléphone non valide",
                    "city": "Ville",
                    "zip": "Code postal",
                    "country:": "Pays",
                    "countrymandatory:": "Entrez votre pays",
                    "message": "Ajouter un message (facultatif)",
                    "contactus": "Envoyer", 
                    "checkboxintegrity": "J’accepte que la société Rototilt Group AB traite mes données personnelles en accord avec sa ",
                    "checkboxintegritylink": "politique en matière de gestion des données personnelles.",	
                    "checkboxnews": "Je souhaite recevoir des actualités et offres de Rototilt.",
                    "share": {
                        "share": "Partager",
                        "close": "Fermer",
                        "copylink": "Copier le lien",
                        "info": "Utilisez ce lien pour partager ou sauvegarder votre configuration"
                    }
                },
                "endpage": {
                    "welldone": "Bon travail !",
                    "gotoweb": "Cliquez ici pour accéder à notre site Web",	
                    "endpageinfo": "Un représentant Rototilt vous contactera sous peu. Une confirmation accompagnée d’un lien vers vos sélections a été envoyée à votre adresse e-mail."
                },
                "disclamer": {
                    "disclamertext": "Nous nous réservons le droit de faire des fautes typographiques, erreurs linguistiques ou autres erreurs éventuelles susceptibles d’apparaître ainsi que de modifier les caractéristiques sans avis préalable. Il peut y avoir des variations de la gamme de produits et des normes d’équipement sur les différents marchés. Pour plus d’informations sur les caractéristiques actuelles des produits, les adaptations locales et les équipements spéciaux, contactez votre revendeur Rototilt le plus proche."
                },
                "url": {
                   "productguide": "guide des produits",
                   "machinetonnage": "poids-de-la-machine",
                   "product": "produit",
                   "optional": "options",
                   "contactus": "nous-contacter",
                   "thankyou": "merci" 
                },
                "wizard": {
                    "marketstep": "Démarrer",
                    "machinetonnagestep": "Machine et poids",
                    "productstep": "Produits",
                    "otheroptionsstep": "Options",
                    "contactusstep": "Vos sélections"
                },
                "cart": {
                    "yourproducts": "Vos produits"
                },
                "footer": {
                    "previous": "Précédent",
                    "next": "Suivant"
                },
                "topbar": {
                    "products": "Produits"
                },
                "popup": {
                    "areyousure": "Vos sélections seront effacées si vous modifiez. Voulez-vous vraiment continuer ?",
                    "important": "Important !",
                    "cancel": "Annuler",
                    "clearchoises": "Effacer mes sélections",
                    "stay": "Rester sur la page"
                },
                "thankyoumail": {
                    "subject": "Objet : Merci de nous avoir contactés",
                    "hello": "Bonjour",
                    "intro": "Nous avons reçu vos sélections dans le guide de produits Rototilt. Un représentant Rototilt vous contactera sous peu. En attendant, vous pouvez cliquer sur le lien ci-dessous pour voir un récapitulatif de vos sélections.",
                    "summary": "Votre récapitulatif",
                    "signature": "Cordialement",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Pour en savoir plus, rendez-vous sur www.rototilt.com"
                }
            },
            "fr-BE": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonnes",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "pièces"
                },
                "seo": {
                    "startpage": {
                        "titel": "Guide de produits Rototilt - Trouvez produits correspondant à votre pelle",
                        "text": "Bienvenue dans le guide de produits Rototilt. Ici, vous pouvez facilement trouver les produits Rototilt qui conviennent à votre modèle de pelle.",
                        "keywords": "guide de produits rototilt, configurateur de produits rototilt",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Choisir le marché",
                        "change": "changer",
                        "sv-SE": "Suède",
                        "da-DK": "Danemark",
                        "en-GB": "Royaume-Uni",
                        "fi-FI": "Finlande",
                        "fr-FR": "France",
                        "de-DE": "Allemagne",
                        "nb-NO": "Norvège",
                        "en-US": "États-Unis",
                        "en-CA": "Canada (Anglais)",   
                        "en-NZ": "Nouvelle-Zélande",	
                        "fr-CA": "Canada (Français)",
                        "en": "Global",
                        "pl-PL": "Pologne",
                        "nl-NL": "Pays-Bas",
                        "es-ES": "Espagne",
                        "en-AU": "Australie",
                        "ja-JP": "Japon",
                        "ko-KR": "Corée du Sud"
                    },
                    "markettexts": {
                        "marketheader": "Bienvenue dans le guide de produits Rototilt",
                        "marketintro": "Vous pouvez ici trouver facilement des produits Rototilt qui correspondent à un modèle de pelle spécifique. Indiquez le modèle et le poids de votre machine et vous pourrez choisir parmi les produits recommandés pour construire votre propre système de tiltrotateur. Pour commencer, choisissez votre marché.",
                        "chosemarketheader": "Choisissez votre marché",
                        "choosebetween": "Choisir parmi",
                        "markets": "Marchés",
                        "marketnotfound": "Si vous ne trouvez pas votre marché, sélectionnez « Global ».",
                        "searchmarket": "Rechercher dans nos marchés",
                        "choosemarket": "Choisir le marché"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine et poids",
                        "machinetonnageintro": "Pour obtenir les meilleures recommandations de produits possibles pour votre machine, sélectionnez le modèle de votre pelle ou indiquez-en le poids.",
                        "findmachine": "Trouvez votre machine",
                        "findmachinetext1":"Sélectionnez le modèle de votre pelle pour obtenir des recommandations de produits.",
                        "findmachinetext2":"Sélectionnez le modèle de votre pelle pour obtenir des recommandations de produits. Si vous ne trouvez pas votre modèle, passez au poids de la machine.",
                        "searchplaceholder": "Rechercher marque et modèle",
                        "switchtotonnage": "Passer au poids de la machine",
                        "picktonnage": "Entrez le poids de votre machine",
                        "picktonnagetext1":"Indiquez le poids pour obtenir des recommandations de produits correspondant à votre pelle.",
                        "picktonnagetext2":"Indiquez le poids pour obtenir des recommandations de produits correspondant à votre pelle. Vous pouvez également passer au modèle de machine. ",
                        "choosetonnage": "Entrez le poids de votre machine",
                        "tonnagehelpertext":"Vous pouvez indiquer une estimation approximative.",
                        "switchtomachine":"Passer au modèle de machine",
                        "loadingMessage": "Nous recherchons votre machine...",
                        "noOptionsMessage": "Recherche de votre machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produits",
                        "productintro": "Quels produits vous intéressent ? Pour commencer, sélectionnez une catégorie de produits. Vous pourrez ajouter d’autres produits et modifier vos sélections plus tard.",
                        "chooseproductcategory": "Choisir une catégorie de produits"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotateur",
                    "tiltrotators": "Tiltrotateurs",
                    "choosetiltrotator": "Choisir un tiltrotateur",
                    "recomended": "Recommandé",
                    "breakforcemax": "Force de rupture, max.",
                    "bucketwidthmax": "Largeur du godet, max."
                },
                "machinefixings": {
                    "weight": "Poids",
                    "recommended": "recommandé",
                    "readmore": "En savoir plus",
                    "machinefixing": "Attache rapide machine",
                    "choosemachinefixing": "Choisir une attache rapide machine",
                    "attachment":"Cadre de fixation",
                    "chooseattachment": "Choisir un cadre de fixation",
                    "continuewithout": "Continuer sans attache rapide machine",
                    "choosedirectmount": "Choisir un cadre de fixation direct",
                    "choosesfixing": "Choisir une attache S",
                    "chooseqcfixing": "Choisir une attache QuickChange™",
                    "nomachinefixing": "Continuer sans choisir d’attache rapide machine",
                    "sfixing": {
                    "sfixing": "Attache S",
                    "weightfrom": "Poids, à partir de",
                    "maxallowedloadlifthook": "Charge max. autorisée, crochet de levage",
                    "infotext": "Une attache standard puissante et robuste de conception compacte. Permet de déconnecter le tiltrotateur pour les travaux plus lourds, par exemple lors de l’utilisation d’un marteau hydraulique. Ces attaches sont basées sur la norme S commune."
                    },
                    "qcfixing": {
                        "qcfixing": "Attache QuickChange™",
                        "weightfrom": "Poids, à partir de",
                        "maxallowedloadlifthook": "Charge max. autorisée, crochet de levage",
                        "numberofcouplers":"Nombre de raccords, max.",
                        "infotext": "QuickChange™ est le système de couplage automatique de Rototilt. Cette solution intelligente permet de changer automatiquement l’outil hydraulique sans sortir de la cabine de la pelle."
                    },
                    "directmount": {
                        "directmount": "Cadre de fixation direct",
                        "infotext": "Un cadre de fixation direct signifie que le tiltrotateur est fixé directement sur la pelle. C’est la solution la plus légère et la plus compacte, idéale pour les applications où il n’est jamais nécessaire de déconnecter le tiltrotateur."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Choisir une attache rapide",
                        "toolattachment": "Attache rapide"
                    }
                },
                "tools": {
                    "readmore": "En savoir plus",
                    "categories": "catégories",
                    "tools": "Outils",
                    "choosetools": "Choisir des outils",
                    "ourtools": "Nos outils",
                    "disclamertools": "Les outils ci-dessous sont une recommandation générale. Consultez votre revendeur qui vous conseillera des produits parfaitement adaptés à votre modèle de machine.",
                    "number of results": "résultat pour votre pelle",
                    "results": "Résultat",
                    "buckets": "Godets",
                    "choise": "Variante",
                    "choises": "Variantes",
                    "weight": "Poids",
                    "bucket": {
                        "bucket": "Godet",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Godet de terrassement",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume",
                        "toothtype": "Type de dents"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Godet de tranchée",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Godet de tri",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Godet de finition",
                        "articlenumber": "Numéro d’article",
                        "width": "Largeur",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Voulez-vous ajouter un module pince ?",
                        "continuewithout": "Continuer sans module pince",
                        "grapplemodule": "Module pince",
                        "weight": "Poids",
                        "liftingcapacitymax": "Capacité de levage, max."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Module pince pour travaux ferroviaires",
                        "weight": "Poids",
                        "liftingcapacitymax": "Capacité de levage, max."
                    },
                    "grapple": {
                        "grapple": "Pinces/grappins",
                        "grappleforcemax": "Force de préhension, max.",
                        "grapplewidthmax": "Largeur de préhension, max."
                    },
                    "grappletypes": {
                        "multigrapple": "grappin multi-usage",
                        "stonegrapple":"pince d'enrochement",
                        "sortinggrapple": "pince de tri"
                    },
                    "compactor": {
                        "compactor": "Plaque de compactage",
                        "weight": "Poids",
                        "vibrationforce": "Force de vibration"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Lame de nivelage",
                        "weight": "Poids",
                        "width": "Largeur"
                    },
                    "ripper": {
                        "ripper": "Dent de défonçage",
                        "weight": "Poids",
                        "toothradius": "Rayon de dent"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Disque pour enrobés",
                        "weight": "Poids",
                        "cutdepth": "Profondeur de coupe"
                    },
                    "toolmount": {
                        "toolmount": "Cadre de fixation d’outil"
                    }
                },
                "optionalstep": {
                    "yourmachine": "votre modèle de machine",
                    "yourmachineweight": "poids de votre machine",
                    "optionalstep": "Options",
                    "introweight": "Voulez-vous ajouter d’autres produits correspondants ? ",
                    "intromachine": "Voulez-vous ajouter d’autres produits correspondants ? ",
                    "introaftervalue":"Découvrez notre gamme ou passez à l’étape suivante."
                },
                "yourchoises": {
                    "yourchoises": "Vos sélections",
                    "yourchoisesintro": "Renseignez vos coordonnées et vérifiez vos sélections. Votre récapitulatif sera ensuite envoyé à un représentant Rototilt qui vous contactera rapidement.",
                    "yourinformation": "Renseignez vos coordonnées",
                   "viewretailers": "Voir les revendeurs",
                    "reviewchoises": "Vérifiez vos sélections",
                    "products": "produits"

                },
                "contactusform": {
                    "firstname": "Prénom",
                    "locationinvalid": "Saisissez uniquement des lettres",	
                    "firstnamemandatory": "Entrez votre prénom",
                    "firstnameinvalid": "Saisissez uniquement des lettres",
                    "lastname": "Nom",
                    "lastnamemandatory": "Entrez votre nom",
                    "lastnameinvalid": "Saisissez uniquement des lettres",
                    "email": "Adresse e-mail",
                    "emailmandatory": "Entrez votre adresse e-mail",
                    "emailinvalid": "Adresse e-mail non valide",
                    "phone": "Numéro de téléphone",
                    "phonemandatory": "Entrez votre numéro de téléphone",
                    "phoneinvalid": "Numéro de téléphone non valide",
                    "city": "Ville",
                    "zip": "Code postal",
                    "country:": "Pays",
                    "countrymandatory:": "Entrez votre pays",
                    "message": "Ajouter un message (facultatif)",
                    "contactus": "Envoyer", 
                    "checkboxintegrity": "J’accepte que la société Rototilt Group AB traite mes données personnelles en accord avec sa ",
                    "checkboxintegritylink": "politique en matière de gestion des données personnelles.",	
                    "checkboxnews": "Je souhaite recevoir des actualités et offres de Rototilt.",
                    "share": {
                        "share": "Partager",
                        "close": "Fermer",
                        "copylink": "Copier le lien",
                        "info": "Utilisez ce lien pour partager ou sauvegarder votre configuration"
                    }
                },
                "endpage": {
                    "welldone": "Bon travail !",
                    "gotoweb": "Cliquez ici pour accéder à notre site Web",	
                    "endpageinfo": "Un représentant Rototilt vous contactera sous peu. Une confirmation accompagnée d’un lien vers vos sélections a été envoyée à votre adresse e-mail."
                },
                "disclamer": {
                    "disclamertext": "Nous nous réservons le droit de faire des fautes typographiques, erreurs linguistiques ou autres erreurs éventuelles susceptibles d’apparaître ainsi que de modifier les caractéristiques sans avis préalable. Il peut y avoir des variations de la gamme de produits et des normes d’équipement sur les différents marchés. Pour plus d’informations sur les caractéristiques actuelles des produits, les adaptations locales et les équipements spéciaux, contactez votre revendeur Rototilt le plus proche."
                },
                "url": {
                   "productguide": "guide des produits",
                   "machinetonnage": "poids-de-la-machine",
                   "product": "produit",
                   "optional": "options",
                   "contactus": "nous-contacter",
                   "thankyou": "merci" 
                },
                "wizard": {
                    "marketstep": "Démarrer",
                    "machinetonnagestep": "Machine et poids",
                    "productstep": "Produits",
                    "otheroptionsstep": "Options",
                    "contactusstep": "Vos sélections"
                },
                "cart": {
                    "yourproducts": "Vos produits"
                },
                "footer": {
                    "previous": "Précédent",
                    "next": "Suivant"
                },
                "topbar": {
                    "products": "Produits"
                },
                "popup": {
                    "areyousure": "Vos sélections seront effacées si vous modifiez. Voulez-vous vraiment continuer ?",
                    "important": "Important !",
                    "cancel": "Annuler",
                    "clearchoises": "Effacer mes sélections",
                    "stay": "Rester sur la page"
                },
                "thankyoumail": {
                    "subject": "Objet : Merci de nous avoir contactés",
                    "hello": "Bonjour",
                    "intro": "Nous avons reçu vos sélections dans le guide de produits Rototilt. Un représentant Rototilt vous contactera sous peu. En attendant, vous pouvez cliquer sur le lien ci-dessous pour voir un récapitulatif de vos sélections.",
                    "summary": "Votre récapitulatif",
                    "signature": "Cordialement",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Pour en savoir plus, rendez-vous sur www.rototilt.com"
                }
            },
            "ja-JP": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " トン",
                    "kg": " kg",
                    "inches": "インチ",
                    "pounds": "ポンド",
                    "liter": "リットル",
                    "kilonewton": "kN",
                    "lbf": "重量ポンド",
                    "pieces": "個"
                },
                "marketstep": {
                    "markets": {
                        "market": "市場を選択",
                        "change": "変更",
                        "sv-SE": "スウェーデン",
                        "da-DK": "デンマーク",
                        "en-GB": "イギリス",
                        "fi-FI": "フィンランド",
                        "fr-FR": "フランス",
                        "de-DE": "ドイツ",
                        "nb-NO": "ノルウェー",
                        "en-US": "アメリカ合衆国",
                        "en-CA": "カナダ (英語圏)",   
                        "en-NZ": "ニュージーランド",	
                        "fr-CA": "カナダ (フランス語圏)",
                        "en": "グローバル",
                        "pl-PL": "ポーランド",
                        "nl-NL": "オランダ",
                        "es-ES": "スペイン",
                        "en-AU": "オーストラリア",
                        "ja-JP": "日本",
                        "ko-KR": "韓国"
                    },
                    "markettexts": {
                        "marketheader": "Rototiltの製品ガイドへようこそ",
                        "marketintro": "この製品ガイドでは、特定の油圧ショベルモデルに適合するRototilt製品を検索していただけます。お客様のマシンのモデルまたは重量をご入力いただくと推奨の製品が表示され、それらの中から目的に適う製品を選択して、お客様独自のチルトローテータシステムを構成していただけます。まず初めに、市場を選択してください。",
                        "chosemarketheader": "お客様の市場を選択してください",
                        "choosebetween": "次から選択",
                        "markets": "市場",
                        "marketnotfound": "お客様の市場が見つからない場合は、「グローバル」を選択してください。",
                        "searchmarket": "弊社の市場から探す",
                        "choosemarket": "市場を選択"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "マシンおよび重量",
                        "machinetonnageintro": "お客様の油圧ショベルのマシンモデルを選択するか、マシン重量を入力してください。最も適した推奨製品の選定に必要です。",
                        "findmachine": "マシンを探す",
                        "findmachinetext1":"お客様の油圧ショベルのマシンモデルを選択してください。推奨製品の選定に必要です。",
                        "findmachinetext2":"お客様の油圧ショベルのマシンモデルを選択してください。推奨製品の選定に必要です。モデルが見つからない場合は、マシン重量に切り替えてください。",
                        "searchplaceholder": "メーカーとモデルを検索",
                        "switchtotonnage": "マシン重量に切り替える",
                        "picktonnage": "マシン重量を入力してください",
                        "picktonnagetext1":"お客様の油圧ショベルの重量を入力してください。適合する推奨製品の選定に必要です。",
                        "picktonnagetext2":"お客様の油圧ショベルの重量を入力してください。適合する推奨製品の選定に必要です。マシンモデルに切り替えることもできます。",
                        "choosetonnage": "マシン重量を入力してください",
                        "tonnagehelpertext":"重量は大まかな見積もりで構いません。",
                        "switchtomachine":"マシンモデルに切り替える",
                        "loadingMessage": "お客様のマシンを検索中...",
                        "noOptionsMessage": "お客様のマシンを検索..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "製品",
                        "productintro": "どのような製品をお探しですか？まず、製品カテゴリーをお選びください。後で製品の追加や選択内容の変更も行えます。",
                        "chooseproductcategory": "製品カテゴリーを選択"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "チルトローテータ",
                    "tiltrotators": "チルトローテータ",
                    "choosetiltrotator": "チルトローテータを選択",
                    "recomended": "推奨",
                    "breakforcemax": "破砕力、最大",
                    "bucketwidthmax": "バケット幅、最大"
                },
                "machinefixings": {
                    "weight": "重量",
                    "recommended": "推奨",
                    "readmore": "続きを読む",
                    "machinefixing": "油圧カプラー",
                    "choosemachinefixing": "油圧カプラーを選択",
                    "attachment":"取り付けフレーム",
                    "chooseattachment": "取り付けフレームを選択",
                    "continuewithout": "油圧カプラーなしで続行",
                    "choosedirectmount": "直接取り付けを選択",
                    "choosesfixing": "Sカプラーを選択",
                    "chooseqcfixing": "QuickChange™カプラーを選択",
                    "nomachinefixing": "油圧カプラーを選択せずに続行",
                    "sfixing": {
                    "sfixing": "Sカプラー",
                    "weightfrom": "重量、必要最小",
                    "maxallowedloadlifthook": "許容最大負荷、リフトフック",
                    "infotext": "コンパクト設計ながらパワフルで頑丈な標準カプラー。油圧ハンマー使用時など、大重量の作業ではチルトローテータを取り外すことができます。これらのカプラーは、共通のS規格に基づいて設計されています。"
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™カプラー",
                        "weightfrom": "重量、必要最小",
                        "maxallowedloadlifthook": "許容最大負荷、リフトフック",
                        "numberofcouplers":"カプリング数、最大",
                        "infotext": "QuickChange™はRototiltの全自動クイックカプラーシステムです。このスマートな装置を追加することで、油圧ショベルの運転室に座ったままでの油圧ツール自動交換が可能になります。"
                    },
                    "directmount": {
                        "directmount": "直接取り付け",
                        "infotext": "直接取り付けとは、チルトローテータが油圧ショベルに直接取り付けられることを意味します。これは最も軽量かつコンパクトなソリューションであり、チルトローテータを取り外す必要がない用途に適しています。"
                    },
                    "toolattachment": {
                        "choosetoolattachment": "クイックカプラーを選択",
                        "toolattachment": "クイックカプラー"
                    }
                },
                "tools": {
                    "readmore": "続きを読む",
                    "categories": "カテゴリー",
                    "tools": "ツール",
                    "choosetools": "ツールを選択",
                    "ourtools": "弊社ツール",
                    "disclamertools": "以下のツールは一般的に推奨される製品です。お客様のモデルに精密に適応させる必要がある場合は、最寄の販売店までご相談ください。",
                    "number of results": "件の結果がお客様の油圧ショベルに適合",
                    "results": "結果",
                    "buckets": "バケット",
                    "choise": "バリエーション",
                    "choises": "バリエーション",
                    "weight": "重量",
                    "bucket": {
                        "bucket": "バケット",
                        "articlenumber": "品番",
                        "width": "幅",
                        "volume": "容量"
                    },
                    "excavationbucket": {
                        "excavationbucket": "掘削バケット",
                        "articlenumber": "品番",
                        "width": "幅",
                        "volume": "容量",
                        "toothtype": "ツースタイプ"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "溝堀用バケット",
                        "articlenumber": "品番",
                        "width": "幅",
                        "volume": "容量"
                    },
                    "sortingbucket": {
                        "sortingbucket": "選別用バケット",
                        "articlenumber": "品番",
                        "width": "幅",
                        "volume": "容量"
                    },
                    "gradingbucket": {
                        "gradingbucket": "汎用バケット",
                        "articlenumber": "品番",
                        "width": "幅",
                        "volume": "容量"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "グラップルモジュールを追加しますか？",
                        "continuewithout": "グラップルモジュールなしで続行",
                        "grapplemodule": "グラップルモジュール",
                        "weight": "重量",
                        "liftingcapacitymax": "吊り上げ能力、最大"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "鉄道用グラップル",
                        "weight": "重量",
                        "liftingcapacitymax": "吊り上げ能力、最大"
                    },
                    "grapple": {
                        "grapple": "グラップル",
                        "grappleforcemax": "グラップル力、最大",
                        "grapplewidthmax": "グラップル幅、最大"
                    },
                    "grappletypes": {
                        "multigrapple": "マルチグラップル",
                        "stonegrapple":"岩石用グラップル",
                        "sortinggrapple": "選別用グラップル"
                    },
                    "compactor": {
                        "compactor": "コンパクター",
                        "weight": "重量",
                        "vibrationforce": "振動力"
                    },
                    "gradingbeam": {
                        "gradingbeam": "グレーディングビーム",
                        "weight": "重量",
                        "width": "幅"
                    },
                    "ripper": {
                        "ripper": "リッパー",
                        "weight": "重量",
                        "toothradius": "ツース半径"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "アスファルトカッター",
                        "weight": "重量",
                        "cutdepth": "切削深さ"
                    },
                    "toolmount": {
                        "toolmount": "ツール取り付けフレーム"
                    }
                },
                "optionalstep": {
                    "yourmachine": "お客様のマシンモデル",
                    "yourmachineweight": "お客様のマシン重量",
                    "optionalstep": "オプション",
                    "introweight": "適合する製品をさらに追加しますか ",
                    "intromachine": "適合する製品をさらに追加しますか ",
                    "introaftervalue":"弊社製品群をもっと詳しく見るか、次のステップに進んでください。"
                },
                "yourchoises": {
                    "yourchoises": "ご選択内容",
                    "yourchoisesintro": "お客様情報を入力し、選択した内容をご確認ください。完了すると、概要がRototiltの代理店に送信され、代理店の方から折り返しご連絡をさせていただきます。",
                    "yourinformation": "お客様の情報を入力してください",
                   "viewretailers": "販売店を表示",
                    "reviewchoises": "選択内容をご確認ください",
                    "products": "製品"

                },
                "contactusform": {
                    "locationinvalid": "文字のみ入力可能",		
                    "firstname": "名",
                    "firstnamemandatory": "名前を入力してください",
                    "firstnameinvalid": "文字のみ入力可能",
                    "lastname": "姓",
                    "lastnamemandatory": "名字を入力してください",
                    "lastnameinvalid": "文字のみ入力可能",
                    "email": "Eメールアドレス",
                    "emailmandatory": "Eメールアドレスを入力してください",
                    "emailinvalid": "無効なEメールアドレス",
                    "phone": "電話番号",
                    "phonemandatory": "電話番号を入力してください",
                    "phoneinvalid": "無効な電話番号",
                    "city": "市",
                    "zip": "郵便番号",
                    "country:": "国",
                    "countrymandatory:": "国名を入力してください",
                    "message": "メッセージを追加 (オプション)",
                    "contactus": "送信", 
                    "checkboxintegrity": "私は、Rototilt Group ABが同社の個人情報保護方針に従って私の個人 ",
                    "checkboxintegritylink": "情報を処理することに同意します。",	
                    "checkboxnews": "Rototiltから配信されるニュースやオファーの受信を希望する。",
                    "share": {
                        "share": "共有",
                        "close": "閉じる",
                        "copylink": "リンクをコピー",
                        "info": "選択した構成は、このリンクを使用して共有または保存できます"
                    }
                },
                "endpage": {
                    "welldone": "ありがとうございました！",
                    "gotoweb": "弊社ウェブサイトはこちらをクリック",	
                    "endpageinfo": "Rototiltの代理店から折り返しご連絡させていただきます。お客様のご選択内容へのリンクが記載された確認メールを送信いたしました。"
                },
                "disclamer": {
                    "disclamertext": "弊社は、期せず発生する誤植、誤字脱字、および一切の誤りについて責任を負わず、予告なしに仕様を変更する権利を留保します。製品群に含まれるバリエーションと装置の規格は、市場によって異なる場合があります。現行の製品仕様、ローカル適応、特殊装置の詳細については、最寄のRototilt販売店までお問い合わせください。"
                },
                "url": {
                   "productguide": "製品ガイド",
                   "machinetonnage": "マシン重量",
                   "product": "製品",
                   "optional": "オプション",
                   "contactus": "お問い合わせ",
                   "thankyou": "ありがとうございました" 
                },
                "wizard": {
                    "marketstep": "始める",
                    "machinetonnagestep": "マシンおよび重量",
                    "productstep": "製品",
                    "otheroptionsstep": "オプション",
                    "contactusstep": "ご選択内容"
                },
                "cart": {
                    "yourproducts": "選択された製品"
                },
                "footer": {
                    "previous": "前へ",
                    "next": "次へ"
                },
                "topbar": {
                    "products": "製品"
                },
                "popup": {
                    "areyousure": "変更を加えた場合、選択内容はクリアされます。続行してよろしいですか？",
                    "important": "重要！",
                    "cancel": "キャンセル",
                    "clearchoises": "選択内容をクリア",
                    "stay": "このページにとどまる"
                },
                "thankyoumail": {
                    "subject": "件名：お問い合わせありがとうございます",
                    "hello": "お客様各位",
                    "intro": "Rototiltの製品ガイドにて、お客様のご選択内容を承りました。Rototiltの代理店より折り返しご連絡させていただきます。ご選択内容の確認には、以下のリンクをクリックしてください。",
                    "summary": "ご選択内容",
                    "signature": "よろしくお願いいたします",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "www.rototilt.comで詳細を読む"
                }
            },
            "ko-KR": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " 톤",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "개"
                },
                "marketstep": {
                    "markets": {
                        "market": "시장 선택",
                        "change": "변경",
                        "sv-SE": "스웨덴",
                        "da-DK": "덴마크",
                        "en-GB": "영국",
                        "fi-FI": "핀란드",
                        "fr-FR": "프랑스",
                        "de-DE": "독일",
                        "nb-NO": "노르웨이",
                        "en-US": "미국",
                        "en-CA": "캐나다(영어)",   
                        "en-NZ": "뉴질랜드",	
                        "fr-CA": "캐나다(프랑스어권)",
                        "en": "전 세계",
                        "pl-PL": "폴란드",
                        "nl-NL": "네덜란드",
                        "es-ES": "스페인",
                        "en-AU": "호주",
                        "ja-JP": "일본",
                        "ko-KR": "대한민국"
                    },
                    "markettexts": {
                        "marketheader": "Rototilt의 제품 가이드에 오신 것을 환영합니다",
                        "marketintro": "Rototilt의 제품 가이드를 사용하면 특정 굴삭기 모델에 Rototilt의 제품을 매칭하는 데에 도움이 될 것입니다. 기계 모델 혹은 기계 무게를 지정하면 추천 제품 사이에서 선택을 통해 자신만의 틸트로테이터 시스템을 구축할 수 있습니다. 시장을 선택해 시작하십시오.",
                        "chosemarketheader": "시장 선택하기",
                        "choosebetween": "시장",
                        "markets": "선택하기",
                        "marketnotfound": "시장을 찾을 수 없다면 “전 세계”를 선택하십시오.",
                        "searchmarket": "시장에서 검색하기",
                        "choosemarket": "시장 선택"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "기계 및 무게",
                        "machinetonnageintro": "기계에 대한 최고의 제품 추천을 받으려면 굴삭기 모델을 선택하거나 기계의 무게를 입력하십시오.",
                        "findmachine": "기계 찾기",
                        "findmachinetext1":"굴삭기에 대한 제품 추천을 받으려면 기계 모델을 선택하십시오.",
                        "findmachinetext2":"굴삭기에 대한 제품 추천을 받으려면 기계 모델을 선택하십시오. 모델을 찾을 수 없다면, 기계 무게로 전환하십시오.",
                        "searchplaceholder": "연식 및 모델 검색",
                        "switchtotonnage": "기계 무게로 전환하기",
                        "picktonnage": "기계 무게를 입력하십시오",
                        "picktonnagetext1":"굴삭기에 맞는 제품 추천을 받으려면 무게를 입력하십시오.",
                        "picktonnagetext2":"굴삭기에 맞는 제품 추천을 받으려면 무게를 입력하십시오. 제품 모델로 전환할 수도 있습니다. ",
                        "choosetonnage": "기계 무게를 입력하십시오",
                        "tonnagehelpertext":"대략적인 예상을 입력해도 좋습니다.",
                        "switchtomachine":"기계 모델로 전환하기",
                        "loadingMessage": "기계를 찾고 있습니다...",
                        "noOptionsMessage": "기계 찾기..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "제품",
                        "productintro": "어떤 제품에 관심이 있으십니까? 시작하려면 제품 카테고리를 선택하십시오. 나중에 더 많은 제품을 추가하고 선택을 변경할 옵션이 주어집니다.",
                        "chooseproductcategory": "제품 카테고리 선택"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "틸트로테이터",
                    "tiltrotators": "틸트로테이터",
                    "choosetiltrotator": "틸트로테이터 선택",
                    "recomended": "추천",
                    "breakforcemax": "최대 돌파력",
                    "bucketwidthmax": "최대 버킷 너비"
                },
                "machinefixings": {
                    "weight": "무게",
                    "recommended": "추천",
                    "readmore": "자세히 보기",
                    "machinefixing": "기계 커플러",
                    "choosemachinefixing": "기계 커플러 선택",
                    "attachment":"부착 프레임",
                    "chooseattachment": "부착 프레임 선택",
                    "continuewithout": "기계 커플러 없이 계속하기",
                    "choosedirectmount": "직접 부착 선택",
                    "choosesfixing": "S-커플러 선택",
                    "chooseqcfixing": "QuickChange™ 커플러 선택",
                    "nomachinefixing": "기계 커플러를 선택하지 않고 계속하기",
                    "sfixing": {
                    "sfixing": "S-커플러",
                    "weightfrom": "최소 무게",
                    "maxallowedloadlifthook": "허용된 최대 하중, 리프트 후크",
                    "infotext": "컴팩트한 디자인을 가진 강력하고 튼튼한 표준 커플러입니다. 유압 해머를 사용하는 등 무거운 작업을 할 때 틸트로테이터를 분리할 수 있도록 해 줍니다. 이러한 커플러는 흔히 사용되는 S-표준을 기반으로 합니다."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ 커플러",
                        "weightfrom": "최소 무게",
                        "maxallowedloadlifthook": "허용된 최대 하중, 리프트 후크",
                        "numberofcouplers":"최대 커플링 수",
                        "infotext": "QuickChange™는 Rototilt의 완전 자동 퀵 커플러 시스템입니다. 굴삭기 운전실을 떠나지 않고도 유압 작업 공구를 자동으로 변경할 수 있게 해주는 스마트한 추가 제품입니다."
                    },
                    "directmount": {
                        "directmount": "직접 부착",
                        "infotext": "직접 부착이란 틸트로테이터가 굴삭기에 직접 연결되어 있다는 것을 의미합니다. 이는 가장 가벼우면서도 가장 컴팩트한 솔루션으로, 틸트로테이터를 절대로 분리할 필요가 없는 상황에 적합합니다."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "퀵 커플러 선택",
                        "toolattachment": "퀵 커플러"
                    }
                },
                "tools": {
                    "readmore": "자세히 보기",
                    "categories": "카테고리",
                    "tools": "작업 공구",
                    "choosetools": "작업 공구 선택",
                    "ourtools": "Rototilt의 작업 공구",
                    "disclamertools": "아래의 작업 공구는 일반적인 추천 사항입니다. 소유하고 있는 기계 모델과 정밀하게 맞추기 위해서는 대리점에 문의하십시오.",
                    "number of results": "귀하의 굴삭기에 대한 결과",
                    "results": "결과",
                    "buckets": "버킷",
                    "choise": "변형",
                    "choises": "변형",
                    "weight": "무게",
                    "bucket": {
                        "bucket": "버킷",
                        "articlenumber": "품목 번호",
                        "width": "너비",
                        "volume": "부피"
                    },
                    "excavationbucket": {
                        "excavationbucket": "굴삭 버킷",
                        "articlenumber": "품목 번호",
                        "width": "너비",
                        "volume": "부피",
                        "toothtype": "톱니 종류"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "트렌칭 버킷",
                        "articlenumber": "품목 번호",
                        "width": "너비",
                        "volume": "부피"
                    },
                    "sortingbucket": {
                        "sortingbucket": "분류 버킷",
                        "articlenumber": "품목 번호",
                        "width": "너비",
                        "volume": "부피"
                    },
                    "gradingbucket": {
                        "gradingbucket": "범용 버킷",
                        "articlenumber": "품목 번호",
                        "width": "너비",
                        "volume": "부피"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "그래플 모듈을 추가하시겠습니까?",
                        "continuewithout": "그래플 모듈 없이 계속하기",
                        "grapplemodule": "그래플 모듈",
                        "weight": "무게",
                        "liftingcapacitymax": "리프팅 용량, 최대"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "철도 그래플",
                        "weight": "무게",
                        "liftingcapacitymax": "리프팅 용량, 최대"
                    },
                    "grapple": {
                        "grapple": "그래플",
                        "grappleforcemax": "최대 그래플 포스",
                        "grapplewidthmax": "최대 그래플 너비"
                    },
                    "grappletypes": {
                        "multigrapple": "멀티 그래플",
                        "stonegrapple":"석재 그래플",
                        "sortinggrapple": "분류 그래플"
                    },
                    "compactor": {
                        "compactor": "압축기",
                        "weight": "무게",
                        "vibrationforce": "진동력"
                    },
                    "gradingbeam": {
                        "gradingbeam": "그레이딩 빔",
                        "weight": "무게",
                        "width": "너비"
                    },
                    "ripper": {
                        "ripper": "리퍼",
                        "weight": "무게",
                        "toothradius": "톱니 반경"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "아스팔트 커터",
                        "weight": "무게",
                        "cutdepth": "절단 깊이"
                    },
                    "toolmount": {
                        "toolmount": "도구 부착 프레임"
                    }
                },
                "optionalstep": {
                    "yourmachine": "귀하의 기계 모델",
                    "yourmachineweight": "귀하의 기계 무게",
                    "optionalstep": "옵션",
                    "introweight": "맞는 제품을 더 추가하시겠습니까 ",
                    "intromachine": "맞는 제품을 더 추가하시겠습니까 ",
                    "introaftervalue":"Rototilt의 제품을 더 둘러보거나 다음 단계로 넘어가십시오."
                },
                "yourchoises": {
                    "yourchoises": "귀하의 선택",
                    "yourchoisesintro": "귀하에 대한 정보를 입력하고 선택하신 내용을 검토하십시오. 완료되면 요약본이 Rototilt의 담당자에게 전송되어 담당자가 가까운 시일 내에 연락드릴 것입니다.",
                    "yourinformation": "정보를 입력해 주십시오",
                   "viewretailers": "대리점 보기",
                    "reviewchoises": "귀하의 선택 검토하기",
                    "products": "제품"

                },
                "contactusform": {
                    "firstname": "이름",
                    "locationinvalid": "문자만 입력해 주십시오",		
                    "firstnamemandatory": "이름을 입력해 주십시오",
                    "firstnameinvalid": "문자만 입력해 주십시오",
                    "lastname": "성",
                    "lastnamemandatory": "성을 입력해 주십시오",
                    "lastnameinvalid": "문자만 입력해 주십시오",
                    "email": "이메일 주소",
                    "emailmandatory": "이메일 주소를 입력해 주십시오",
                    "emailinvalid": "유효하지 않은 이메일 주소",
                    "phone": "전화번호",
                    "phonemandatory": "전화번호를 입력해 주십시오",
                    "phoneinvalid": "유효하지 않은 전화번호",
                    "city": "도시",
                    "zip": "우편번호",
                    "country:": "국가",
                    "countrymandatory:": "국가를 입력해 주십시오",
                    "message": "메시지 추가하기(옵션)",
                    "contactus": "보내기", 
                    "checkboxintegrity": "Rototilt Group AB가 개인 정보를 개인 정보 규정에 따라 처리하는 것을 ",
                    "checkboxintegritylink": "허가합니다.",	
                    "checkboxnews": "Rototilt로부터 뉴스 및 제안을 받고 싶습니다.",
                    "share": {
                        "share": "공유하기",
                        "close": "닫기",
                        "copylink": "링크 복사",
                        "info": "이 링크를 사용해 설정을 공유하거나 저장하십시오"
                    }
                },
                "endpage": {
                    "welldone": "잘하셨습니다!",
                    "gotoweb": "여기를 클릭해 웹사이트 방문",	
                    "endpageinfo": "Rototilt의 담당자가 조만간 귀하에게 연락할 것입니다. 귀하가 선택하신 내용에 대한 링크가 포함된 확인이 귀하의 이메일로 전송되었습니다."
                },
                "disclamer": {
                    "disclamertext": "Rototilt는 인쇄상의 오류나 오타 및 발생 가능한 모든 오류에 대한 유보 조항을 달며, 사전 공지 없이 사양을 바꿀 권한을 가집니다. 시장에 따라 제품군 및 장비 표준 상의 차이가 발생할 가능성이 있습니다. 현재의 제품 사양, 지역적 적용 및 특수 장비에 대해 더 많은 정보를 알아보시려면 근처의 Rototilt 대리점에 문의해 주시기 바랍니다."
                },
                "url": {
                   "productguide": "제품 가이드",
                   "machinetonnage": "기계 무게",
                   "product": "제품",
                   "optional": "옵션",
                   "contactus": "연락하기",
                   "thankyou": "감사합니다" 
                },
                "wizard": {
                    "marketstep": "시작",
                    "machinetonnagestep": "기계 및 무게",
                    "productstep": "제품",
                    "otheroptionsstep": "옵션",
                    "contactusstep": "귀하의 선택"
                },
                "cart": {
                    "yourproducts": "귀하의 제품"
                },
                "footer": {
                    "previous": "이전",
                    "next": "다음"
                },
                "topbar": {
                    "products": "제품"
                },
                "popup": {
                    "areyousure": "변경하면 선택한 사항이 삭제됩니다. 계속하시겠습니까?",
                    "important": "중요!",
                    "cancel": "취소",
                    "clearchoises": "내 선택 삭제",
                    "stay": "페이지에 남기"
                },
                "thankyoumail": {
                    "subject": "제목: 연락해 주셔서 감사합니다",
                    "hello": "안녕하세요",
                    "intro": "Rototilt의 제품 가이드에서 귀하가 선택한 내용을 수신했습니다. Rototilt의 담당자가 근시일 내로 연락할 것입니다. 그 동안, 아래의 링크를 클릭해 선택하신 내용의 요악을 확인할 수 있습니다.",
                    "summary": "귀하의 선택",
                    "signature": "감사합니다",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "자세한 내용은 www.rototilt.com에서 확인하십시오"
                }
            },
            "nb-NO": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tonn",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "stykker"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt Produktguide – match med gravemaskinen din",
                        "text": "Velkommen til Rototilts produktguide. Her kan du enkelt finne og matche produkter fra Rototilt med gravemaskinmodellen din.",
                        "keywords": "rototilt produktguide, rototilt produktkonfigurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Velg marked",
                        "change": "endre",
                        "sv-SE": "Sverige",
                        "da-DK": "Danmark",
                        "en-GB": "Storbritannia",
                        "fi-FI": "Finland",
                        "fr-FR": "Frankrike",
                        "de-DE": "Tyskland",
                        "nb-NO": "Norge",
                        "en-US": "USA",
                        "en-CA": "Canada (engelsk)",   
                        "en-NZ": "New Zealand",	
                        "fr-CA": "Canada (fransk)",
                        "en": "Global",
                        "pl-PL": "Polen",
                        "nl-NL": "Nederland",
                        "es-ES": "Spania",
                        "en-AU": "Australia",
                        "ja-JP": "Japan",
                        "ko-KR": "Sør-Korea"
                    },
                    "markettexts": {
                        "marketheader": "Velkommen til Rototilts produktguide",
                        "marketintro": "Her kan du enkelt matche produkter fra Rototilt mot en gravemaskinmodell. Når du angir maskinmodell eller maskinvekt, kan du velge blant anbefalte produkter og bygge ditt eget tiltrotatorsystem. Begynn med å velge markedet ditt.",
                        "chosemarketheader": "Velg markedet ditt",
                        "choosebetween": "Velg blant",
                        "markets": "Markeder",
                        "marketnotfound": "Hvis du ikke finner markedet ditt, kan du velge «Global».",
                        "searchmarket": "Søk blant markedene våre",
                        "choosemarket": "Velg marked"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Maskin og vekt",
                        "machinetonnageintro": "For å få de beste produktanbefalingene for maskinen din må du velge gravemaskinmodell eller angi maskinens vekt.",
                        "findmachine": "Finn maskinen din",
                        "findmachinetext1":"Velg maskinmodell for å få produktanbefalinger for gravemaskinen din.",
                        "findmachinetext2":"Velg maskinmodell for å få produktanbefalinger for gravemaskinen din. Hvis du ikke finner modellen din, kan du bytte til maskinvekt.",
                        "searchplaceholder": "Søk etter merke og modell",
                        "switchtotonnage": "Bytt til maskinvekt",
                        "picktonnage": "Angi maskinvekten",
                        "picktonnagetext1":"Angi vekt for å få produktanbefalinger som passer til gravemaskinen din.",
                        "picktonnagetext2":"Angi vekt for å få produktanbefalinger som passer til gravemaskinen din. Du kan også bytte til maskinmodell. ",
                        "choosetonnage": "Angi maskinvekten",
                        "tonnagehelpertext":"Du kan bruke et estimat.",
                        "switchtomachine":"Bytt til maskinmodell",
                        "loadingMessage": "Vi søker etter maskinen din …",
                        "noOptionsMessage": "Søk etter maskinen din …"
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produkter",
                        "productintro": "Hvilke produkter er du interessert i? Velg en produktkategori for å begynne. Du kan legge til flere produkter og endre valgene dine senere.",
                        "chooseproductcategory": "Velg produktkategori"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotatorer",
                    "choosetiltrotator": "Velg tiltrotator",
                    "recomended": "Anbefalt",
                    "breakforcemax": "Brytekraft, maksimalt",
                    "bucketwidthmax": "Skuffebredde, maksimalt"
                },
                "machinefixings": {
                    "weight": "Vekt",
                    "recommended": "anbefalt",
                    "readmore": "Les mer",
                    "machinefixing": "Maskinfeste",
                    "choosemachinefixing": "Velg maskinfeste",
                    "attachment":"Festeramme",
                    "chooseattachment": "Velg festeramme",
                    "continuewithout": "Fortsett uten maskinfeste",
                    "choosedirectmount": "Velg direkte festeramme",
                    "choosesfixing": "Velg S-feste",
                    "chooseqcfixing": "Velg QuickChange™-feste",
                    "nomachinefixing": "Fortsett uten å velge maskinfeste",
                    "sfixing": {
                    "sfixing": "S-feste",
                    "weightfrom": "Vekt, fra",
                    "maxallowedloadlifthook": "Tillatt maksimal last løftekrok",
                    "infotext": "Et kraftig og robust standardfeste med kompakt design. Gjør det mulig å koble fra tiltrotatoren ved tyngre oppgaver, for eksempel ved bruk av hydraulisk hammer. Disse festene er basert på den felles S-standarden."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™-feste",
                        "weightfrom": "Vekt, fra",
                        "maxallowedloadlifthook": "Tillatt maksimal last løftekrok",
                        "numberofcouplers":"Antall koblinger, maksimalt",
                        "infotext": "QuickChange™ er Rototilts helautomatiske hurtigkoblingssystem. Det er et smart tillegg som muliggjør automatiske bytter av hydraulisk redskap uten at du trenger å forlate gravemaskinens førerhus."
                    },
                    "directmount": {
                        "directmount": "Direkte festeramme",
                        "infotext": "En direkte festeramme innebærer at tiltrotatoren festes direkte til gravemaskinen. Det er den enkleste og mest kompakte løsningen, og den passer for oppgaver der det ikke er nødvendig å koble fra tiltrotatoren."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Velg redskapsfeste",
                        "toolattachment": "Redskapsfeste"
                    }
                },
                "tools": {
                    "readmore": "Les mer",
                    "tools": "Redskap",
                    "categories": "kategorier",
                    "choosetools": "Velg redskap",
                    "ourtools": "Våre redskaper",
                    "disclamertools": "Redskapene under er en generell anbefaling. Snakk med forhandleren din for å få korrekt tilpasning til maskinmodellen din.",
                    "number of results": "resultat for gravemaskinen din",
                    "results": "Resultat",
                    "buckets": "Skuffer",
                    "choise": "Variant",
                    "choises": "Varianter",
                    "weight": "Vekt",
                    "bucket": {
                        "bucket": "Skuffe",
                        "articlenumber": "Artikkelnummer",
                        "width": "Bredde",
                        "volume": "Volum"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Graveskuff",
                        "articlenumber": "Artikkelnummer",
                        "width": "Bredde",
                        "volume": "Volum",
                        "toothtype": "Tanntype"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Smalskuff",
                        "articlenumber": "Artikkelnummer",
                        "width": "Bredde",
                        "volume": "Volum"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Sorteringsskuff",
                        "articlenumber": "Artikkelnummer",
                        "width": "Bredde",
                        "volume": "Volum"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Planeringsskuff",
                        "articlenumber": "Artikkelnummer",
                        "width": "Bredde",
                        "volume": "Volum"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Vil du legge til en gripemodul?",
                        "continuewithout": "Fortsett uten gripemodul",
                        "grapplemodule": "Gripemodul",
                        "weight": "Vekt",
                        "liftingcapacitymax": "Løftekapasitet, maksimalt"
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Jernbanegrabb",
                        "weight": "Vekt",
                        "liftingcapacitymax": "Løftekapasitet, maksimalt"
                    },
                    "grapple": {
                        "grapple": "Grabber",
                        "grappleforcemax": "Grabbens kraft, maksimalt",
                        "grapplewidthmax": "Grabbens bredde, maksimalt"
                    },
                    "grappletypes": {
                        "multigrapple": "multigriper",
                        "stonegrapple":"steingriper",
                        "sortinggrapple": "sorteringsgriper"
                    },
                    "compactor": {
                        "compactor": "Markvibrator",
                        "weight": "Vekt",
                        "vibrationforce": "Vibrasjonskraft"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Avrettingsbjelke",
                        "weight": "Vekt",
                        "width": "Bredde"
                    },
                    "ripper": {
                        "ripper": "Rivetann",
                        "weight": "Vekt",
                        "toothradius": "Tannradius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asfaltkutter",
                        "weight": "Vekt",
                        "cutdepth": "Skjæredybde"
                    },
                    "toolmount": {
                        "toolmount": "Redskapsfeste"
                    }
                },
                "optionalstep": {
                    "yourmachine": "din maskinmodell",
                    "yourmachineweight": "din maskinvekt",
                    "optionalstep": "Ekstrautstyr",
                    "introweight": "Vil du legge til flere produkter som matcher ",
                    "intromachine": "Vil du legge til flere produkter som matcher ",
                    "introaftervalue":"Ta en titt på utvalget vårt, eller gå videre til neste trinn."
                },
                "yourchoises": {
                    "yourchoises": "Dine valg",
                    "yourchoisesintro": "Fyll ut opplysningene dine og se gjennom valgene. Når du er ferdig, sendes sammendraget til en representant fra Rototilt, som kontakter deg snart.",
                    "yourinformation": "Fyll ut opplysningene dine",
                   "viewretailers": "Se forhandlere",
                    "reviewchoises": "Se gjennom valgene dine",
                    "products": "produkter"

                },
                "contactusform": {
                    "firstname": "Fornavn",
                    "locationinvalid": "Bruk bare bokstaver",		
                    "firstnamemandatory": "Fyll ut fornavnet ditt",
                    "firstnameinvalid": "Bruk bare bokstaver",
                    "lastname": "Etternavn",
                    "lastnamemandatory": "Fyll ut etternavnet ditt",
                    "lastnameinvalid": "Bruk bare bokstaver",
                    "email": "E-postadresse",
                    "emailmandatory": "Fyll ut e-postadressen din",
                    "emailinvalid": "E-postadressen er ikke gyldig",
                    "phone": "Telefonnummer",
                    "phonemandatory": "Fyll ut telefonnummeret ditt",
                    "phoneinvalid": "Telefonnummeret er ikke gyldig",
                    "city": "Sted",
                    "zip": "Postnummer",
                    "country:": "Land",
                    "countrymandatory:": "Fyll ut landet ditt",
                    "message": "Legg til melding (valgfritt)",
                    "contactus": "Send", 
                    "checkboxintegrity": "Jeg godkjenner at Rototilt Group AB kan behandle personopplysningene mine i henhold til ",
                    "checkboxintegritylink": "personvernerklæringen.",	
                    "checkboxnews": "Jeg ønsker å motta nyheter og tilbud fra Rototilt.",
                    "share": {
                        "share": "Del",
                        "close": "Lukk",
                        "copylink": "Kopier lenke",
                        "info": "Bruk denne lenken til å dele eller lagre konfigurasjonen din"
                    }
                },
                "endpage": {
                    "welldone": "Godt jobbet!",
                    "gotoweb": "Klikk her for å gå til nettstedet vårt",	
                    "endpageinfo": "En representant fra Rototilt kontakter deg snart. Vi har sendt deg en e-post med bekreftelse og en lenke til valgene dine."
                },
                "disclamer": {
                    "disclamertext": "Med forbehold om trykkfeil eller skrivefeil samt eventuelle feil som kan oppstå. Vi forbeholder oss retten til å endre spesifikasjoner uten ytterligere forvarsel. Variasjoner i produktprogram og utstyrsstandard kan oppstå i forskjellige markeder. Kontakt nærmeste Rototilt-forhandler for mer informasjon om aktuelle produktspesifikasjoner, lokale tilpasninger og spesialutstyr."
                },
                "url": {
                   "productguide": "produktguiden",
                   "machinetonnage": "maskinvekt",
                   "product": "produkt",
                   "optional": "ekstrautstyr",
                   "contactus": "kontakt-oss",
                   "thankyou": "takk" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Maskin og vekt",
                    "productstep": "Produkter",
                    "otheroptionsstep": "Ekstrautstyr",
                    "contactusstep": "Dine valg"
                },
                "cart": {
                    "yourproducts": "Dine produkter"
                },
                "footer": {
                    "previous": "Forrige",
                    "next": "Neste"
                },
                "topbar": {
                    "products": "Produkter"
                },
                "popup": {
                    "areyousure": "Hvis du endrer, blir valgene dine slettet. Vil du fortsette?",
                    "important": "Viktig!",
                    "cancel": "Avbryt",
                    "clearchoises": "Slett valgene mine",
                    "stay": "Forbli på siden"
                },
                "thankyoumail": {
                    "subject": "Emne: Takk for at du kontakter oss",
                    "hello": "Hei",
                    "intro": "Vi har mottatt dine valg i Rototilts produktguide. En representant fra Rototilt kontakter deg snart. I mellomtiden kan du klikke på lenken under for å se et sammendrag av valgene dine.",
                    "summary": "Sammendraget ditt",
                    "signature": "Med vennlig hilsen",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Les mer på www.rototilt.com"
                }
            },
            "nl-NL": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " ton",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "stuks"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt Productgids - Wat past bij uw graafmachine",
                        "text": "Welkom bij de productgids van Rototilt. Hier kunt u op eenvoudige wijze producten van Rototilt vinden die passen bij uw specifieke graafmachinemodel.",
                        "keywords": "rototilt productgids, rototilt productconfigurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Kies uw markt",
                        "change": "wijzig",
                        "sv-SE": "Zweden",
                        "da-DK": "Denemarken",
                        "en-GB": "Verenigd Koninkrijk",
                        "fi-FI": "Finland",
                        "fr-FR": "Frankrijk",
                        "de-DE": "Duitsland",
                        "nb-NO": "Noorwegen",
                        "en-US": "VS",
                        "en-CA": "Canada (Engels)",   
                        "en-NZ": "Nieuw-Zeeland",	
                        "fr-CA": "Canada (Frans)",
                        "en": "Wereldwijd",
                        "pl-PL": "Polen",
                        "nl-NL": "Nederland",
                        "es-ES": "Spanje",
                        "en-AU": "Australië",
                        "ja-JP": "Japan",
                        "ko-KR": "Zuid-Korea"
                    },
                    "markettexts": {
                        "marketheader": "Welkom bij de productgids van Rototilt",
                        "marketintro": "Hier kunt u Rototilt producten eenvoudig koppelen aan een specifiek graafmachinemodel. Door uw machinemodel of machinegewicht op te geven, kunt u kiezen uit aanbevolen producten en uw eigen draaikantelstuksysteem bouwen. Begin met het kiezen van uw markt.",
                        "chosemarketheader": "Kies uw markt",
                        "choosebetween": "Kies uit",
                        "markets": "Markten",
                        "marketnotfound": "Als u uw markt niet kunt vinden, selecteert u \"Wereldwijd\".",
                        "searchmarket": "Zoek in onze markten",
                        "choosemarket": "Kies uw markt"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine en gewicht",
                        "machinetonnageintro": "Voor de best mogelijke productaanbevelingen voor uw machine kiest u het graafmachinemodel of voert u het gewicht van de machine in.",
                        "findmachine": "Vindt uw machine",
                        "findmachinetext1":"Selecteer het machinemodel om productaanbevelingen voor uw graafmachine te krijgen.",
                        "findmachinetext2":"Selecteer het machinemodel om productaanbevelingen voor uw graafmachine te krijgen. Als u uw model niet kunt vinden, vult u het gewicht van de machine in.",
                        "searchplaceholder": "Zoek merk en model",
                        "switchtotonnage": "Gebruik machinegewicht",
                        "picktonnage": "Voer het gewicht van uw machine in",
                        "picktonnagetext1":"Vul het gewicht in om aanbevelingen te krijgen van producten die geschikt zijn voor uw graafmachine.",
                        "picktonnagetext2":"Vul het gewicht in om aanbevelingen te krijgen van producten die geschikt zijn voor uw graafmachine. U kunt ook het machinemodel gebruiken. ",
                        "choosetonnage": "Voer het gewicht van uw machine in",
                        "tonnagehelpertext":"Dit hoeft niet exact te zijn, een benadering is voldoende.",
                        "switchtomachine":"Gebruik machinemodel",
                        "loadingMessage": "Wij zijn op zoek naar uw machine...",
                        "noOptionsMessage": "Bezig met zoeken naar uw machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Producten",
                        "productintro": "In welke producten bent u geïnteresseerd? Kies om te beginnen een productcategorie. U hebt de mogelijkheid om meer producten toe te voegen en uw keuzes later te wijzigen.",
                        "chooseproductcategory": "Kies productcategorie"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Draaikantelstuk",
                    "tiltrotators": "Draaikantelstukken",
                    "choosetiltrotator": "Kies draaikantelstuk",
                    "recomended": "Aanbevolen",
                    "breakforcemax": "Opbreekkracht, max.",
                    "bucketwidthmax": "Breedte bak, max"
                },
                "machinefixings": {
                    "weight": "Gewicht",
                    "recommended": "aanbevolen",
                    "readmore": "Lees meer",
                    "machinefixing": "Machinesnelwissel",
                    "choosemachinefixing": "Kies machinesnelwissel",
                    "attachment":"Ophanging",
                    "chooseattachment": "Kies ophanging",
                    "continuewithout": "Doorgaan zonder machinesnelwissel",
                    "choosedirectmount": "Kies directe bevestiging",
                    "choosesfixing": "Kies S-snelwissel",
                    "chooseqcfixing": "Kies QuickChange™ snelwissel",
                    "nomachinefixing": "Vaste ophanging of CW snelwissel",
                    "sfixing": {
                    "sfixing": "S-snelwissel",
                    "weightfrom": "Gewicht, vanaf",
                    "maxallowedloadlifthook": "Toegestane maximale belasting hijshaak",
                    "infotext": "Een krachtige en robuuste standaardkoppeling met een compact ontwerp. Maakt het mogelijk om het draaikantelstuk te ontkoppelen voor zwaardere werkzaamheden, zoals bij het gebruik van hydraulische breekhamers. Deze koppelingen zijn gebaseerd op de gemeenschappelijke S-standaard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ snelwissel",
                        "weightfrom": "Gewicht, vanaf",
                        "maxallowedloadlifthook": "Toegestane maximale belasting hijshaak",
                        "numberofcouplers":"Aantal koppelingen, max",
                        "infotext": "QuickChange™ is het volledig automatische snelwisselsysteem van Rototilt. Het is een slimme uitbreiding waarmee hydraulische uitrustingsstukken automatisch gewisseld kunnen worden zonder dat u de cabine van de graafmachine hoeft te verlaten."
                    },
                    "directmount": {
                        "directmount": "Directe bevestiging",
                        "infotext": "Een directe koppeling betekent dat het draaikantelstuk direct aan de graafmachine wordt bevestigd. Het is de lichtste en meest compacte oplossing die geschikt is voor toepassingen waarbij het draaikantelstuk nooit afgekoppeld hoeft te worden."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Selecteer snelwissel",
                        "toolattachment": "Snelwissel"
                    }
                },
                "tools": {
                    "readmore": "Lees meer",
                    "categories": "categorieën",
                    "tools": "Uitrustingsstukken",
                    "choosetools": "Kies uitrustingsstuk",
                    "ourtools": "Onze uitrustingsstukken",
                    "disclamertools": "De onderstaande uitrustingsstukken zijn een algemene aanbeveling. Overleg met uw dealer voor een exacte afstemming met uw machinemodel.",
                    "number of results": "resultaten voor uw graafmachine",
                    "results": "Resultaat",
                    "buckets": "Bakken",
                    "choise": "Variant",
                    "choises": "Varianten",
                    "weight": "Gewicht",
                    "bucket": {
                        "bucket": "Bak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Graafbak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume",
                        "toothtype": "Type tand"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Sleuvengraafbak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Puinbak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Egalisatiebak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Wilt u een grijpermodule toevoegen?",
                        "continuewithout": "Verder gaan zonder grijpermodule",
                        "grapplemodule": "Grijpermodule",
                        "weight": "Gewicht",
                        "liftingcapacitymax": "Hefvermogen, max."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Spoorweggrijper",
                        "weight": "Gewicht",
                        "liftingcapacitymax": "Hefvermogen, max."
                    },
                    "grapple": {
                        "grapple": "Grijpers",
                        "grappleforcemax": "Grijpkracht, max.",
                        "grapplewidthmax": "Grijperbreedte, max."
                    },
                    "grappletypes": {
                        "multigrapple": "multigrijper",
                        "stonegrapple":"stenengrijper",
                        "sortinggrapple": "sorteergrijper"
                    },
                    "compactor": {
                        "compactor": "Trilplaten",
                        "weight": "Gewicht",
                        "vibrationforce": "Vibratiekracht"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Nivelleringsbalk",
                        "weight": "Gewicht",
                        "width": "Breedte"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Gewicht",
                        "toothradius": "Tandradius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asfaltsnijder",
                        "weight": "Gewicht",
                        "cutdepth": "Mesdiepte"
                    },
                    "toolmount": {
                        "toolmount": "Snelwissel"
                    }
                },
                "optionalstep": {
                    "yourmachine": "aan uw machinemodel",
                    "yourmachineweight": "uw machinegewicht",
                    "optionalstep": "Opties",
                    "introweight": "Wilt u meer passende producten toevoegen ",
                    "intromachine": "Wilt u meer passende producten toevoegen ",
                    "introaftervalue":"Bekijk onze selectie of ga verder met de volgende stap."
                },
                "yourchoises": {
                    "yourchoises": "Uw keuzes",
                    "yourchoisesintro": "Vul uw gegevens in en bekijk uw keuzes. Wanneer u klaar bent, wordt uw samenvatting verzonden naar een vertegenwoordiger van Rototilt die binnenkort contact met u opneemt.",
                    "yourinformation": "Vul uw gegevens in",
                   "viewretailers": "Zie dealers",
                    "reviewchoises": "Uw keuzes bekijken",
                    "products": "producten"

                },
                "contactusform": {
                    "locationinvalid": "Voer alleen de initialen in",		
                    "firstname": "Voornaam",
                    "firstnamemandatory": "Vul uw voornaam in",
                    "firstnameinvalid": "Voer alleen de initialen in",
                    "lastname": "Achternaam",
                    "lastnamemandatory": "Vul uw achternaam in",
                    "lastnameinvalid": "Voer alleen de initialen in",
                    "email": "E-mailadres",
                    "emailmandatory": "Voer uw e-mailadres in",
                    "emailinvalid": "Ongeldig e-mailadres",
                    "phone": "Telefoonnummer",
                    "phonemandatory": "Vul uw telefoonnummer in",
                    "phoneinvalid": "Ongeldig telefoonnummer",
                    "city": "Plaats",
                    "zip": "Postcode",
                    "country:": "Land",
                    "countrymandatory:": "Vul uw land in",
                    "message": "Hier kunt u een vraag of mededeling plaatsen (optioneel)",
                    "contactus": "Verzenden", 
                    "checkboxintegrity": "Ik ga ermee akkoord dat Rototilt Group AB mijn persoonsgegevens mag verwerken, in overeenstemming met haar ",
                    "checkboxintegritylink": "privacybeleid (gegevensbeschermingsbeleid).",	
                    "checkboxnews": "Ik wil graag nieuws en aanbiedingen van Rototilt ontvangen.",
                    "share": {
                        "share": "Delen",
                        "close": "Sluiten",
                        "copylink": "Link kopiëren",
                        "info": "Gebruik deze link om uw configuratie te delen of op te slaan"
                    }
                },
                "endpage": {
                    "welldone": "Goed gedaan!",
                    "gotoweb": "Klik hier om naar onze website te gaan",	
                    "endpageinfo": "Een vertegenwoordiger van Rototilt neemt binnenkort contact met u op. Er is een bevestiging met een link met uw keuzes naar uw e-mail verzonden."
                },
                "disclamer": {
                    "disclamertext": "We behouden ons het recht voor van typografische of typefouten en eventuele andere fouten en behouden ons het recht voor om specificaties zonder kennisgeving te wijzigen. Er kunnen variaties in productassortimenten en productstandaarden tussen verschillende markten zijn. Voor meer informatie over actuele productspecificaties, lokale aanpassingen en speciale uitrusting kunt u contact opnemen met uw dichtstbijzijnde Rototilt-dealer."
                },
                "url": {
                   "productguide": "de productgids",
                   "machinetonnage": "machinegewicht",
                   "product": "product",
                   "optional": "opties",
                   "contactus": "neem contact met ons op",
                   "thankyou": "bedankt" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine en gewicht",
                    "productstep": "Producten",
                    "otheroptionsstep": "Opties",
                    "contactusstep": "Uw keuzes"
                },
                "cart": {
                    "yourproducts": "Uw producten"
                },
                "footer": {
                    "previous": "Vorige",
                    "next": "Volgende"
                },
                "topbar": {
                    "products": "Producten"
                },
                "popup": {
                    "areyousure": "Als u teruggaat, worden uw keuzes gewist. Weet u zeker dat u terug wilt gaan?",
                    "important": "Belangrijk!",
                    "cancel": "Annuleren",
                    "clearchoises": "Wis mijn keuzes",
                    "stay": "Blijf op de pagina"
                },
                "thankyoumail": {
                    "subject": "Onderwerp: Fijn dat u contact met ons heeft opgenomen",
                    "hello": "Hallo",
                    "intro": "We hebben uw keuzes uit de productgids van Rototilt ontvangen. Een vertegenwoordiger van Rototilt neemt binnenkort contact met u op. U kunt op onderstaande link klikken om een overzicht van uw keuzes te zien.",
                    "summary": "Uw opstelling",
                    "signature": "Met hartelijke groeten",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Lees meer op www.rototilt.com"
                }
            },
            "nl-BE": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " ton",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "stuks"
                },
                "seo": {
                    "startpage": {
                        "titel": "Rototilt Productgids - Wat past bij uw graafmachine",
                        "text": "Welkom bij de productgids van Rototilt. Hier kunt u op eenvoudige wijze producten van Rototilt vinden die passen bij uw specifieke graafmachinemodel.",
                        "keywords": "rototilt productgids, rototilt productconfigurator",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Kies uw markt",
                        "change": "wijzig",
                        "sv-SE": "Zweden",
                        "da-DK": "Denemarken",
                        "en-GB": "Verenigd Koninkrijk",
                        "fi-FI": "Finland",
                        "fr-FR": "Frankrijk",
                        "de-DE": "Duitsland",
                        "nb-NO": "Noorwegen",
                        "en-US": "VS",
                        "en-CA": "Canada (Engels)",   
                        "en-NZ": "Nieuw-Zeeland",	
                        "fr-CA": "Canada (Frans)",
                        "en": "Wereldwijd",
                        "pl-PL": "Polen",
                        "nl-NL": "Nederland",
                        "es-ES": "Spanje",
                        "en-AU": "Australië",
                        "ja-JP": "Japan",
                        "ko-KR": "Zuid-Korea"
                    },
                    "markettexts": {
                        "marketheader": "Welkom bij de productgids van Rototilt",
                        "marketintro": "Hier kunt u Rototilt producten eenvoudig koppelen aan een specifiek graafmachinemodel. Door uw machinemodel of machinegewicht op te geven, kunt u kiezen uit aanbevolen producten en uw eigen draaikantelstuksysteem bouwen. Begin met het kiezen van uw markt.",
                        "chosemarketheader": "Kies uw markt",
                        "choosebetween": "Kies uit",
                        "markets": "Markten",
                        "marketnotfound": "Als u uw markt niet kunt vinden, selecteert u \"Wereldwijd\".",
                        "searchmarket": "Zoek in onze markten",
                        "choosemarket": "Kies uw markt"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Machine en gewicht",
                        "machinetonnageintro": "Voor de best mogelijke productaanbevelingen voor uw machine kiest u het graafmachinemodel of voert u het gewicht van de machine in.",
                        "findmachine": "Vindt uw machine",
                        "findmachinetext1":"Selecteer het machinemodel om productaanbevelingen voor uw graafmachine te krijgen.",
                        "findmachinetext2":"Selecteer het machinemodel om productaanbevelingen voor uw graafmachine te krijgen. Als u uw model niet kunt vinden, vult u het gewicht van de machine in.",
                        "searchplaceholder": "Zoek merk en model",
                        "switchtotonnage": "Gebruik machinegewicht",
                        "picktonnage": "Voer het gewicht van uw machine in",
                        "picktonnagetext1":"Vul het gewicht in om aanbevelingen te krijgen van producten die geschikt zijn voor uw graafmachine.",
                        "picktonnagetext2":"Vul het gewicht in om aanbevelingen te krijgen van producten die geschikt zijn voor uw graafmachine. U kunt ook het machinemodel gebruiken. ",
                        "choosetonnage": "Voer het gewicht van uw machine in",
                        "tonnagehelpertext":"Dit hoeft niet exact te zijn, een benadering is voldoende.",
                        "switchtomachine":"Gebruik machinemodel",
                        "loadingMessage": "Wij zijn op zoek naar uw machine...",
                        "noOptionsMessage": "Bezig met zoeken naar uw machine..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Producten",
                        "productintro": "In welke producten bent u geïnteresseerd? Kies om te beginnen een productcategorie. U hebt de mogelijkheid om meer producten toe te voegen en uw keuzes later te wijzigen.",
                        "chooseproductcategory": "Kies productcategorie"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Draaikantelstuk",
                    "tiltrotators": "Draaikantelstukken",
                    "choosetiltrotator": "Kies draaikantelstuk",
                    "recomended": "Aanbevolen",
                    "breakforcemax": "Opbreekkracht, max.",
                    "bucketwidthmax": "Breedte bak, max"
                },
                "machinefixings": {
                    "weight": "Gewicht",
                    "recommended": "aanbevolen",
                    "readmore": "Lees meer",
                    "machinefixing": "Machinesnelwissel",
                    "choosemachinefixing": "Kies machinesnelwissel",
                    "attachment":"Ophanging",
                    "chooseattachment": "Kies ophanging",
                    "continuewithout": "Doorgaan zonder machinesnelwissel",
                    "choosedirectmount": "Kies directe bevestiging",
                    "choosesfixing": "Kies S-snelwissel",
                    "chooseqcfixing": "Kies QuickChange™ snelwissel",
                    "nomachinefixing": "Vaste ophanging of CW snelwissel",
                    "sfixing": {
                    "sfixing": "S-snelwissel",
                    "weightfrom": "Gewicht, vanaf",
                    "maxallowedloadlifthook": "Toegestane maximale belasting hijshaak",
                    "infotext": "Een krachtige en robuuste standaardkoppeling met een compact ontwerp. Maakt het mogelijk om het draaikantelstuk te ontkoppelen voor zwaardere werkzaamheden, zoals bij het gebruik van hydraulische breekhamers. Deze koppelingen zijn gebaseerd op de gemeenschappelijke S-standaard."
                    },
                    "qcfixing": {
                        "qcfixing": "QuickChange™ snelwissel",
                        "weightfrom": "Gewicht, vanaf",
                        "maxallowedloadlifthook": "Toegestane maximale belasting hijshaak",
                        "numberofcouplers":"Aantal koppelingen, max",
                        "infotext": "QuickChange™ is het volledig automatische snelwisselsysteem van Rototilt. Het is een slimme uitbreiding waarmee hydraulische uitrustingsstukken automatisch gewisseld kunnen worden zonder dat u de cabine van de graafmachine hoeft te verlaten."
                    },
                    "directmount": {
                        "directmount": "Directe bevestiging",
                        "infotext": "Een directe koppeling betekent dat het draaikantelstuk direct aan de graafmachine wordt bevestigd. Het is de lichtste en meest compacte oplossing die geschikt is voor toepassingen waarbij het draaikantelstuk nooit afgekoppeld hoeft te worden."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Selecteer snelwissel",
                        "toolattachment": "Snelwissel"
                    }
                },
                "tools": {
                    "readmore": "Lees meer",
                    "categories": "categorieën",
                    "tools": "Uitrustingsstukken",
                    "choosetools": "Kies uitrustingsstuk",
                    "ourtools": "Onze uitrustingsstukken",
                    "disclamertools": "De onderstaande uitrustingsstukken zijn een algemene aanbeveling. Overleg met uw dealer voor een exacte afstemming met uw machinemodel.",
                    "number of results": "resultaten voor uw graafmachine",
                    "results": "Resultaat",
                    "buckets": "Bakken",
                    "choise": "Variant",
                    "choises": "Varianten",
                    "weight": "Gewicht",
                    "bucket": {
                        "bucket": "Bak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Graafbak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume",
                        "toothtype": "Type tand"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Sleuvengraafbak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Puinbak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Egalisatiebak",
                        "articlenumber": "Artikelnummer",
                        "width": "Breedte",
                        "volume": "Volume"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Wilt u een grijpermodule toevoegen?",
                        "continuewithout": "Verder gaan zonder grijpermodule",
                        "grapplemodule": "Grijpermodule",
                        "weight": "Gewicht",
                        "liftingcapacitymax": "Hefvermogen, max."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Spoorweggrijper",
                        "weight": "Gewicht",
                        "liftingcapacitymax": "Hefvermogen, max."
                    },
                    "grapple": {
                        "grapple": "Grijpers",
                        "grappleforcemax": "Grijpkracht, max.",
                        "grapplewidthmax": "Grijperbreedte, max."
                    },
                    "grappletypes": {
                        "multigrapple": "multigrijper",
                        "stonegrapple":"stenengrijper",
                        "sortinggrapple": "sorteergrijper"
                    },
                    "compactor": {
                        "compactor": "Trilplaten",
                        "weight": "Gewicht",
                        "vibrationforce": "Vibratiekracht"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Nivelleringsbalk",
                        "weight": "Gewicht",
                        "width": "Breedte"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Gewicht",
                        "toothradius": "Tandradius"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Asfaltsnijder",
                        "weight": "Gewicht",
                        "cutdepth": "Mesdiepte"
                    },
                    "toolmount": {
                        "toolmount": "Snelwissel"
                    }
                },
                "optionalstep": {
                    "yourmachine": "aan uw machinemodel",
                    "yourmachineweight": "uw machinegewicht",
                    "optionalstep": "Opties",
                    "introweight": "Wilt u meer passende producten toevoegen ",
                    "intromachine": "Wilt u meer passende producten toevoegen ",
                    "introaftervalue":"Bekijk onze selectie of ga verder met de volgende stap."
                },
                "yourchoises": {
                    "yourchoises": "Uw keuzes",
                    "yourchoisesintro": "Vul uw gegevens in en bekijk uw keuzes. Wanneer u klaar bent, wordt uw samenvatting verzonden naar een vertegenwoordiger van Rototilt die binnenkort contact met u opneemt.",
                    "yourinformation": "Vul uw gegevens in",
                   "viewretailers": "Zie dealers",
                    "reviewchoises": "Uw keuzes bekijken",
                    "products": "producten"

                },
                "contactusform": {
                    "locationinvalid": "Voer alleen de initialen in",		
                    "firstname": "Voornaam",
                    "firstnamemandatory": "Vul uw voornaam in",
                    "firstnameinvalid": "Voer alleen de initialen in",
                    "lastname": "Achternaam",
                    "lastnamemandatory": "Vul uw achternaam in",
                    "lastnameinvalid": "Voer alleen de initialen in",
                    "email": "E-mailadres",
                    "emailmandatory": "Voer uw e-mailadres in",
                    "emailinvalid": "Ongeldig e-mailadres",
                    "phone": "Telefoonnummer",
                    "phonemandatory": "Vul uw telefoonnummer in",
                    "phoneinvalid": "Ongeldig telefoonnummer",
                    "city": "Plaats",
                    "zip": "Postcode",
                    "country:": "Land",
                    "countrymandatory:": "Vul uw land in",
                    "message": "Hier kunt u een vraag of mededeling plaatsen (optioneel)",
                    "contactus": "Verzenden", 
                    "checkboxintegrity": "Ik ga ermee akkoord dat Rototilt Group AB mijn persoonsgegevens mag verwerken, in overeenstemming met haar ",
                    "checkboxintegritylink": "privacybeleid (gegevensbeschermingsbeleid).",	
                    "checkboxnews": "Ik wil graag nieuws en aanbiedingen van Rototilt ontvangen.",
                    "share": {
                        "share": "Delen",
                        "close": "Sluiten",
                        "copylink": "Link kopiëren",
                        "info": "Gebruik deze link om uw configuratie te delen of op te slaan"
                    }
                },
                "endpage": {
                    "welldone": "Goed gedaan!",
                    "gotoweb": "Klik hier om naar onze website te gaan",	
                    "endpageinfo": "Een vertegenwoordiger van Rototilt neemt binnenkort contact met u op. Er is een bevestiging met een link met uw keuzes naar uw e-mail verzonden."
                },
                "disclamer": {
                    "disclamertext": "We behouden ons het recht voor van typografische of typefouten en eventuele andere fouten en behouden ons het recht voor om specificaties zonder kennisgeving te wijzigen. Er kunnen variaties in productassortimenten en productstandaarden tussen verschillende markten zijn. Voor meer informatie over actuele productspecificaties, lokale aanpassingen en speciale uitrusting kunt u contact opnemen met uw dichtstbijzijnde Rototilt-dealer."
                },
                "url": {
                   "productguide": "de productgids",
                   "machinetonnage": "machinegewicht",
                   "product": "product",
                   "optional": "opties",
                   "contactus": "neem contact met ons op",
                   "thankyou": "bedankt" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Machine en gewicht",
                    "productstep": "Producten",
                    "otheroptionsstep": "Opties",
                    "contactusstep": "Uw keuzes"
                },
                "cart": {
                    "yourproducts": "Uw producten"
                },
                "footer": {
                    "previous": "Vorige",
                    "next": "Volgende"
                },
                "topbar": {
                    "products": "Producten"
                },
                "popup": {
                    "areyousure": "Als u teruggaat, worden uw keuzes gewist. Weet u zeker dat u terug wilt gaan?",
                    "important": "Belangrijk!",
                    "cancel": "Annuleren",
                    "clearchoises": "Wis mijn keuzes",
                    "stay": "Blijf op de pagina"
                },
                "thankyoumail": {
                    "subject": "Onderwerp: Fijn dat u contact met ons heeft opgenomen",
                    "hello": "Hallo",
                    "intro": "We hebben uw keuzes uit de productgids van Rototilt ontvangen. Een vertegenwoordiger van Rototilt neemt binnenkort contact met u op. U kunt op onderstaande link klikken om een overzicht van uw keuzes te zien.",
                    "summary": "Uw opstelling",
                    "signature": "Met hartelijke groeten",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Lees meer op www.rototilt.com"
                }
            },
            "pl-PL": {
                "translation": {
                },
                "metrics": {
                    "tonnes": " tony",
                    "kg": " kg",
                    "inches": "in",
                    "pounds": "lb",
                    "liter": "l",
                    "kilonewton": "kN",
                    "lbf": "lbf",
                    "pieces": "szt."
                },
                "seo": {
                    "startpage": {
                        "titel": "Przewodnik po produktach Rototilt – Dopasuj do swojej koparki",
                        "text": "Witamy w przewodniku po produktach Rototilt. Tutaj możesz łatwo znaleźć i dopasować produkty Rototilt do określonego modelu koparki.",
                        "keywords": "przewodnik po produktach rototilt, konfigurator produktów rototilt",
                    }
                },
                "marketstep": {
                    "markets": {
                        "market": "Wybierz rynek",
                        "change": "zmień",
                        "sv-SE": "Szwecja",
                        "da-DK": "Dania",
                        "en-GB": "Wielka Brytania",
                        "fi-FI": "Finlandia",
                        "fr-FR": "Francja",
                        "de-DE": "Niemcy",
                        "nb-NO": "Norwegia",
                        "en-US": "USA",
                        "en-CA": "Kanada (angielski)",   
                        "en-NZ": "Nowa Zelandia",	
                        "fr-CA": "Kanada (francuski)",
                        "en": "Cały świat",
                        "pl-PL": "Polska",
                        "nl-NL": "Holandia",
                        "es-ES": "Hiszpania",
                        "en-AU": "Australia",
                        "ja-JP": "Japonia",
                        "ko-KR": "Korea Południowa"
                    },
                    "markettexts": {
                        "marketheader": "Witamy w przewodniku po produktach Rototilt",
                        "marketintro": "Korzystanie z naszego przewodnika po produktach pomoże Ci dopasować produkty Rototilt do konkretnego modelu koparki. Określając model maszyny lub jej masę, możesz wybrać spośród zalecanych produktów i zbudować swój własny system tiltrotatora. Zacznij od wyboru rynku.",
                        "chosemarketheader": "Wybierz swój rynek",
                        "choosebetween": "Wybierz jedną z opcji",
                        "markets": "Rynki",
                        "marketnotfound": "Jeśli nie możesz znaleźć swojego rynku, wybierz opcję „Cały świat”.",
                        "searchmarket": "Szukaj wśród naszych rynków",
                        "choosemarket": "Wybierz rynek"
                    }
                },
                "machinetonnagestep": {
                    "machinetonnagetexts": {
                        "machinetonnageheader": "Maszyna i masa",
                        "machinetonnageintro": "Aby uzyskać najlepsze możliwe rekomendacje produktów dla swojej maszyny, wybierz model koparki lub określ masę swojej maszyny.",
                        "findmachine": "Znajdź swoją maszynę",
                        "findmachinetext1":"Wybierz model maszyny, aby uzyskać rekomendacje produktów dla swojej koparki.",
                        "findmachinetext2":"Wybierz model maszyny, aby uzyskać rekomendacje produktów dla swojej koparki. Jeśli nie możesz znaleźć swojego modelu, przełącz wyszukiwanie na masę maszyny.",
                        "searchplaceholder": "Wyszukaj markę i model",
                        "switchtotonnage": "Przełącz na masę maszyny",
                        "picktonnage": "Wprowadź masę maszyny",
                        "picktonnagetext1":"Wprowadź masę, aby uzyskać rekomendacje produktów dopasowane do Twojej koparki.",
                        "picktonnagetext2":"Wprowadź masę, aby uzyskać rekomendacje produktów dopasowane do Twojej koparki. Możesz też przełączyć wyszukiwanie na model maszyny. ",
                        "choosetonnage": "Wprowadź masę maszyny",
                        "tonnagehelpertext":"Masę możesz podać w przybliżeniu.",
                        "switchtomachine":"Przełącz na model maszyny",
                        "loadingMessage": "Szukamy Twojej maszyny...",
                        "noOptionsMessage": "Wyszukaj swoją maszynę..."
                    }                
                },
                "productstep": {
                    "producttexts": {
                        "productheading": "Produkty",
                        "productintro": "Jakie produkty Cię interesują? Na początek wybierz kategorię produktu. Później będziesz mieć możliwość dodania kolejnych produktów i zmiany wybranych opcji.",
                        "chooseproductcategory": "Wybierz kategorię produktów"
                    }
                },
                "tiltrotator": {
                    "tiltrotator": "Tiltrotator",
                    "tiltrotators": "Tiltrotatory",
                    "choosetiltrotator": "Wybierz tiltrotator",
                    "recomended": "Polecane",
                    "breakforcemax": "Siła zrywająca, maks.",
                    "bucketwidthmax": "Szerokość czerpaka, maks."
                },
                "machinefixings": {
                    "weight": "Masa",
                    "recommended": "polecane produkty",
                    "readmore": "Czytaj więcej",
                    "machinefixing": "Złącze maszyny",
                    "choosemachinefixing": "Wybierz złącze maszyny",
                    "attachment":"Mocowanie ramy",
                    "chooseattachment": "Wybierz mocowanie ramy",
                    "continuewithout": "Kontynuuj bez złącza maszyny",
                    "choosedirectmount": "Wybierz mocowanie bezpośrednie",
                    "choosesfixing": "Wybierz łącznik typu S",
                    "chooseqcfixing": "Wybierz łącznik QuickChange™",
                    "nomachinefixing": "Kontynuuj bez wyboru złącza maszyny",
                    "sfixing": {
                    "sfixing": "Łącznik typu S",
                    "weightfrom": "Masa, min.",
                    "maxallowedloadlifthook": "Dopuszczalne obciążenie maks., hak nośny",
                    "infotext": "Mocny i solidny standardowy łącznik o kompaktowej konstrukcji. Umożliwia odłączenie tiltrotatora podczas cięższych prac, na przykład przy użyciu młotów hydraulicznych. Łączniki te bazują na powszechnym standardzie S."
                    },
                    "qcfixing": {
                        "qcfixing": "Łącznik QuickChange™",
                        "weightfrom": "Masa, min.",
                        "maxallowedloadlifthook": "Dopuszczalne obciążenie maks., hak nośny",
                        "numberofcouplers":"Liczba przyłączy, maks.",
                        "infotext": "QuickChange™ to w pełni automatyczny system szybkozłącza marki Rototilt. To inteligentny sprzęt dodatkowy, który umożliwia automatyczną wymianę hydraulicznych narzędzi roboczych bez konieczności wychodzenia z kabiny koparki."
                    },
                    "directmount": {
                        "directmount": "Mocowanie bezpośrednie",
                        "infotext": "Mocowanie bezpośrednie oznacza, że tiltrotator zostaje przymocowany bezpośrednio do koparki. Jest to najlżejsze i najbardziej kompaktowe rozwiązanie, które sprawdza się w zastosowaniach, w których nie ma potrzeby odłączania tiltrotatora."
                    },
                    "toolattachment": {
                        "choosetoolattachment": "Wybierz szybkozłącze",
                        "toolattachment": "Szybkozłącze"
                    }
                },
                "tools": {
                    "readmore": "Czytaj więcej",
                    "categories": "kategorie",
                    "tools": "Narzędzia robocze",
                    "choosetools": "Wybierz narzędzie robocze",
                    "ourtools": "Nasze narzędzia robocze",
                    "disclamertools": "Poniższe narzędzia robocze są polecane ogólnie. Skonsultuj się ze sprzedawcą w celu precyzyjnego dostosowania do modelu swojej maszyny.",
                    "number of results": "Wyniki dla Twojej koparki",
                    "results": "Wyniki",
                    "buckets": "Czerpaki",
                    "choise": "Wariant",
                    "choises": "Warianty",
                    "weight": "Masa",
                    "bucket": {
                        "bucket": "Czerpak",
                        "articlenumber": "Numer artykułu",
                        "width": "Szerokość",
                        "volume": "Objętość"
                    },
                    "excavationbucket": {
                        "excavationbucket": "Czerpak do wykopów",
                        "articlenumber": "Numer artykułu",
                        "width": "Szerokość",
                        "volume": "Objętość",
                        "toothtype": "Typ zębów"
                    },
                    "trenchingbucket": {
                        "trenchingbucket": "Czerpak wąskoprzestrzenny",
                        "articlenumber": "Numer artykułu",
                        "width": "Szerokość",
                        "volume": "Objętość"
                    },
                    "sortingbucket": {
                        "sortingbucket": "Czerpak do sortowania",
                        "articlenumber": "Numer artykułu",
                        "width": "Szerokość",
                        "volume": "Objętość"
                    },
                    "gradingbucket": {
                        "gradingbucket": "Czerpak uniwersalny",
                        "articlenumber": "Numer artykułu",
                        "width": "Szerokość",
                        "volume": "Objętość"
                    },
                    "grapplemodule": {
                        "doyouwantgrapple": "Czy chcesz dodać moduł chwytaka?",
                        "continuewithout": "Kontynuuj bez modułu chwytaka",
                        "grapplemodule": "Moduł chwytaka",
                        "weight": "Masa",
                        "liftingcapacitymax": "Udźwig, maks."
                    },
                    "railroadgrapple": {
                        "railroadgrapple": "Chwytak do robót kolejowych",
                        "weight": "Masa",
                        "liftingcapacitymax": "Udźwig, maks."
                    },
                    "grapple": {
                        "grapple": "Chwytaki",
                        "grappleforcemax": "Siła chwytaka, maks.",
                        "grapplewidthmax": "Szerokość chwytaka, maks."
                    },
                    "grappletypes": {
                        "multigrapple": "chwytak uniwersalny",
                        "stonegrapple":"chwytak do kamienia",
                        "sortinggrapple": "chwytak do sortowania"
                    },
                    "compactor": {
                        "compactor": "Zagęszczarka",
                        "weight": "Masa",
                        "vibrationforce": "Siła wibracji"
                    },
                    "gradingbeam": {
                        "gradingbeam": "Belka do profilowania powierzchni",
                        "weight": "Masa",
                        "width": "Szerokość"
                    },
                    "ripper": {
                        "ripper": "Ripper",
                        "weight": "Masa",
                        "toothradius": "Promień zęba"
                    },
                    "asphaltcutter": {
                        "asphaltcutter": "Przecinarka do asfaltu",
                        "weight": "Masa",
                        "cutdepth": "Głębokość cięcia"
                    },
                    "toolmount": {
                        "toolmount": "Rama do mocowania narzędzi"
                    }
                },
                "optionalstep": {
                    "yourmachine": "model Twojej maszyny",
                    "yourmachineweight": "masa Twojej maszyny",
                    "optionalstep": "Opcja",
                    "introweight": "Czy chcesz dodać więcej dopasowanych produktów ",
                    "intromachine": "Czy chcesz dodać więcej dopasowanych produktów ",
                    "introaftervalue":"Poznaj naszą ofertę lub przejdź do następnego kroku."
                },
                "yourchoises": {
                    "yourchoises": "Wybrane produkty",
                    "yourchoisesintro": "Uzupełnij dane i przejrzyj wybrane produkty. Po zakończeniu do przedstawiciela firmy Rototilt zostanie wysłane podsumowanie. W niedługim czasie skontaktuje się on z Tobą.",
                    "yourinformation": "Uzupełnij swoje dane",
                   "viewretailers": "Zobacz sprzedawców",
                    "reviewchoises": "Przejrzyj wybrane produkty",
                    "products": "produkty"

                },
                "contactusform": {
                    "firstname": "Imię",
                    "locationinvalid": "Wpisać można tylko litery",		
                    "firstnamemandatory": "Wpisz swoje imię",
                    "firstnameinvalid": "Wpisać można tylko litery",
                    "lastname": "Nazwisko",
                    "lastnamemandatory": "Wpisz swoje nazwisko",
                    "lastnameinvalid": "Wpisać można tylko litery",
                    "email": "Adres e-mail",
                    "emailmandatory": "Wpisz swój adres e-mail",
                    "emailinvalid": "Nieprawidłowy adres e-mail",
                    "phone": "Numer telefonu",
                    "phonemandatory": "Wpisz swój numer telefonu",
                    "phoneinvalid": "Nieprawidłowy numer telefonu",
                    "city": "Miejscowość",
                    "zip": "Kod pocztowy",
                    "country:": "Kraj",
                    "countrymandatory:": "Wpisz swój kraj",
                    "message": "Dodaj wiadomość (opcjonalnie)",
                    "contactus": "Wyślij", 
                    "checkboxintegrity": "Wyrażam zgodę na przetwarzanie moich danych osobowych przez Rototilt Group AB zgodnie ",
                    "checkboxintegritylink": "z jej polityką w zakresie danych osobowych.",	
                    "checkboxnews": "Chcę otrzymywać wiadomości i oferty od firmy Rototilt.",
                    "share": {
                        "share": "Udostępnij",
                        "close": "Zamknij",
                        "copylink": "Kopiuj link",
                        "info": "Użyj tego linku, aby udostępnić lub zapisać swoją konfigurację"
                    }
                },
                "endpage": {
                    "welldone": "Dobra robota!",
                    "gotoweb": "Kliknij tutaj, aby odwiedzić naszą stronę internetową",	
                    "endpageinfo": "Przedstawiciel firmy Rototilt wkrótce się z Tobą skontaktuje. Na Twój adres e-mail zostało wysłane potwierdzenie z linkiem do zestawienia wybranych produktów."
                },
                "disclamer": {
                    "disclamertext": "Zastrzegamy możliwość występowania błędów typograficznych lub ortograficznych oraz wszelkich innych możliwych błędów, a ponadto zastrzegamy sobie prawo do zmiany specyfikacji bez uprzedniego powiadomienia. W zależności od rynku mogą występować różnice w asortymencie produktów i standardach wyposażenia. Aby uzyskać więcej informacji na temat aktualnych specyfikacji produktów, lokalnych adaptacji i sprzętu specjalnego przeznaczenia, skontaktuj się z najbliższym sprzedawcą produktów marki Rototilt."
                },
                "url": {
                   "productguide": "przewodnik po produktach",
                   "machinetonnage": "masa maszyny",
                   "product": "produkt",
                   "optional": "opcja",
                   "contactus": "kontakt",
                   "thankyou": "dziękujemy" 
                },
                "wizard": {
                    "marketstep": "Start",
                    "machinetonnagestep": "Maszyna i masa",
                    "productstep": "Produkty",
                    "otheroptionsstep": "Opcja",
                    "contactusstep": "Wybrane produkty"
                },
                "cart": {
                    "yourproducts": "Twoje produkty"
                },
                "footer": {
                    "previous": "Wstecz",
                    "next": "Dalej"
                },
                "topbar": {
                    "products": "Produkty"
                },
                "popup": {
                    "areyousure": "Jeśli dokonasz zmian, Twoje wybory zostaną wyczyszczone. Czy na pewno chcesz kontynuować?",
                    "important": "Ważne!",
                    "cancel": "Anuluj",
                    "clearchoises": "Wyczyść wybrane produkty",
                    "stay": "Pozostań na stronie"
                },
                "thankyoumail": {
                    "subject": "Temat: Dziękujemy za skontaktowanie się z nami.",
                    "hello": "Witaj",
                    "intro": "Otrzymaliśmy listę wybranych przez Ciebie produktów z przewodnika po produktach marki Rototilt. Wkrótce skontaktuje się z Tobą przedstawiciel firmy Rototilt. Póki co możesz kliknąć poniższy link, aby zobaczyć podsumowanie swoich wyborów.",
                    "summary": "Twoje podsumowanie",
                    "signature": "Z pozdrowieniami",
                    "rototilt": "Rototilt Group AB",
                    "readmore": "Czytaj więcej na www.rototilt.com"
                }
            }
        },
        lng: "en",
        fallbackLng: "en",
        debug: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;